// Generated by Avo VERSION 122.286.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true;
        } catch (e) {
          return false;
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self,
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj);
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]',
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name');
    }
    return name.toLowerCase();
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value;
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value };
      },
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name));
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items);
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items);
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items);
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('');
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0);
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer;
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode);
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse);
    };

    // @ts-ignore
    return this;
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read');
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests');
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit });
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form;
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers;
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url,
    });
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response;
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code');
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } });
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'));
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || ''),
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = 'prod',
  Dev = 'dev',
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (groupType: string, groupId: string, groupProperties: Record<string, any>) => void;
  addCurrentUserToGroup?: (groupType: string, groupId: string, groupProperties: Record<string, any>) => void;
  logEventWithGroups?: (eventName: string, eventProperties: any, groupTypesToGroupIds: Record<string, string>) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[];
  shape?: any;
  shapeUserProps?: any;
  actualType?: string;
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = '0LWj9b3ds5YKGpPDfwZc';
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;

// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target: any, _varArgs: any) {
      // .length of function is 2
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true,
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = 'BottomRight',
  BottomLeft = 'BottomLeft',
  TopRight = 'TopRight',
  TopLeft = 'TopLeft',
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
};

let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message =
      'Event Sent:' +
      eventName +
      'Event Props:' +
      JSON.stringify(eventProperties) +
      'User Props:' +
      JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return;
    }
    typeof console !== 'undefined' &&
      console.log('[avo] Event Sent:', eventName, 'Event Props:', eventProperties, 'User Props:', userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return;
    }
    typeof console !== 'undefined' && console.log('[avo] ' + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return;
    }
    typeof console !== 'undefined' && console.warn('[avo] ' + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return;
    }
    typeof console !== 'undefined' && console.error('[avo] ' + message, error);
  },
};

function convertPropertiesArrayToMap(propertiesArray: [{ id: string; name: string; value: string }]): {
  string: string | null | undefined;
} {
  let result: { string: string } = {};

  propertiesArray.forEach(value => {
    result[value.name] = value.value;
  });

  return result;
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
};

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message =
        propName +
        ' should be of type object but you provided type ' +
        typeof obj +
        ' with value ' +
        JSON.stringify(obj);
      return [{ tag: 'expectedObjectType', propertyId, message, actualType: typeof obj }];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message =
        propName +
        ' should be of type string but you provided type ' +
        typeof str +
        ' with value ' +
        JSON.stringify(str);
      return [{ tag: 'expectedStringType', propertyId, message, actualType: typeof str }];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName + ' should be of type int but you provided type float with value ' + JSON.stringify(int);
      return [{ tag: 'expectedIntType', propertyId, message, actualType: 'float' }];
    } else if (typeof int !== 'number') {
      let message =
        propName + ' should be of type int but you provided type ' + typeof int + ' with value ' + JSON.stringify(int);
      return [{ tag: 'expectedIntType', propertyId, message, actualType: typeof int }];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName + ' should be of type long but you provided type float with value ' + JSON.stringify(long);
      return [{ tag: 'expectedLongType', propertyId, message, actualType: 'float' }];
    } else if (typeof long !== 'number') {
      let message =
        propName +
        ' should be of type long but you provided type ' +
        typeof long +
        ' with value ' +
        JSON.stringify(long);
      return [{ tag: 'expectedLongType', propertyId, message, actualType: typeof long }];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message =
        propName +
        ' should be of type float but you provided type ' +
        typeof float +
        ' with value ' +
        JSON.stringify(float);
      return [{ tag: 'expectedFloatType', propertyId, message, actualType: typeof float }];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message =
        propName +
        ' should be of type boolean but you provided type ' +
        typeof bool +
        ' with value ' +
        JSON.stringify(bool);
      return [{ tag: 'expectedBoolType', propertyId, message, actualType: typeof bool }];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(propertyId: string, propName: string, max: number, value: number) {
    if (value > max) {
      let message =
        propName + ' has a maximum value of ' + max + ' but you provided the value ' + JSON.stringify(value);
      return [{ tag: 'expectedMax', propertyId, message }];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(propertyId: string, propName: string, min: number, value: number) {
    if (value < min) {
      let message =
        propName + ' has a minimum value of ' + min + ' but you provided the value ' + JSON.stringify(value);
      return [{ tag: 'expectedMin', propertyId, message }];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{ tag: 'expectedList', propertyId, message }];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = 'Additional properties when sending event ' + eventName + ': ' + JSON.stringify(additionalKeys);
      return [{ tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message }];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(
    eventName: string,
    input: string[],
    spec: string[],
  ) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message =
        'Additional user properties when sending event ' + eventName + ': ' + JSON.stringify(additionalKeys);
      return [{ tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message }];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(
  env: AvoEnv,
  eventId: string,
  hash: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return;
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 'JhtXZuNH9mnwY9jHE3uh',
          br: 'master',
          en: env,
          ev: eventId,
          ha: hash,
          sc: 'Qxw4SpNZAmmYOzZQPcag',
          se: new Date().toISOString(),
          so: 'xAxP8rQ_2',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json();
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa;
        })
        .catch(function () {});
    }
  }
};

_avo_invoke_meta = function _avo_invoke_meta(
  env: AvoEnv,
  type: string,
  messages: { tag: string; propertyId: string }[],
  origin: string,
) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') {
    return;
  }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch('https://api.avo.app/i', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ac: 'JhtXZuNH9mnwY9jHE3uh',
          br: 'master',
          en: env,
          ty: type,
          sc: 'Qxw4SpNZAmmYOzZQPcag',
          se: new Date().toISOString(),
          so: 'xAxP8rQ_2',
          va: messages.length === 0,
          me: messages,
          or: origin,
        }),
      })
        .then(function (res: any) {
          return res.json();
        })
        .then(function (data: any) {
          _avo_sampling_rate = data.sa;
        })
        .catch(function () {});
    }
  }
};

let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    let iframe: any = document.getElementById('avo-debugger');
    if (iframe && event && event.data && event.data.type_ === 'avo-debugger-update-style') {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === 'avo-debugger-ready') {
      let message = {
        type_: 'avo-debugger-boot-events',
        schemaId: 'Qxw4SpNZAmmYOzZQPcag',
        href: window.location.href,
        events: _avo_debugger_events_during_boot,
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, 'https://www.avo.app/_debugger');
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(
  eventId: string,
  eventName: string,
  messages: any[],
  eventProperties: any[],
  userProperties: any[],
  groupProperties: any[],
) {
  if (typeof (window as any) === 'undefined') {
    return;
  }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties,
  };

  if (_avo_debugger_ready) {
    let message = { type_: 'avo-debugger-events', events: [event] };
    (document.getElementById('avo-debugger') as any).contentWindow.postMessage(
      message,
      'https://www.avo.app/_debugger',
    );
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
};

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') {
    return;
  }
  window.addEventListener('message', function (event) {
    if (event.origin !== 'https://www.avo.app') {
      return;
    }
    if (event.data.type_ === 'avo-debugger-ready' && position !== null) {
      var message = { type_: 'avo-debugger-position', position: position };
      document.getElementById('avo-debugger').contentWindow.postMessage(message, 'https://www.avo.app/_debugger');
    }
  });
}

export interface WoltSpecialSettings {
  discountAmount: number;
  startDateSelected: number;
  endDateSelected: number;
  firstTimeCustomers: string;
}

export const TargetContentDatePicker = {
  DATE_PICKER_YEAR: 'date_picker_year',
  DATE_PICKER_YESTERDAY: 'date_picker_yesterday',
  DATE_PICKER_LAST_WEEK: 'date_picker_last_week',
  DATE_PICKER_THIS_MONTH: 'date_picker_this_month',
  DATE_PICKER_LAST_28_DAYS: 'date_picker_last_28_days',
} as const;
export type TargetContentDatePickerType = typeof TargetContentDatePicker;
export type TargetContentDatePickerValueType = TargetContentDatePickerType[keyof TargetContentDatePickerType];

export const OptionSelected = {
  FREE_DELIVERY: 'free_delivery',
  BASKET_DISCOUNT: 'basket_discount',
  ADS: 'ads',
  ITEM_DISCOUNT: 'item_discount',
  END_OF_DAY: 'end_of_day',
} as const;
export type OptionSelectedType = typeof OptionSelected;
export type OptionSelectedValueType = OptionSelectedType[keyof OptionSelectedType];

export const TargetContentCampaignsTable = {
  NAME: 'name',
  END: 'end',
  TYPE: 'type',
  VENUES: 'venues',
  STATUS: 'status',
  CONTEXTUAL_MENU: 'contextual_menu',
  EDIT: 'edit',
  CANCEL: 'cancel',
  DELETE: 'delete',
  START: 'start',
} as const;
export type TargetContentCampaignsTableType = typeof TargetContentCampaignsTable;
export type TargetContentCampaignsTableValueType =
  TargetContentCampaignsTableType[keyof TargetContentCampaignsTableType];

export const TargetContentNewCampaigns = {
  TOOLTIP_HELP_DISMISSED: 'tooltip_help_dismissed',
  CAMPAIGN_NAME: 'campaign_name',
  CHANGE_RULES: 'change_rules',
  SELECTION_MINIMUM_RANGE: 'selection_minimum_range',
  SELECTION_MEDIUM_RANGE: 'selection_medium_range',
  CHANGE_SCHEDULING: 'change_scheduling',
  CREATE_CAMPAIGN: 'create_campaign',
  CHANGE_DISCOUNT: 'change_discount',
  CHANGE_UPPER_LIMIT: 'change_upper_limit',
  BASKET_DISCOUNT_TYPE: 'basket_discount_type',
} as const;
export type TargetContentNewCampaignsType = typeof TargetContentNewCampaigns;
export type TargetContentNewCampaignsValueType = TargetContentNewCampaignsType[keyof TargetContentNewCampaignsType];

export const CampaignType = {
  FREE_DELIVERY: 'free_delivery',
  ADS: 'ads',
  BASKET_DISCOUNT: 'basket_discount',
  ITEM_DISCOUNT: 'item_discount',
  END_OF_DAY: 'end_of_day',
} as const;
export type CampaignTypeType = typeof CampaignType;
export type CampaignTypeValueType = CampaignTypeType[keyof CampaignTypeType];

export const TargetContentCampaignEdit = {
  CHANGE_RULES: 'change_rules',
  CHANGE_SPEND: 'change_spend',
  CHANGE_SCHEDULING: 'change_scheduling',
  CHANGE_DISCOUNT: 'change_discount',
  CHANGE_UPPER_LIMIT: 'change_upper_limit',
  BASKET_DISCOUNT_TYPE: 'basket_discount_type',
} as const;
export type TargetContentCampaignEditType = typeof TargetContentCampaignEdit;
export type TargetContentCampaignEditValueType = TargetContentCampaignEditType[keyof TargetContentCampaignEditType];

export const DeliveryType = {
  SELF_DELIVERY: 'self_delivery',
  WOLT_DELIVERY: 'wolt_delivery',
} as const;
export type DeliveryTypeType = typeof DeliveryType;
export type DeliveryTypeValueType = DeliveryTypeType[keyof DeliveryTypeType];

export const OverlayType = {
  TOOLTIP: 'tooltip',
  BANNER: 'banner',
} as const;
export type OverlayTypeType = typeof OverlayType;
export type OverlayTypeValueType = OverlayTypeType[keyof OverlayTypeType];

export const Source = {
  VENUE: 'venue',
  RATING: 'rating',
  DELIVERY_TYPE_MODAL: 'delivery_type_modal',
  FRONT_PAGE: 'front_page',
  SEARCH: 'search',
  LIVE_PURCHASES: 'live_purchases',
  RESTAURANT_DETAILS: 'restaurant_details',
} as const;
export type SourceType = typeof Source;
export type SourceValueType = SourceType[keyof SourceType];

export const View = {
  PURCHASES: 'purchases',
  BUSINESS_INSIGHTS: 'business_insights',
  MENU_EDITOR: 'menu_editor',
  LOGIN_PAGE: 'login_page',
  ONBOARDING_LANDING_PAGE: 'onboarding_landing_page',
  ONBOARDING_REGISTRATION_PAGE: 'onboarding_registration_page',
  ONBOARDING_DOCUMENT_VERIFICATION_CITIZENSHIP: 'onboarding_document_verification_citizenship',
  ONBOARDING_IDENTITY_VERIFICATION: 'onboarding_identity_verification',
  ONBOARDING_WAITING_FOR_CONTRACT: 'onboarding_waiting_for_contract',
  ONBOARDING_VERIFICATION_ERROR: 'onboarding_verification_error',
  ONBOARDING_VERIFICATION_STATUS: 'onboarding_verification_status',
  ONBOARDING_OVERVIEW: 'onboarding_overview',
  ONBOARDING_CONTINUE_TO_CONTRACT: 'onboarding_continue_to_contract',
  ENTERPRISE_ANALYTICS: 'enterprise_analytics',
  HOMEPAGE: 'homepage',
  ALL_ITEMS: 'all_items',
  ALL_OPTIONS: 'all_options',
  ALL_DISABLED: 'all_disabled',
  ITEMS_NO_CATEGORY: 'items_no_category',
  CATEGORIES: 'categories',
  CAMPAIGNS: 'campaigns',
  CHOOSE_CAMPAIGN: 'choose_campaign',
  NEW_CAMPAIGN: 'new_campaign',
  NEW_CAMPAIGN_RULES: 'new_campaign_rules',
  UPDATE_CAMPAIGN: 'update_campaign',
  BUSINESS_INSIGHTS_V2: 'business_insights_v2',
  ENTERPRISE_USER_MANAGEMENT: 'enterprise_user_management',
  CART: 'cart',
  CAMPAIGN_DETAILS: 'campaign_details',
  LIVE_PURCHASES: 'live_purchases',
  RESTAURANT_DETAILS: 'restaurant_details',
  ENTER_PHONE_NUMBER: 'enter_phone_number',
  ENTER_VERIFICATION_CODE: 'enter_verification_code',
  VENUE_AVAILABILITY: 'venue_availability',
  ORDER_TRACKING: 'order_tracking',
  EASTER_EGG_V2: 'easter_egg_v2',
  PROFILE: 'profile',
  BUSINESS_INSIGHTS_V2_MENU: 'business_insights_v2_menu',
  BUSINESS_INSIGHTS_V2_OPERATIONS: 'business_insights_v2_operations',
  BUSINESS_INSIGHTS_V2_PERFORMANCE: 'business_insights_v2_performance',
  BUSINESS_INSIGHTS_V2_CUSTOMER_BASE: 'business_insights_v2_customer_base',
  SHARED_MENU: 'shared_menu',
  HISTORICAL_AVAILABILITY: 'historical_availability',
  GOOGLE_SHEET_PAGE: 'google_sheet_page',
  DELIVERY_TYPE_MODAL: 'delivery_type_modal',
  BUSINESS_INSIGHTS_V2_RATINGS_REVIEWS: 'business_insights_v2_ratings_reviews',
  VENUE_GROUP: 'venue_group',
  MERCHANT_ADMIN_USER_SETTINGS: 'merchant_admin_user_settings',
  MERCHANT_ADMIN_SEARCH: 'merchant_admin_search',
  IMPORT_EXISTING_MENU_FROM_VENUE: 'import_existing_menu_from_venue',
  CHECK_EMAIL_LOGIN: 'check_email_login',
  MAGIC_LINK_VERIFICATION: 'magic_link_verification',
  EMAIL_LOGIN: 'email_login',
  LOGIN_OR_APPLY: 'login_or_apply',
  SUBSCRIPTION_PURCHASE_OUTCOME: 'subscription_purchase_outcome',
  SUBSCRIPTION_PURCHASE_WELCOME: 'subscription_purchase_welcome',
  MERCHANT_SELF_SERVICE_SIGN_UP: 'merchant_self_service_sign_up',
  PROMO_CONSENTS: 'promo_consents',
  PUSH_NOTIFICATION: 'push_notification',
  GEOLOCATION_HISTORY: 'geolocation_history',
  MERCHANT_ADMIN_PURCHASES: 'merchant_admin_purchases',
} as const;
export type ViewType = typeof View;
export type ViewValueType = ViewType[keyof ViewType];

export const TargetContentFilterRatings = {
  FILTER_RATINGS_VALUE_1: 'filter_ratings_value_1',
  FILTER_RATINGS_VALUE_2: 'filter_ratings_value_2',
  FILTER_RATINGS_VALUE_3: 'filter_ratings_value_3',
  FILTER_RATINGS_VALUE_4: 'filter_ratings_value_4',
  FILTER_RATINGS_VALUE_5: 'filter_ratings_value_5',
} as const;
export type TargetContentFilterRatingsType = typeof TargetContentFilterRatings;
export type TargetContentFilterRatingsValueType = TargetContentFilterRatingsType[keyof TargetContentFilterRatingsType];

export const SourceTitle = {
  TOTAL_SALES: 'total_sales',
  TOTAL_ORDERS: 'total_orders',
  AVG_BASKET_SIZES: 'avg_basket_sizes',
  AVG_BASKET_SIZES_ITEMS: 'avg_basket_sizes_items',
} as const;
export type SourceTitleType = typeof SourceTitle;
export type SourceTitleValueType = SourceTitleType[keyof SourceTitleType];

export const FormSubmissionStatus = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const;
export type FormSubmissionStatusType = typeof FormSubmissionStatus;
export type FormSubmissionStatusValueType = FormSubmissionStatusType[keyof FormSubmissionStatusType];

export const InteractionType = {
  CLEAR: 'clear',
  DELETE: 'delete',
  SWIPE: 'swipe',
  CLICK: 'click',
  PROFILE_PICTURE: 'profile_picture',
  SETTINGS_ITEM: 'settings_item',
  CONFIRM: 'confirm',
  DISMISS: 'dismiss',
} as const;
export type InteractionTypeType = typeof InteractionType;
export type InteractionTypeValueType = InteractionTypeType[keyof InteractionTypeType];

export const ClickTarget = {
  ACCEPTED: 'accepted',
  DISAPPEARED: 'disappeared',
  COMPLETED: 'completed',
  CONTACT_SUPPORT: 'contact_support',
  SKIP_AUTO_DROPOFF_COUNTDOWN: 'skip_auto_dropoff_countdown',
  GET_STARTED_OR_APPLY_NOW: 'get_started_or_apply_now',
  APPLY_NOW_OR_SIGN_UP: 'apply_now_or_sign_up',
  LOGIN_OR_SIGN_IN: 'login_or_sign_in',
  REJECTED: 'rejected',
  RETURN: 'return',
  DISMISS: 'dismiss',
  SELECTOR: 'selector',
  PIN_TICKET: 'pin_ticket',
  UNPIN_TICKET: 'unpin_ticket',
  BANNER_REFERRAL_DISCOVERY_SHARE: 'banner:referral_discovery:share',
  ENTER_ADDRESS_MANUALLY: 'enter_address_manually',
  FAVOURITE: 'favourite',
  FILTERS: 'filters',
  HERO: 'hero',
  LOCATION: 'location',
  MAP: 'map',
  MEDIUM: 'medium',
  MENU_ITEM: 'menu_item',
  PRODUCT_LINE: 'product-line',
  QUICKLINK: 'quicklink',
  SEE_ALL: 'see_all',
  SHARE_LOCATION: 'share_location',
  UNFAVOURITE: 'unfavourite',
  VENUE: 'venue',
  VENUE_LARGE: 'venue-large',
  WOLT_PLUS_BANNER: 'wolt_plus_banner',
  OPEN_VISIBLE_BASKETS: 'open_visible_baskets',
  SQUARE_TITLE_BOTTOM: 'square-title-bottom',
  ADDRESS_DETAILS: 'address_details',
  ADDRESS_LIST: 'address_list',
  AGE_VERIFICATION: 'age_verification',
  CHECKOUT_FEES_INFO: 'checkout_fees_info',
  CO2_RESPONSIBILITY_BANNER: 'co2_responsibility_banner',
  COLLAPSE: 'collapse',
  COURIER_INSTRUCTIONS: 'courier_instructions',
  DELIVERY_SCHEDULE: 'delivery_schedule',
  DESELECT: 'deselect',
  EDIT_ORDER: 'edit_order',
  GET_SUBSCRIPTION: 'get_subscription',
  HOMEDELIVERY: 'homedelivery',
  MENU_ITEM_UPDATE_CART: 'menu_item_update_cart',
  MINUS: 'minus',
  ORDER_DETAILS: 'order_details',
  PLUS: 'plus',
  PRESSED_CONFIRM: 'pressed_confirm',
  SELECT: 'select',
  SELECT_CONFIRMATION_PICKUP_NO: 'select_confirmation_pickup_no',
  SHOW_DIALOG_CONFIRMATION_PICKUP: 'show_dialog_confirmation_pickup',
  TAKEAWAY: 'takeaway',
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  SELECT_CONFIRMATION_PICKUP_YES: 'select_confirmation_pickup_yes',
  OPEN_CHAT: 'open_chat',
  DISMISS_CHAT: 'dismiss_chat',
  EXPAND: 'expand',
  MENU_LANGUAGE_ALWAYS: 'menu_language_always',
  MENU_LANGUAGE_NEVER: 'menu_language_never',
  MENU_LANGUAGE_SELECT: 'menu_language_select',
  MENU_LANGUAGE_SHOW_ORIGINAL: 'menu_language_show_original',
  MENU_LANGUAGE_TRANSLATE: 'menu_language_translate',
  OPEN_DELIVERY_CONFIG: 'open_delivery_config',
  OPTIONS: 'options',
  PRODUCT_INFORMATION: 'product_information',
  SHARE_GROUP_URL: 'share_group_url',
  START_GROUP: 'start_group',
  VIEW_ORDER: 'view_order',
  RETAKE_DOCUMENT: 'retake_document',
  UPLOAD_DOCUMENT: 'upload_document',
  SELECT_DOCUMENT: 'select_document',
  SELECT_CONTRACT: 'select_contract',
  IBAN_FIELD: 'iban_field',
  ADDRESS_FIELD: 'address_field',
  CITIZENSHIP_LIST: 'citizenship_list',
  CONTINUE: 'continue',
  IDENTIFICATION_METHOD_LIST: 'identification_method_list',
  ALLOW_CAMERA: 'allow_camera',
  CLOSE: 'close',
  EXPORT_MENU: 'export_menu',
  DOWNLOAD_ITEMS: 'download_items',
  START_MENU_IMPORT: 'start_menu_import',
  IMPORT_MENU: 'import_menu',
  IMPORT_ITEM_IMAGES: 'import_item_images',
  SELECT_IMAGES: 'select_images',
  START_UPLOADING: 'start_uploading',
  CREATE_ITEMS: 'create_items',
  CREATE_SELECT_FILE: 'create_select_file',
  SUBMIT_ITEMS_CREATION: 'submit_items_creation',
  UPDATE_ITEMS: 'update_items',
  UPDATE_SELECT_FILE: 'update_select_file',
  SUBMIT_ITEM_UPDATING: 'submit_item_updating',
  EXPORT_VERSIONS: 'export_versions',
  EDIT_CATEGORY: 'edit_category',
  DELETE_CATEGORY: 'delete_category',
  IMPORT_ITEMS: 'import_items',
  EXPORT_ITEMS: 'export_items',
  ENABLE_ITEMS: 'enable_items',
  DISABLE_ITEMS: 'disable_items',
  ADD_SUBCATEGORIES: 'add_subcategories',
  CREATE_ITEM_COPY: 'create_item_copy',
  CREATE_SPECIAL: 'create_special',
  DISABLE_ITEM: 'disable_item',
  DELETE_ITEM: 'delete_item',
  REMOVE_ITEM_FROM_CATEGORY: 'remove_item_from_category',
  ENABLE_ITEM: 'enable_item',
  ADD_NEW_CATEGORY: 'add_new_category',
  VIEW_ON_WOLT: 'view_on_wolt',
  MENU_IMPORT_SELECT_FILE: 'menu_import_select_file',
  EDIT_ITEM: 'edit_item',
  SAVE_ITEM_CHANGES: 'save_item_changes',
  ADD_NEW_OPTION: 'add_new_option',
  SAVE_NEW_OPTION: 'save_new_option',
  ADD_NEW_ITEM: 'add_new_item',
  SAVE_NEW_ITEM: 'save_new_item',
  ENABLE_OR_DISABLE: 'enable_or_disable',
  SET_AVAILABILITY: 'set_availability',
  CHANGE_STOCK_AVAILABILITY: 'change_stock_availability',
  CHANGE_PRICE: 'change_price',
  SET_COURIER_RESTRICTIONS: 'set_courier_restrictions',
  CHANGE_CATEGORY: 'change_category',
  ADD_OPTIONS: 'add_options',
  CHANGE_COMMISSIONS: 'change_commissions',
  CHANGE_VAT: 'change_vat',
  CREATE_WOLT_SPECIALS: 'create_wolt_specials',
  DELETE_ITEMS: 'delete_items',
  EDIT_OPTION: 'edit_option',
  EDIT_SUBCATEGORY: 'edit_subcategory',
  DELETE_SUBCATEGORY: 'delete_subcategory',
  DATE_PICKER: 'date_picker',
  CHART_SOURCE: 'chart_source',
  CAMPAIGN_TABLE: 'campaign_table',
  NEW_CAMPAIGN: 'new_campaign',
  CAMPAIGN_RULES_BASKET: 'campaign_rules_basket',
  USER_RULES: 'user_rules',
  CAMPAIGN_EDIT: 'campaign_edit',
  CAMPAIGN_SELECTION: 'campaign_selection',
  CAMPAIGN_RULES: 'campaign_rules',
  CAMPAIGN_UPDATE: 'campaign_update',
  INTRO_LINK: 'intro_link',
  SEND_INVITATION: 'send_invitation',
  CREATE_SHARED_MENU: 'create_shared_menu',
  SHARE_MENU_WITH_VENUES: 'share_menu_with_venues',
  STOP_SHARING_MENU: 'stop_sharing_menu',
  EDIT_SHARED_MENU: 'edit_shared_menu',
  SCHEDULE_PUBLISHING: 'schedule_publishing',
  PUBLISH_NOW: 'publish_now',
  ITEM_BOTTOM_SHEET: 'item_bottom_sheet',
  INSTALL_PWA: 'install_pwa',
  IOS_VIEW_INSTRUCTION: 'ios_view_instruction',
  INSTALL_PWA_USER_DROPDOWN: 'install_pwa_user_dropdown',
  UPLOAD_IMAGE: 'upload_image',
  SCHEDULED_HOURS: 'scheduled_hours',
  SWITCH_DELIVERY_TYPE: 'switch_delivery_type',
  CONFIRM: 'confirm',
  APPLE: 'apple',
  CODE_NOT_RECEIVED: 'code_not_received',
  EMAIL: 'email',
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  GUEST: 'guest',
  SEND_CODE: 'send_code',
  ADD_ITEMS_TO_CATALOG: 'add_items_to_catalog',
  LOG_IN_TO_ORDER: 'log_in_to_order',
  LINE: 'line',
  RECEIPT: 'receipt',
  CANCEL_ORDER_BACK: 'cancel_order_back',
  CANCEL_ORDER_MODIFY: 'cancel_order_modify',
  HIDE_ORDER_STATUS: 'hide_order_status',
  CONTACT_VENUE: 'contact_venue',
  ADD_COMMENT: 'add_comment',
  PROCEED_TO_CHECKOUT: 'proceed_to_checkout',
  SUBSTITUTION_PREFERENCES: 'substitution_preferences',
  SWITCH_TO_OLD_INSIGHTS: 'switch_to_old_insights',
  CHANGE_TO_OLD_INSIGHTS: 'change_to_old_insights',
  FILTER_VENUES_BUTTON: 'filter_venues_button',
  FILTER_VENUES_OPTION: 'filter_venues_option',
  VENUE_ORDERBY: 'venue_orderby',
  ARCHIVE_BRAND_OWNER: 'archive_brand_owner',
  EXPORT_TO_SHEET: 'export_to_sheet',
  SELECT_SHEET: 'select_sheet',
  UPLOAD_SHEET_DATA: 'upload_sheet_data',
  CANCEL_SHEET_IMPORT: 'cancel_sheet_import',
  DEPOSIT_MADE: 'deposit_made',
  FILTER_RATINGS: 'filter_ratings',
  DUPLICATE_MENU: 'duplicate_menu',
  RENAME_MENU: 'rename_menu',
  DELETE_MENU: 'delete_menu',
  SEND: 'send',
  LOGIN_SMS: 'login_sms',
  LOGIN_EMAIL: 'login_email',
  APPLY: 'apply',
  TOGGLE_DELIVERY_AREA: 'toggle_delivery_area',
} as const;
export type ClickTargetType = typeof ClickTarget;
export type ClickTargetValueType = ClickTargetType[keyof ClickTargetType];

export const LogType = {
  VIEW: 'view',
  DATA: 'data',
  INTERACTION: 'interaction',
  IMPRESSION: 'impression',
  ERROR: 'error',
  OVERLAY: 'overlay',
} as const;
export type LogTypeType = typeof LogType;
export type LogTypeValueType = LogTypeType[keyof LogTypeType];

export const Overlay = {
  SUBSTITUTIONS_ONBOARDING: 'substitutions_onboarding',
  APP_REFERRAL_BANNER: 'app_referral_banner',
  APP_REFERRAL_LINK: 'app_referral_link',
  WOLT_REWARD_PROGRESSION: 'wolt_reward_progression',
  EARNED_WOLT_POINTS: 'earned_wolt_points',
  ORDER_BUBBLE: 'order_bubble',
  CASH_OVERFLOW: 'cash_overflow',
  CAMPAIGNS_LIMIT_WARNING: 'campaigns_limit_warning',
  CAMPAIGNS_LIMIT_REACHED: 'campaigns_limit_reached',
  VISIBLE_BASKET_ONBOARDING: 'visible_basket_onboarding',
} as const;
export type OverlayType = typeof Overlay;
export type OverlayValueType = OverlayType[keyof OverlayType];

export const EventName = {
  BUSINESS_INSIGHTS_VIEW: 'business_insights_view',
  CONTACT_SUPPORT: 'contact_support',
  HOMEPAGE_VIEW: 'homepage_view',
  MENU_EDITOR_VIEW: 'menu_editor_view',
  PURCHASES_VIEW: 'purchases_view',
  CLICK: 'click',
  ONBOARDING_REGISTRATION_PAGE_VIEW: 'onboarding_registration_page_view',
  ONBOARDING_LANDING_PAGE_INTERACTION_GET_STARTED: 'onboarding_landing_page_interaction_get_started',
  ONBOARDING_LANDING_PAGE_VIEW: 'onboarding_landing_page_view',
  ONBOARDING_REGISTRATION_PAGE_INTERACTION_APPLY: 'onboarding_registration_page_interaction_apply',
  ONBOARDING_REGISTRATION_PAGE_INTERACTION_LOGIN: 'onboarding_registration_page_interaction_login',
  NO_LOCATION: 'no_location',
  BANNER: 'banner',
  MENU_ITEM: 'menu_item',
  VENUE: 'venue',
  SUPPORT_INBOX_VIEW: 'support_inbox_view',
  CONFIRM_ORDER: 'confirm_order',
  COURIER_INSTRUCTIONS: 'courier_instructions',
  ORDER_FAILED: 'order_failed',
  SELECT_CONFIRMATION_PICKUP_NO: 'select_confirmation_pickup_no',
  SEND_ORDER: 'send_order',
  MENU_CATEGORY: 'menu_category',
  FILLED: 'filled',
  LOAD_LOOKER_DASHBOARD: 'load_looker_dashboard',
  CSV_DOWNLOAD: 'csv_download',
  DATA_CHART_HOVER: 'data_chart_hover',
  NEW_CAMPAIGN_CREATED: 'new_campaign_created',
  CAMPAIGN_RULES: 'campaign_rules',
  END_CAMPAIGN: 'end_campaign',
  UPDATE_CAMPAIGN: 'update_campaign',
  BUSINESS_INSIGHTS_V2_VIEW: 'business_insights_v2_view',
  CART_ITEMS: 'cart_items',
  CHOOSE_CAMPAIGN_VIEW: 'choose_campaign_view',
  NEW_CAMPAIGN_VIEW: 'new_campaign_view',
  UPDATE_CAMPAIGN_VIEW: 'update_campaign_view',
  CAMPAIGN_DETAILS_VIEW: 'campaign_details_view',
  BRAND: 'brand',
  RESULTS: 'results',
  BUSINESS_INSIGHTS_V2_PERFORMANCE_VIEW: 'business_insights_v2_performance_view',
  BUSINESS_INSIGHTS_V2_OPERATIONS_VIEW: 'business_insights_v2_operations_view',
  BUSINESS_INSIGHTS_V2_CUSTOMER_BASE_VIEW: 'business_insights_v2_customer_base_view',
  BUSINESS_INSIGHTS_V2_MENU_VIEW: 'business_insights_v2_menu_view',
  DISMISS: 'dismiss',
  LOADING_ERROR: 'loading_error',
  LOAD_LOOKER_DASHBOARD_ERROR: 'load_looker_dashboard_error',
  SHARED_MENU_VIEW_GOOGLE_SHEET_PAGE: 'shared_menu_view_google_sheet_page',
  BUSINESS_INSIGHTS_V2_RATINGS_REVIEWS_VIEW: 'business_insights_v2_ratings_reviews_view',
  CREATE_VENUE_GROUP_FAILED: 'create_venue_group_failed',
  LANGUAGE: 'language',
  UPDATE_SIDEBAR_WIDTH: 'update_sidebar_width',
  DARK_MODE: 'dark_mode',
  LOGOUT: 'logout',
  SUPPORT: 'support',
  IMPORT_VENUE_ID: 'import_venue_id',
  LOAD: 'load',
  GET_WOLT_PLUS: 'get_wolt_plus',
  GET_WOLT_PLUS_CONFIRM: 'get_wolt_plus_confirm',
  SUBSCRIPTION_RESULT_SUCCESS: 'subscription_result_success',
  SUBSCRIPTION_RESULT_ERROR: 'subscription_result_error',
  FETCH: 'fetch',
  FORM_SUBMISSION_STATUS: 'form_submission_status',
  SKIP_RATING: 'skip_rating',
  SAVE_DELIVERY_AREAS: 'save_delivery_areas',
  DELIVERY_AREAS: 'delivery_areas',
  REDEEM_BENEFIT: 'redeem_benefit',
  EDGE_CAMPING_DETECTED: 'edge_camping_detected',
  WOLT_PLUS_LEARN_MORE: 'wolt_plus_learn_more',
  SEND_OFFER: 'send_offer',
  HOVER_OFFER: 'hover_offer',
  EXPAND_BENEFITS: 'expand_benefits',
  GEO_AREA_FROM_URL: 'geo_area_from_url',
  GET_RECEIPTS: 'get_receipts',
  DOWNLOAD_CSV: 'download_csv',
  SWITCH_TO_ITEMS: 'switch_to_items',
  SWITCH_TO_ORDERS: 'switch_to_orders',
  DOWNLOAD_CSV_CONFIRMED: 'download_csv_confirmed',
  GET_RECEIPTS_CONFIRMED: 'get_receipts_confirmed',
} as const;
export type EventNameType = typeof EventName;
export type EventNameValueType = EventNameType[keyof EventNameType];

export const SidebarWidthUpdateType = {
  EXPAND: 'expand',
  COLLAPSE: 'collapse',
} as const;
export type SidebarWidthUpdateTypeType = typeof SidebarWidthUpdateType;
export type SidebarWidthUpdateTypeValueType = SidebarWidthUpdateTypeType[keyof SidebarWidthUpdateTypeType];

let WoltGatekeeper: any;

export function initAvo(
  options: {
    env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger;
  },
  destinationOptions: any,
  WoltGatekeeperDestination: CustomDestination,
) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn('[avo] ****************************************************');
    InternalAvoLogger.warn('[avo] WARNING Avo cannot be initialized in noop mode in production:');
    InternalAvoLogger.warn('[avo] - Overwriting configuration with noop=false.');
    InternalAvoLogger.warn(
      '[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true',
    );
    InternalAvoLogger.warn('[avo] ****************************************************');
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log('[avo] ****************************************************');
    InternalAvoLogger.log('[avo] Avo is now initialized in noop mode. This means:');
    InternalAvoLogger.log('[avo] - No events will be sent');
    InternalAvoLogger.log('[avo] - No network requests are made');
    InternalAvoLogger.log('[avo] ****************************************************');
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ =
    !__AVO_NOOP__ &&
    ((typeof window !== 'undefined' && (window as any).location.search.indexOf('avo_debug=1') > -1) ||
      (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn('[avo] Avo Inspector not provided in initAvo() call');
  }

  destinationOptions = destinationOptions || {};

  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position);
    }

    (function () {
      if (typeof (window as any) === 'undefined') {
        return;
      }
      let init = function () {
        let iframe: any = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.id = 'avo-debugger';
        iframe.src = 'https://www.avo.app/_debugger';
        iframe.style = 'display: none;';
      };

      if (document.body) {
        init();
      } else {
        document.addEventListener('DOMContentLoaded', init);
      }
    })();
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }

    WoltGatekeeper = WoltGatekeeperDestination;
    if (__AVO_ENV__ === 'prod') {
      WoltGatekeeper && WoltGatekeeper.make && WoltGatekeeper.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      WoltGatekeeper && WoltGatekeeper.make && WoltGatekeeper.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error'](
        '[avo] No staging key is set for Wolt - Gatekeeper. Head to destination settings in Avo to set a staging key.',
      );
      WoltGatekeeper && WoltGatekeeper.make && WoltGatekeeper.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertWoltSpecialSettings(woltSpecialSettings: WoltSpecialSettings, _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(
    AvoAssert.assertObject(
      'oY3fg8owt',
      _label ? 'wolt_special_settings' + ': ' + _label : 'wolt_special_settings',
      woltSpecialSettings,
    ),
  );
  if (woltSpecialSettings !== null && woltSpecialSettings !== undefined) {
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface HomepageViewProperties {
  durationMs: number;
}
/**
 * homepage_view: When merchant.wolt.com is opened. This is the main landing page where user would either login or will be asked to enter the venue if already logged in.
 *
 * When to trigger this event:
 * 1. Trigger when user lands on merchant.wolt.com
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/NH60nPfkyl/trigger/1azg4r42J
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/NH60nPfkyl}
 */
export function homepageView(properties: HomepageViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'homepage' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'homepage_view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'NH60nPfkyl',
        'a2e9e06366a49db999d6241fe141b5f5de052c7e044702c14ee670d15e908f43',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('homepage_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('NH60nPfkyl', 'homepage_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'homepage_view',
        eventProperties,
        'NH60nPfkyl',
        'a2e9e06366a49db999d6241fe141b5f5de052c7e044702c14ee670d15e908f43',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('homepage_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BusinessInsightsViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * business_insights_view: When user logs in to merchant admin and lands on business insights page after selecting a merchant/venue
 *
 * When to trigger this event:
 * 1. Trigger when user land on this page after selecting the venue
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/XBV74DEy0O/trigger/VNqFkIJOr
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/XBV74DEy0O}
 */
export function businessInsightsView(properties: BusinessInsightsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'business_insights_view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'XBV74DEy0O',
        'c88a0660c3c021e91355bf5c8d2d42c56d0de96c867548f414314308dd5956d5',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('business_insights_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'XBV74DEy0O',
        'business_insights_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_view',
        eventProperties,
        'XBV74DEy0O',
        'c88a0660c3c021e91355bf5c8d2d42c56d0de96c867548f414314308dd5956d5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('business_insights_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MenuEditorViewProperties {
  durationMs: number;
}
/**
 * menu_editor_view: when the menu editor is viewed
 *
 * When to trigger this event:
 * 1. When menu editor is opened
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/TyRu8bouRl/trigger/3g2y5nALv
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/TyRu8bouRl}
 */
export function menuEditorView(properties: MenuEditorViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'menu_editor_view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'menu_editor' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'TyRu8bouRl',
        'd6646e376887a57166941bc268957694ce4ed2bda53a998c3e1b3378691554fd',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('menu_editor_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('TyRu8bouRl', 'menu_editor_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'menu_editor_view',
        eventProperties,
        'TyRu8bouRl',
        'd6646e376887a57166941bc268957694ce4ed2bda53a998c3e1b3378691554fd',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('menu_editor_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PurchasesViewProperties {
  versionType: string;
  durationMs: number;
}
/**
 * purchases_view: Records when purchase view is loaded in merchant.wolt.com
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/W2tx2BTPHL/trigger/MsGpU4g64
 *
 * @param properties the properties associatied with this event
 * @param properties.versionType: Defines if the version of purchases view is v1 or v2
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/W2tx2BTPHL}
 */
export function purchasesView(properties: PurchasesViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'vLpZ3ZH5PK', name: 'version_type', value: properties.versionType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'purchases' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'purchases_view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'W2tx2BTPHL',
        '4090cb7040a235e29cbf5871e5fc307e3da740498e19dab7ffdbac5abedf9873',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('purchases_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('W2tx2BTPHL', 'purchases_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'purchases_view',
        eventProperties,
        'W2tx2BTPHL',
        '4090cb7040a235e29cbf5871e5fc307e3da740498e19dab7ffdbac5abedf9873',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('purchases_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ContactSupportProperties {
  view: ViewValueType;
}
/**
 * contact_support: determines when merchant user contacts support merchant admin
 *
 * When to trigger this event:
 * 1. When support chat icon is clicked from right side of screen
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/eNh5qkCr8W/trigger/cCQCt4jPi
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/eNh5qkCr8W}
 */
export function contactSupport(properties: ContactSupportProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'contact_support' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'eNh5qkCr8W',
        'f46eec7cdbb7183b85cdf487fbe662d2f94a5a6a0526ea5bf4b7eb3ea63449ee',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('contact_support', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('eNh5qkCr8W', 'contact_support', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'contact_support',
        eventProperties,
        'eNh5qkCr8W',
        'f46eec7cdbb7183b85cdf487fbe662d2f94a5a6a0526ea5bf4b7eb3ea63449ee',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('contact_support', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EnterpriseAnalyticsDataLoadLookerDashboardProperties {
  durationMs: number;
}
/**
 * enterprise_analytics_data_load_looker_dashboard: When the enterprise/brand owners log in to merchant admin and visit business insight tab, we'll send this event to measure how long it would take to complete loading the dashboard to learn if the performance of loading dashboards are acceptable.

After all tiles in the dashboard are loaded successfully, the duration between "dashboard start loading" and "dashboard complete loading" will be sent as the payload of the event.
 *
 * When to trigger this event:
 * 1. After all tiles in the dashboard are loaded successfully
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Jj1ujYLkJf/trigger/YTvGpJk2T
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Jj1ujYLkJf}
 */
export function enterpriseAnalyticsDataLoadLookerDashboard(
  properties: EnterpriseAnalyticsDataLoadLookerDashboardProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'enterprise_analytics' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'load_looker_dashboard' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Jj1ujYLkJf',
        'dbfb2cf2bf882c3e7a1520f8af5173f0d0bc76370b14e10fbd8630fe6d3fffba',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('enterprise_analytics_data_load_looker_dashboard', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Jj1ujYLkJf',
        'enterprise_analytics_data_load_looker_dashboard',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'enterprise_analytics_data_load_looker_dashboard',
        eventProperties,
        'Jj1ujYLkJf',
        'dbfb2cf2bf882c3e7a1520f8af5173f0d0bc76370b14e10fbd8630fe6d3fffba',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'enterprise_analytics_data_load_looker_dashboard',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface PurchasesDataCsvDownloadProperties {
  businessName: string;
  venuesCount: number;
  entityType: string;
  numOfDays: number;
  downloadTimeMs: number;
  entityId: string;
  rangeStartDaysAgo: number;
  rangeEndDaysAgo: number;
}
/**
 * purchases_data_csv_download: This metric is intended to track the user behavior of the CSV download button in merchant-admin. From this metric, we can get insights into how often the feature is used and how long it usually takes, depending on the time range and size of an entity.
 *
 * When to trigger this event:
 * 1. User click "Download report" button to get a CSV file. The metric is designed to measure time to download the file with which action.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/I6ll6Hjyc-/trigger/mHOJY3Dna
 * 2. This event is triggered when a user download a CSV file.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/I6ll6Hjyc-/trigger/8iHiiKTJx
 *
 * @param properties the properties associatied with this event
 * @param properties.businessName: The name of a business (brand, enterprise and merchant)
 * @param properties.venuesCount: The number of venues in one entity.
 * @param properties.entityType: Whether an entity is 'business', 'enterprise,' or 'merchant'.
 * @param properties.numOfDays: The number of days between startTime and endTime selected by a user.
 * @param properties.downloadTimeMs: Time to download a CSV file.

 * @param properties.entityId: id of either enterprise, business or merchant

 * @param properties.rangeStartDaysAgo: The time range between startTime to today. We need to know relative time ranges based on today.
 * @param properties.rangeEndDaysAgo: The time range between endTime and today. We need to get a better insight into how users select time range based on today's date time value.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/I6ll6Hjyc-}
 */
export function purchasesDataCsvDownload(properties: PurchasesDataCsvDownloadProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'jYCm_3HWP', name: 'business_name', value: properties.businessName });
  eventPropertiesArray.push({ id: '0dhXEw7Gg', name: 'venues_count', value: properties.venuesCount });
  eventPropertiesArray.push({ id: 'JpH8y9l1Z', name: 'entity_type', value: properties.entityType });
  eventPropertiesArray.push({ id: 'zBnbQv1Kr', name: 'num_of_days', value: properties.numOfDays });
  eventPropertiesArray.push({ id: 'xQV8akJQI', name: 'download_time_ms', value: properties.downloadTimeMs });
  eventPropertiesArray.push({ id: 'Kor3GaiFO', name: 'entity_id', value: properties.entityId });
  eventPropertiesArray.push({ id: 'oqdgTsHKQ', name: 'range_start_days_ago', value: properties.rangeStartDaysAgo });
  eventPropertiesArray.push({ id: 'OwyT7jYhA', name: 'range_end_days_ago', value: properties.rangeEndDaysAgo });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'purchases' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'csv_download' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'I6ll6Hjyc-',
        'def881c3fdcdad37583453e901eb590da2fc5839ce2101a14da11a95e3154fa5',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('purchases_data_csv_download', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'I6ll6Hjyc-',
        'purchases_data_csv_download',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'purchases_data_csv_download',
        eventProperties,
        'I6ll6Hjyc-',
        'def881c3fdcdad37583453e901eb590da2fc5839ce2101a14da11a95e3154fa5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('purchases_data_csv_download', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PurchasesErrorCsvDownloadProperties {
  businessName: string;
  venuesCount: number;
  entityType: string;
  numOfDays: number;
  entityId: string;
  rangeStartDaysAgo: number;
  rangeEndDaysAgo: number;
  errorType: string;
}
/**
 * purchases_error_csv_download: This metric is intended to track errors in the CSV download feature in merchant-admin.
 *
 * When to trigger this event:
 * 1. This event is triggered when a user encounters an error in downloading a CSV file.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/nqHJRuQUl/trigger/CwgKMzVJM3
 *
 * @param properties the properties associatied with this event
 * @param properties.businessName: The name of a business (brand, enterprise and merchant)
 * @param properties.venuesCount: The number of venues in one entity.
 * @param properties.entityType: Whether an entity is 'business', 'enterprise,' or 'merchant'.
 * @param properties.numOfDays: The number of days between startTime and endTime selected by a user.
 * @param properties.entityId: id of either enterprise, business or merchant

 * @param properties.rangeStartDaysAgo: The time range between startTime to today. We need to know relative time ranges based on today.
 * @param properties.rangeEndDaysAgo: The time range between endTime and today. We need to get a better insight into how users select time range based on today's date time value.
 * @param properties.errorType: Type of an error that shows up in an error pop-up/view. Below are the rules for values:

general: when the error is general without specific reason. Like 'Something went wrong!'
network: when the error is because of network problems
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/nqHJRuQUl}
 */
export function purchasesErrorCsvDownload(properties: PurchasesErrorCsvDownloadProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'jYCm_3HWP', name: 'business_name', value: properties.businessName });
  eventPropertiesArray.push({ id: '0dhXEw7Gg', name: 'venues_count', value: properties.venuesCount });
  eventPropertiesArray.push({ id: 'JpH8y9l1Z', name: 'entity_type', value: properties.entityType });
  eventPropertiesArray.push({ id: 'zBnbQv1Kr', name: 'num_of_days', value: properties.numOfDays });
  eventPropertiesArray.push({ id: 'Kor3GaiFO', name: 'entity_id', value: properties.entityId });
  eventPropertiesArray.push({ id: 'oqdgTsHKQ', name: 'range_start_days_ago', value: properties.rangeStartDaysAgo });
  eventPropertiesArray.push({ id: 'OwyT7jYhA', name: 'range_end_days_ago', value: properties.rangeEndDaysAgo });
  eventPropertiesArray.push({ id: 'PvxDsuw9S', name: 'error_type', value: properties.errorType });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'error' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'purchases' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'csv_download' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'nqHJRuQUl',
        '0b1b53ea0a3e0b3cc2fd6bb03b3fcb7680066b29cfb7fe6cdc5f4c7fd52e1171',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('purchases_error_csv_download', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'nqHJRuQUl',
        'purchases_error_csv_download',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'purchases_error_csv_download',
        eventProperties,
        'nqHJRuQUl',
        '0b1b53ea0a3e0b3cc2fd6bb03b3fcb7680066b29cfb7fe6cdc5f4c7fd52e1171',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('purchases_error_csv_download', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickExportMenuProperties {
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_export_menu: Determines when the user clicked on the "Export entire menu from JSON" and exported the menu
 *
 * When to trigger this event:
 * 1. Trigger when the "Export entire menu from JSON" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/nufm6dHPY5/trigger/FybeV3ktM
 *
 * @param properties the properties associatied with this event
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/nufm6dHPY5}
 */
export function allItemsInteractionClickExportMenu(properties: AllItemsInteractionClickExportMenuProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'export_menu' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'nufm6dHPY5',
        '3f9c8206c90ca21597e9e1a9d7f3fd6a8fcf94621dc84e72bd1b9fd84b162ad7',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_export_menu', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'nufm6dHPY5',
        'all_items_interaction_click_export_menu',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_export_menu',
        eventProperties,
        'nufm6dHPY5',
        '3f9c8206c90ca21597e9e1a9d7f3fd6a8fcf94621dc84e72bd1b9fd84b162ad7',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_items_interaction_click_export_menu', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickStartMenuImportProperties {
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_start_menu_import: Determines when the user clicked on "Import entire menu from JSON" and started the process of importing the menu
 *
 * When to trigger this event:
 * 1. Trigger when the user clicked on the "Import entire menu from JSON"
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MP7bvMzkgy/trigger/W70NoMzGf
 *
 * @param properties the properties associatied with this event
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MP7bvMzkgy}
 */
export function allItemsInteractionClickStartMenuImport(properties: AllItemsInteractionClickStartMenuImportProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'start_menu_import' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'MP7bvMzkgy',
        '5f0b91018c05282a661ee3f42e6fbcf29fc0398edc3ff639aba93cf9f968ee31',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_start_menu_import', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'MP7bvMzkgy',
        'all_items_interaction_click_start_menu_import',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_start_menu_import',
        eventProperties,
        'MP7bvMzkgy',
        '5f0b91018c05282a661ee3f42e6fbcf29fc0398edc3ff639aba93cf9f968ee31',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'all_items_interaction_click_start_menu_import',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickImportMenuProperties {
  importStatus: string;
  keepPriceInformation: boolean;
  keepAvailabilityInformation: boolean;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_import_menu: Determines when the user clicked on "Import menu" and tried to import the menu from JSON
 *
 * When to trigger this event:
 * 1. Trigger when the "Import menu" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/hciC9v-wOu/trigger/incEPR07v
 *
 * @param properties the properties associatied with this event
 * @param properties.importStatus: Determines if the import was successful. If not, provides the error message
 * @param properties.keepPriceInformation: Describes if the user asked to keep price information
 * @param properties.keepAvailabilityInformation: Describes if the user asked to keep availability information
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/hciC9v-wOu}
 */
export function allItemsInteractionClickImportMenu(properties: AllItemsInteractionClickImportMenuProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Kh0saahc4', name: 'import_status', value: properties.importStatus });
  eventPropertiesArray.push({
    id: '3kDk_7GVV',
    name: 'keep_price_information',
    value: properties.keepPriceInformation,
  });
  eventPropertiesArray.push({
    id: 'Ja9uHSLcn',
    name: 'keep_availability_information',
    value: properties.keepAvailabilityInformation,
  });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'import_menu' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'hciC9v-wOu',
        '274217dfc64890c2fe3f6d87f180121ffd60e0cf234db2d67325fe6b4950df8a',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_import_menu', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'hciC9v-wOu',
        'all_items_interaction_click_import_menu',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_import_menu',
        eventProperties,
        'hciC9v-wOu',
        '274217dfc64890c2fe3f6d87f180121ffd60e0cf234db2d67325fe6b4950df8a',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_items_interaction_click_import_menu', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickImportItemImagesProperties {
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_import_item_images: Determines if the user clicked on "Import item images"
 *
 * When to trigger this event:
 * 1. Trigger when the users clicked the "Import item images"
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/NCrpyXs_Y/trigger/2XTpZlDnr
 *
 * @param properties the properties associatied with this event
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/NCrpyXs_Y}
 */
export function allItemsInteractionClickImportItemImages(
  properties: AllItemsInteractionClickImportItemImagesProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'import_item_images' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'NCrpyXs_Y',
        '12f28af23bbefad9620b37b563452b82c634822e80c9bbcd19792be270410306',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_import_item_images', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'NCrpyXs_Y',
        'all_items_interaction_click_import_item_images',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_import_item_images',
        eventProperties,
        'NCrpyXs_Y',
        '12f28af23bbefad9620b37b563452b82c634822e80c9bbcd19792be270410306',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'all_items_interaction_click_import_item_images',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickSelectImagesProperties {
  numberOfImagesSelected: number;
  matchingStatus: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_select_images: Determines if the user clicked the "Select images" inside the images importing
 *
 * When to trigger this event:
 * 1. Trigger when the user clicked "Select images" or dropped an image (images) to the menu editor
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/PDYxVDmUAr/trigger/4tR4QfO4A
 *
 * @param properties the properties associatied with this event
 * @param properties.numberOfImagesSelected: Number of images (files) user uploaded
 * @param properties.matchingStatus: Describes if we could math the pictures with the images. If not, what message did the user get
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/PDYxVDmUAr}
 */
export function allItemsInteractionClickSelectImages(properties: AllItemsInteractionClickSelectImagesProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: '0vyh5dH8k',
    name: 'number_of_images_selected',
    value: properties.numberOfImagesSelected,
  });
  eventPropertiesArray.push({ id: 'lTbKjmZiK', name: 'matching_status', value: properties.matchingStatus });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'select_images' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'PDYxVDmUAr',
        '1f9bbd68baa9e33cc7b1146e1faf9d36e337ae50cf4927a3e13fb46f8169517a',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_select_images', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'PDYxVDmUAr',
        'all_items_interaction_click_select_images',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_select_images',
        eventProperties,
        'PDYxVDmUAr',
        '1f9bbd68baa9e33cc7b1146e1faf9d36e337ae50cf4927a3e13fb46f8169517a',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_items_interaction_click_select_images', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickStartUploadingProperties {
  importStatus: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_start_uploading: Determines if the user started uploading item images
 *
 * When to trigger this event:
 * 1. Trigger when the user clicked on the "Start upload"
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ZXkDIsVtDj/trigger/qSWDlRrdT
 *
 * @param properties the properties associatied with this event
 * @param properties.importStatus: Determines if the import was successful. If not, provides the error message
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ZXkDIsVtDj}
 */
export function allItemsInteractionClickStartUploading(properties: AllItemsInteractionClickStartUploadingProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Kh0saahc4', name: 'import_status', value: properties.importStatus });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'start_uploading' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ZXkDIsVtDj',
        '2a2c9a45d46be085a2cd0bc3591a8484047bd4dfc6bd619dbbcab00efab943a9',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_start_uploading', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ZXkDIsVtDj',
        'all_items_interaction_click_start_uploading',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_start_uploading',
        eventProperties,
        'ZXkDIsVtDj',
        '2a2c9a45d46be085a2cd0bc3591a8484047bd4dfc6bd619dbbcab00efab943a9',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_items_interaction_click_start_uploading', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickCreateItemsProperties {
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_create_items: Determines when the user clicked on "Create Items" inside the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when the user clicked on the "Create items"
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/efddtne_8c/trigger/qkzc37LI2
 *
 * @param properties the properties associatied with this event
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/efddtne_8c}
 */
export function allItemsInteractionClickCreateItems(properties: AllItemsInteractionClickCreateItemsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'create_items' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'efddtne_8c',
        'd2bedabf6753f38d4a5d07f501fdde0fab85c3e46b5dc16bc5e2c93f66cd6ef3',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_create_items', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'efddtne_8c',
        'all_items_interaction_click_create_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_create_items',
        eventProperties,
        'efddtne_8c',
        'd2bedabf6753f38d4a5d07f501fdde0fab85c3e46b5dc16bc5e2c93f66cd6ef3',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_items_interaction_click_create_items', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickSubmitItemsCreationProperties {
  importStatus: string;
  categorySelected: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_submit_items_creation: Determines when the user clicked on "Submit" and created some new items with uploading a CSV file
 *
 * When to trigger this event:
 * 1. Trigger when the CSV file was selected and the "Submit" button was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/nuaR5SDb1h/trigger/WHLGG-m3r
 *
 * @param properties the properties associatied with this event
 * @param properties.importStatus: Determines if the import was successful. If not, provides the error message
 * @param properties.categorySelected: Selected category to import these items into (category ID and name)
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/nuaR5SDb1h}
 */
export function allItemsInteractionClickSubmitItemsCreation(
  properties: AllItemsInteractionClickSubmitItemsCreationProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Kh0saahc4', name: 'import_status', value: properties.importStatus });
  eventPropertiesArray.push({ id: 'ztSTUat2E', name: 'category_selected', value: properties.categorySelected });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'submit_items_creation' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'nuaR5SDb1h',
        '6029c78760cde64099c476e63cbc1133ae4d47d3aecddbb8bd1f510ce4dad975',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'all_items_interaction_click_submit_items_creation',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'nuaR5SDb1h',
        'all_items_interaction_click_submit_items_creation',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_submit_items_creation',
        eventProperties,
        'nuaR5SDb1h',
        '6029c78760cde64099c476e63cbc1133ae4d47d3aecddbb8bd1f510ce4dad975',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'all_items_interaction_click_submit_items_creation',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickUpdateItemsProperties {
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_update_items: Determines when "Update items" was clicked
 *
 * When to trigger this event:
 * 1. Trigger when "Update items" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/6c1EYhPgnH/trigger/Mk194j-8m
 *
 * @param properties the properties associatied with this event
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/6c1EYhPgnH}
 */
export function allItemsInteractionClickUpdateItems(properties: AllItemsInteractionClickUpdateItemsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'update_items' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '6c1EYhPgnH',
        '9ca7f31959bef87745fa420841422e69507fb657a4f9a004160d8c11f2be17d5',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_update_items', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '6c1EYhPgnH',
        'all_items_interaction_click_update_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_update_items',
        eventProperties,
        '6c1EYhPgnH',
        '9ca7f31959bef87745fa420841422e69507fb657a4f9a004160d8c11f2be17d5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_items_interaction_click_update_items', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickSubmitItemUpdatingProperties {
  importStatus: string;
  selectedFields: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_submit_item_updating: Determines when the CSV file for item updating was uploaded and the "Download backup file and submit" was clicked
 *
 * When to trigger this event:
 * 1. Trigger when "Download backup file and submit" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MI7wgfkmX4/trigger/wLndZXgGf
 *
 * @param properties the properties associatied with this event
 * @param properties.importStatus: Determines if the import was successful. If not, provides the error message
 * @param properties.selectedFields: Fields selected in 'Select which fields to update on the items'
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MI7wgfkmX4}
 */
export function allItemsInteractionClickSubmitItemUpdating(
  properties: AllItemsInteractionClickSubmitItemUpdatingProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Kh0saahc4', name: 'import_status', value: properties.importStatus });
  eventPropertiesArray.push({ id: 'Rs7Td22nP', name: 'selected_fields', value: properties.selectedFields });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'submit_item_updating' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'MI7wgfkmX4',
        '305ba08e384b725dedbd768cf062eedffab0214ae088ee412d9dd75482846b58',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_submit_item_updating', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'MI7wgfkmX4',
        'all_items_interaction_click_submit_item_updating',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_submit_item_updating',
        eventProperties,
        'MI7wgfkmX4',
        '305ba08e384b725dedbd768cf062eedffab0214ae088ee412d9dd75482846b58',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'all_items_interaction_click_submit_item_updating',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickDownloadItemsProperties {
  selectAllSelected: boolean;
  fieldsSelected: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_download_items: Determine when the user downloaded a CSV file with the information about items
 *
 * When to trigger this event:
 * 1. Trigger when the "Download" was clicked (inside the "Download items")
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/0HcsrgTMM1/trigger/qCSCLls4u
 *
 * @param properties the properties associatied with this event
 * @param properties.selectAllSelected: Determines if 'Select all' was used
 * @param properties.fieldsSelected: If select_all_selected=False, this property should define all the field that user exported
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/0HcsrgTMM1}
 */
export function allItemsInteractionClickDownloadItems(properties: AllItemsInteractionClickDownloadItemsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'nph2B0tBC', name: 'select_all_selected', value: properties.selectAllSelected });
  eventPropertiesArray.push({ id: 'MWg5WOwYX', name: 'fields_selected', value: properties.fieldsSelected });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'download_items' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '0HcsrgTMM1',
        '1735e70725d711e9bb3ca8f7a90f0f84d28a7dc39f967259f00d9f80490cc465',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_download_items', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '0HcsrgTMM1',
        'all_items_interaction_click_download_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_download_items',
        eventProperties,
        '0HcsrgTMM1',
        '1735e70725d711e9bb3ca8f7a90f0f84d28a7dc39f967259f00d9f80490cc465',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_items_interaction_click_download_items', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickExportVersionsProperties {
  dateSelected: number;
  exportStatus: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_export_versions: Determines when the user exported (or tried to export) a past version of the menu
 *
 * When to trigger this event:
 * 1. Trigger when the "Export" button was clicked (inside the "Export pas versions of this menu as JSON")
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MQcUFXDjdP/trigger/NqK2O8abY
 *
 * @param properties the properties associatied with this event
 * @param properties.dateSelected: The date selected by user
 * @param properties.exportStatus: Was the export successful or not. If not, what message did the user receive
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MQcUFXDjdP}
 */
export function allItemsInteractionClickExportVersions(properties: AllItemsInteractionClickExportVersionsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'FRE0y-Mg4', name: 'date_selected', value: properties.dateSelected });
  eventPropertiesArray.push({ id: 'jNHg4W71D', name: 'export_status', value: properties.exportStatus });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'export_versions' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'MQcUFXDjdP',
        '57989a4c97a492333c2c1e58ee98c37e940e27846313841a26e0335533bee607',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_export_versions', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'MQcUFXDjdP',
        'all_items_interaction_click_export_versions',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_export_versions',
        eventProperties,
        'MQcUFXDjdP',
        '57989a4c97a492333c2c1e58ee98c37e940e27846313841a26e0335533bee607',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_items_interaction_click_export_versions', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickEditCategoryProperties {
  view: ViewValueType;
  categoryId: string;
  changedFields: string[];
  imageUploaded: boolean;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_edit_category: Determines when the used made some changes to the category name or the category description
 *
 * When to trigger this event:
 * 1. Trigger when "Edit category" and "Save" were clicked. (When the user clicked "Edit category", made some changes and saved them). Can be triggered from the "All items" view or from any of the categories views
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/qzhIQEJMg5/trigger/VZ6okHFCS
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.changedFields: Determines what fields were change by user
 * @param properties.imageUploaded: Describes if the user uploaded a new image
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/qzhIQEJMg5}
 */
export function interactionClickEditCategory(properties: InteractionClickEditCategoryProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({ id: 'G7EAKyPSs', name: 'changed_fields', value: properties.changedFields });
  eventPropertiesArray.push({ id: 'e_heUnfbc', name: 'image_uploaded', value: properties.imageUploaded });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'edit_category' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'qzhIQEJMg5',
        'f2720da6731c322d87e74e0ca9b3b963a058e437f63ba12f44ff0b30cd8879a8',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_edit_category', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'qzhIQEJMg5',
        'interaction_click_edit_category',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_edit_category',
        eventProperties,
        'qzhIQEJMg5',
        'f2720da6731c322d87e74e0ca9b3b963a058e437f63ba12f44ff0b30cd8879a8',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_edit_category', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickDeleteCategoryProperties {
  view: ViewValueType;
  categoryId: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_delete_category: Determines when the user deleted a category
 *
 * When to trigger this event:
 * 1. Trigger when the user deleted the category (clicked "Delete category", and then clicked "Yes"). Can be triggered from the "All items" view or from any of the categories views
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/P2P2wAFdkI/trigger/rBccbPy2t
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/P2P2wAFdkI}
 */
export function interactionClickDeleteCategory(properties: InteractionClickDeleteCategoryProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'delete_category' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'P2P2wAFdkI',
        '3e502a077a31f21c29e886be3802297732e28d052b8656acdffe38e16a91fcbb',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_delete_category', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'P2P2wAFdkI',
        'interaction_click_delete_category',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_delete_category',
        eventProperties,
        'P2P2wAFdkI',
        '3e502a077a31f21c29e886be3802297732e28d052b8656acdffe38e16a91fcbb',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_delete_category', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickImportItemsProperties {
  view: ViewValueType;
  categoryId: string;
  importStatus: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_import_items: Determines when the user tried to upload items by uploading a JSON file
 *
 * When to trigger this event:
 * 1. Trigger when "Submit" was clicked (can be triggered from the "All items" view or from any of the categories views)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Mq45xqk2nl/trigger/rvBSrraBe
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.importStatus: Determines if the import was successful. If not, provides the error message
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Mq45xqk2nl}
 */
export function interactionClickImportItems(properties: InteractionClickImportItemsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({ id: 'Kh0saahc4', name: 'import_status', value: properties.importStatus });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'import_items' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Mq45xqk2nl',
        '81f2e7a5ab518bc507272ef9b3fb02df75db1080cc4b63eedf8e6fe5a72bb37e',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_import_items', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Mq45xqk2nl',
        'interaction_click_import_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_import_items',
        eventProperties,
        'Mq45xqk2nl',
        '81f2e7a5ab518bc507272ef9b3fb02df75db1080cc4b63eedf8e6fe5a72bb37e',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_import_items', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickExportItemsProperties {
  view: ViewValueType;
  categoryId: string;
  exportStatus: string;
  triggeredFromSharedMenu: boolean;
  selectedItems: string[];
}
/**
 * interaction_click_export_items: Determines when the user exported some items from the category
 *
 * When to trigger this event:
 * 1. Trigger when "Export" was clicked. Can be triggered from the "All items" view or from any of the categories views
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/RvBJtLAd9Z/trigger/iDJVi_doJ
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.exportStatus: Was the export successful or not. If not, what message did the user receive
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 * @param properties.selectedItems: Items selected
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/RvBJtLAd9Z}
 */
export function interactionClickExportItems(properties: InteractionClickExportItemsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({ id: 'jNHg4W71D', name: 'export_status', value: properties.exportStatus });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'export_items' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'RvBJtLAd9Z',
        '8437ab2930999d058eb693cd151131caf2d93d204e192dd6ccbe3ccf786c5b03',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_export_items', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'RvBJtLAd9Z',
        'interaction_click_export_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_export_items',
        eventProperties,
        'RvBJtLAd9Z',
        '8437ab2930999d058eb693cd151131caf2d93d204e192dd6ccbe3ccf786c5b03',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_export_items', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickEnableItemsProperties {
  view: ViewValueType;
  categoryId: string;
  triggeredFromSharedMenu: boolean;
  selectedItems: string[];
}
/**
 * interaction_click_enable_items: Determines when the user enabled all the items inside the category
 *
 * When to trigger this event:
 * 1. Trigger when "Enable" was clicked. Can be triggered from the "All items" view or from any of the categories views
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/de80FVccwg/trigger/JMSKouwaN
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 * @param properties.selectedItems: Items selected
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/de80FVccwg}
 */
export function interactionClickEnableItems(properties: InteractionClickEnableItemsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'enable_items' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'de80FVccwg',
        '5eacf947ae8c22aef5492c5d3c55b51d0fa7be2cea2c4cd6909081513ab74503',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_enable_items', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'de80FVccwg',
        'interaction_click_enable_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_enable_items',
        eventProperties,
        'de80FVccwg',
        '5eacf947ae8c22aef5492c5d3c55b51d0fa7be2cea2c4cd6909081513ab74503',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_enable_items', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickDisableItemsProperties {
  view: ViewValueType;
  categoryId: string;
  triggeredFromSharedMenu: boolean;
  selectedItems: string[];
}
/**
 * interaction_click_disable_items: Determines when the user disabled all the items inside the category
 *
 * When to trigger this event:
 * 1. Trigger when "Disable" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/qNdbVxnmUr/trigger/il4GnICg8
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 * @param properties.selectedItems: Items selected
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/qNdbVxnmUr}
 */
export function interactionClickDisableItems(properties: InteractionClickDisableItemsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'disable_items' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'qNdbVxnmUr',
        'f20bcab7a0a131c5fb3ab1c5a8e31f5512f0f1fd0a83974f7d228950b178c884',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_disable_items', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'qNdbVxnmUr',
        'interaction_click_disable_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_disable_items',
        eventProperties,
        'qNdbVxnmUr',
        'f20bcab7a0a131c5fb3ab1c5a8e31f5512f0f1fd0a83974f7d228950b178c884',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_disable_items', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickCreateItemCopyProperties {
  view: ViewValueType;
  changedFields: string[];
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_create_item_copy: Determines when the user created an item's copy
 *
 * When to trigger this event:
 * 1. Trigger when the user clicked the "Create a copy" near the item, and then clicked the "Save" after editing it
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/1OLh9Rk5fl/trigger/bzr_k8W4P
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.changedFields: Determines what fields were change by user
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/1OLh9Rk5fl}
 */
export function interactionClickCreateItemCopy(properties: InteractionClickCreateItemCopyProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'G7EAKyPSs', name: 'changed_fields', value: properties.changedFields });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'create_item_copy' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '1OLh9Rk5fl',
        '15669347f6d7b592b1e9e20520151d77840cf3f3cdae6fed9a66348ab5fc16da',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_create_item_copy', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '1OLh9Rk5fl',
        'interaction_click_create_item_copy',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_create_item_copy',
        eventProperties,
        '1OLh9Rk5fl',
        '15669347f6d7b592b1e9e20520151d77840cf3f3cdae6fed9a66348ab5fc16da',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_create_item_copy', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickCreateSpecialProperties {
  view: ViewValueType;
  changedFields: string[];
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_create_special: Determines when the user created a special from the item
 *
 * When to trigger this event:
 * 1. Trigger when the user clicked the "Create special", and then saved the item
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/W3K4KLd9hH/trigger/8woSnY7Rs
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.changedFields: Determines what fields were change by user
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/W3K4KLd9hH}
 */
export function interactionClickCreateSpecial(properties: InteractionClickCreateSpecialProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'G7EAKyPSs', name: 'changed_fields', value: properties.changedFields });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'create_special' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'W3K4KLd9hH',
        '078630fe2d207434bf37afee2162aa01405a66a3f8a0079cee0e0f1060b9186c',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_create_special', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'W3K4KLd9hH',
        'interaction_click_create_special',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_create_special',
        eventProperties,
        'W3K4KLd9hH',
        '078630fe2d207434bf37afee2162aa01405a66a3f8a0079cee0e0f1060b9186c',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_create_special', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickDisableItemProperties {
  view: ViewValueType;
  itemId: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_disable_item: Determines when the user disabled the item
 *
 * When to trigger this event:
 * 1. Trigger when "Disable" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/TpAh10TKJ9/trigger/V1vmyiPUg
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.itemId: Item unique id
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/TpAh10TKJ9}
 */
export function interactionClickDisableItem(properties: InteractionClickDisableItemProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'xQWzY_yOa', name: 'item_id', value: properties.itemId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'disable_item' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'TpAh10TKJ9',
        'dc1541734d3c1a04e21f77845b33690f92939fa1cba843bdde0f97e392499840',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_disable_item', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'TpAh10TKJ9',
        'interaction_click_disable_item',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_disable_item',
        eventProperties,
        'TpAh10TKJ9',
        'dc1541734d3c1a04e21f77845b33690f92939fa1cba843bdde0f97e392499840',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_disable_item', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickEnableItemProperties {
  view: ViewValueType;
  itemId: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_enable_item: Determines if the user enabled the item
 *
 * When to trigger this event:
 * 1. trigger when the user clicked the "Enable"
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/oQ6nv4djrj/trigger/H51U7lbCz
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.itemId: Item unique id
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/oQ6nv4djrj}
 */
export function interactionClickEnableItem(properties: InteractionClickEnableItemProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'xQWzY_yOa', name: 'item_id', value: properties.itemId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'enable_item' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'oQ6nv4djrj',
        'c8f1d93e740be18219891f41e8c9c7d7faf5f618f95bcfa8ccbb5868919e5617',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_enable_item', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'oQ6nv4djrj',
        'interaction_click_enable_item',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_enable_item',
        eventProperties,
        'oQ6nv4djrj',
        'c8f1d93e740be18219891f41e8c9c7d7faf5f618f95bcfa8ccbb5868919e5617',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_enable_item', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickDeleteItemProperties {
  view: ViewValueType;
  itemId: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_delete_item: Determines if the user deleted the item
 *
 * When to trigger this event:
 * 1. Trigger when the "Delete item" was clicked, and "Yes" was clicked then (the item was deleted)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/HGALGC6OIJ/trigger/BuD5901sC
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.itemId: Item unique id
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/HGALGC6OIJ}
 */
export function interactionClickDeleteItem(properties: InteractionClickDeleteItemProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'xQWzY_yOa', name: 'item_id', value: properties.itemId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'delete_item' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'HGALGC6OIJ',
        '6aa64773e7d0b63ac5829ed0644f43488415bac2468a1a1f99cc2cf65e80ad77',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_delete_item', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'HGALGC6OIJ',
        'interaction_click_delete_item',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_delete_item',
        eventProperties,
        'HGALGC6OIJ',
        '6aa64773e7d0b63ac5829ed0644f43488415bac2468a1a1f99cc2cf65e80ad77',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_delete_item', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickRemoveItemFromCategoryProperties {
  view: ViewValueType;
  itemId: string;
  categoryId: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_remove_item_from_category: Determines if the user removed the item from the category
 *
 * When to trigger this event:
 * 1. Trigger when "Remove from category" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/GnvU7Hqk-u/trigger/HUeqRIEkm
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.itemId: Item unique id
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/GnvU7Hqk-u}
 */
export function interactionClickRemoveItemFromCategory(properties: InteractionClickRemoveItemFromCategoryProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'xQWzY_yOa', name: 'item_id', value: properties.itemId });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'remove_item_from_category' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'GnvU7Hqk-u',
        'a1fadfaf2fe671468979f90aa13aafc80bdb20b30c5437aaac61ed9cbea1b2f4',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_remove_item_from_category', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'GnvU7Hqk-u',
        'interaction_click_remove_item_from_category',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_remove_item_from_category',
        eventProperties,
        'GnvU7Hqk-u',
        'a1fadfaf2fe671468979f90aa13aafc80bdb20b30c5437aaac61ed9cbea1b2f4',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_remove_item_from_category', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickSaveNewOptionProperties {
  view: ViewValueType;
  optionId: string;
  changedFields: string[];
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_save_new_option: Determines when the user created a new option
 *
 * When to trigger this event:
 * 1. Trigger when a new option was created and added ("Create option" was clicked)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/67C0L95O38/trigger/ApHT-I9YI
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.optionId: ID of the item options section available in item bottom sheet / card
 * @param properties.changedFields: Determines what fields were change by user
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/67C0L95O38}
 */
export function interactionClickSaveNewOption(properties: InteractionClickSaveNewOptionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'Gh5yBexKN', name: 'option_id', value: properties.optionId });
  eventPropertiesArray.push({ id: 'G7EAKyPSs', name: 'changed_fields', value: properties.changedFields });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'save_new_option' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '67C0L95O38',
        '00e4edfcf0ebc32aa320f09d7d50c0494d1aed9e0e39628e230afed4e36cb4f3',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_save_new_option', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '67C0L95O38',
        'interaction_click_save_new_option',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_save_new_option',
        eventProperties,
        '67C0L95O38',
        '00e4edfcf0ebc32aa320f09d7d50c0494d1aed9e0e39628e230afed4e36cb4f3',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_save_new_option', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickSaveItemChangesProperties {
  view: ViewValueType;
  itemId: string;
  mandatoryWarningsSelected: string;
  imageUploaded: boolean;
  changedFields: string[];
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_save_item_changes: Determines when the used made some changes to the item and saved them
 *
 * When to trigger this event:
 * 1. Trigger when the user clicked "Save" inside the item editor
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/IZ8lT6FnY9/trigger/nPtbzBY5D
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.itemId: Item unique id
 * @param properties.mandatoryWarningsSelected: Describes which mandatory warnings were selected
 * @param properties.imageUploaded: Describes if the user uploaded a new image
 * @param properties.changedFields: Determines what fields were change by user
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/IZ8lT6FnY9}
 */
export function interactionClickSaveItemChanges(properties: InteractionClickSaveItemChangesProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'xQWzY_yOa', name: 'item_id', value: properties.itemId });
  eventPropertiesArray.push({
    id: 'HmY1ZFxlv',
    name: 'mandatory_warnings_selected',
    value: properties.mandatoryWarningsSelected,
  });
  eventPropertiesArray.push({ id: 'e_heUnfbc', name: 'image_uploaded', value: properties.imageUploaded });
  eventPropertiesArray.push({ id: 'G7EAKyPSs', name: 'changed_fields', value: properties.changedFields });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'save_item_changes' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'IZ8lT6FnY9',
        '8c37aa5678a51a13b3db9ea1207f5ff6f1670dea2df9b2453d284982f77cff18',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_save_item_changes', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'IZ8lT6FnY9',
        'interaction_click_save_item_changes',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_save_item_changes',
        eventProperties,
        'IZ8lT6FnY9',
        '8c37aa5678a51a13b3db9ea1207f5ff6f1670dea2df9b2453d284982f77cff18',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_save_item_changes', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickSaveNewItemProperties {
  view: ViewValueType;
  itemId: string;
  mandatoryWarningsSelected: string;
  imageUploaded: boolean;
  changedFields: string[];
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_save_new_item: Determines when the user created a new item and saved it
 *
 * When to trigger this event:
 * 1. Trigger when "Save" was clicked and a new item was created
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/vmrsj0i6z1/trigger/ZUUkzWnE4
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.itemId: Item unique id
 * @param properties.mandatoryWarningsSelected: Describes which mandatory warnings were selected
 * @param properties.imageUploaded: Describes if the user uploaded a new image
 * @param properties.changedFields: Determines what fields were change by user
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/vmrsj0i6z1}
 */
export function interactionClickSaveNewItem(properties: InteractionClickSaveNewItemProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'xQWzY_yOa', name: 'item_id', value: properties.itemId });
  eventPropertiesArray.push({
    id: 'HmY1ZFxlv',
    name: 'mandatory_warnings_selected',
    value: properties.mandatoryWarningsSelected,
  });
  eventPropertiesArray.push({ id: 'e_heUnfbc', name: 'image_uploaded', value: properties.imageUploaded });
  eventPropertiesArray.push({ id: 'G7EAKyPSs', name: 'changed_fields', value: properties.changedFields });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'save_new_item' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'vmrsj0i6z1',
        'b1fc43f3ab48a9640e2543462e12aa58001e0cf478a58aa04fab740af7fb2249',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_save_new_item', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'vmrsj0i6z1',
        'interaction_click_save_new_item',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_save_new_item',
        eventProperties,
        'vmrsj0i6z1',
        'b1fc43f3ab48a9640e2543462e12aa58001e0cf478a58aa04fab740af7fb2249',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_save_new_item', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickAddNewCategoryProperties {
  view: ViewValueType;
  categoriesAdded: string;
  imageUploaded: boolean;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_add_new_category: Determines when the user created a new category
 *
 * When to trigger this event:
 * 1. Trigger when a new category was added and saved ("Add category" was clicked, and "Save" was clicked then)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/8X-QKA40Sn/trigger/FxiYXLiXm
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.categoriesAdded: Added categories: category_id and category_name for each added category
 * @param properties.imageUploaded: Describes if the user uploaded a new image
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/8X-QKA40Sn}
 */
export function interactionClickAddNewCategory(properties: InteractionClickAddNewCategoryProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'OTfNdoiEO', name: 'categories_added', value: properties.categoriesAdded });
  eventPropertiesArray.push({ id: 'e_heUnfbc', name: 'image_uploaded', value: properties.imageUploaded });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'add_new_category' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '8X-QKA40Sn',
        'feb0b5934af0e020d375487df87e0092310dfa071b536d59179211897f25e099',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_add_new_category', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '8X-QKA40Sn',
        'interaction_click_add_new_category',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_add_new_category',
        eventProperties,
        '8X-QKA40Sn',
        'feb0b5934af0e020d375487df87e0092310dfa071b536d59179211897f25e099',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_add_new_category', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickViewOnWoltProperties {
  view: ViewValueType;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_view_on_wolt: Determines if the user viewed the menu on wolt.com
 *
 * When to trigger this event:
 * 1. Trigger when "View on Wolt.com" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/RKAl6yScVM/trigger/D9qF7IfDN
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/RKAl6yScVM}
 */
export function interactionClickViewOnWolt(properties: InteractionClickViewOnWoltProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'view_on_wolt' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'RKAl6yScVM',
        '496eb1e05c9d083aa98cf1600b17288be0f86c0b02708c3182cd3c7e3b12847d',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_view_on_wolt', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'RKAl6yScVM',
        'interaction_click_view_on_wolt',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_view_on_wolt',
        eventProperties,
        'RKAl6yScVM',
        '496eb1e05c9d083aa98cf1600b17288be0f86c0b02708c3182cd3c7e3b12847d',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_view_on_wolt', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsViewProperties {
  durationMs: number;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_view: Tracks the active time spend on the "All items" view
 *
 * When to trigger this event:
 * 1. Trigger when the "All items" view was opened
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/LWl9fS8hu-/trigger/xhDxobqmM
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/LWl9fS8hu-}
 */
export function allItemsView(properties: AllItemsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'LWl9fS8hu-',
        '95349ea785aa5a6dbada43f2113f17f3f4b4f11af2c41abd29bc6bece8b9dcd6',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('LWl9fS8hu-', 'all_items_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_view',
        eventProperties,
        'LWl9fS8hu-',
        '95349ea785aa5a6dbada43f2113f17f3f4b4f11af2c41abd29bc6bece8b9dcd6',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_items_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllOptionsViewProperties {
  durationMs: number;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_options_view: Tracks the active time spend on the "All options" view
 *
 * When to trigger this event:
 * 1. Trigger when the "All options" view was opened
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/G8G82BkHtGe/trigger/9_ZXxc_HL
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/G8G82BkHtGe}
 */
export function allOptionsView(properties: AllOptionsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_options' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'G8G82BkHtGe',
        'c2c0b3c5f8dc9d2706fd04ea4b54f61882470b6e7e0e93b95b13dcee53f3225f',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_options_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('G8G82BkHtGe', 'all_options_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_options_view',
        eventProperties,
        'G8G82BkHtGe',
        'c2c0b3c5f8dc9d2706fd04ea4b54f61882470b6e7e0e93b95b13dcee53f3225f',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_options_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllDisabledViewProperties {
  durationMs: number;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_disabled_view: Tracks the active time spend on the "All disabled" view
 *
 * When to trigger this event:
 * 1. Trigger when the "All disabled" view was opened
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/fOpd1dnAPz/trigger/vUdIMC8e-
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/fOpd1dnAPz}
 */
export function allDisabledView(properties: AllDisabledViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_disabled' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'fOpd1dnAPz',
        '123d9cc54c1e509e9f63e7eeaab5261d04f885d0a22325d1b14dcc2aac8c648c',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_disabled_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('fOpd1dnAPz', 'all_disabled_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_disabled_view',
        eventProperties,
        'fOpd1dnAPz',
        '123d9cc54c1e509e9f63e7eeaab5261d04f885d0a22325d1b14dcc2aac8c648c',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('all_disabled_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ItemsNoCategoryViewProperties {
  durationMs: number;
  triggeredFromSharedMenu: boolean;
}
/**
 * items_no_category_view: Tracks the time spend at the "Items with no category" view
 *
 * When to trigger this event:
 * 1. Trigger when the "Item with no category" view was opened
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/DAhKgI69VG/trigger/SXt9u7GPc
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/DAhKgI69VG}
 */
export function itemsNoCategoryView(properties: ItemsNoCategoryViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'items_no_category' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'DAhKgI69VG',
        'ed722b5c1e5ee3a14e3638a6e7dee5d0a7a1d0d90554001339f3c637baf80dde',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('items_no_category_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'DAhKgI69VG',
        'items_no_category_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'items_no_category_view',
        eventProperties,
        'DAhKgI69VG',
        'ed722b5c1e5ee3a14e3638a6e7dee5d0a7a1d0d90554001339f3c637baf80dde',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('items_no_category_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CategoriesViewProperties {
  durationMs: number;
  categoryId: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * categories_view: Track the time spend at different categories' views
 *
 * When to trigger this event:
 * 1. Trigger when the view of any category was opened (under the "Categories" tab)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/9r9HH-sfUV/trigger/tIqA-oMYN
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/9r9HH-sfUV}
 */
export function categoriesView(properties: CategoriesViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'categories' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '9r9HH-sfUV',
        'd75db4605ee6ed81dea9889a9d9a14266bcdbcf2517ffda7d0a4c5744bc3bd26',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('categories_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('9r9HH-sfUV', 'categories_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'categories_view',
        eventProperties,
        '9r9HH-sfUV',
        'd75db4605ee6ed81dea9889a9d9a14266bcdbcf2517ffda7d0a4c5744bc3bd26',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('categories_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickEnableOrDisableProperties {
  view: ViewValueType;
  selectedItems: string[];
  disableItems: boolean;
  enableItems: boolean;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_enable_or_disable: Determines when the user enabled or disabled the items using the bulk at the top of the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when "Enable / disable" at the top of the menu editor was clicked AND enabling was completed further ("Enable" was clicked)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/K6kgsvU4_/trigger/qazDVO-co
 * 2. Trigger when "Enable / disable" at the top of the menu editor was clicked AND disabling was completed further ("Disable" was clicked)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/K6kgsvU4_/trigger/_WYK4dZNp
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.disableItems: Determines if the user disabled items
 * @param properties.enableItems: Determines if the user enabled items
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/K6kgsvU4_}
 */
export function interactionClickEnableOrDisable(properties: InteractionClickEnableOrDisableProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: 'aCY5k6DpF', name: 'disable_items', value: properties.disableItems });
  eventPropertiesArray.push({ id: '57zYslnmG', name: 'enable_items', value: properties.enableItems });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'enable_or_disable' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'K6kgsvU4_',
        '10cbc133d897037803d4d161470727933e3f9bf8041bb34aebf3b3ed7a29319b',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_enable_or_disable', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'K6kgsvU4_',
        'interaction_click_enable_or_disable',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_enable_or_disable',
        eventProperties,
        'K6kgsvU4_',
        '10cbc133d897037803d4d161470727933e3f9bf8041bb34aebf3b3ed7a29319b',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_enable_or_disable', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickSetAvailabilityProperties {
  view: ViewValueType;
  selectedAvailability: string;
  selectedVisibility: string;
  selectedItems: string[];
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_set_availability: Determines when the user set items availability using the bulks at the top of the item editor
 *
 * When to trigger this event:
 * 1. Trigger when "Set availability and visibility" was clicked AND "Save" was clicked then
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MYPIE1Ipsz/trigger/9VZ5p1cLp
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedAvailability: Availability that user selected (according to the opening hours / manual with days and etc)
 * @param properties.selectedVisibility: Visibility that user selected (according to the opening hours / manual with days and etc)
 * @param properties.selectedItems: Items selected
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MYPIE1Ipsz}
 */
export function interactionClickSetAvailability(properties: InteractionClickSetAvailabilityProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'qPrh2B__O', name: 'selected_availability', value: properties.selectedAvailability });
  eventPropertiesArray.push({ id: 'GdH9EsHMw', name: 'selected_visibility', value: properties.selectedVisibility });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'set_availability' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'MYPIE1Ipsz',
        'a10a9282f926d4294aca9e6677ff22087ca7e0ab8d49cd439f8881d92754d209',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_set_availability', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'MYPIE1Ipsz',
        'interaction_click_set_availability',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_set_availability',
        eventProperties,
        'MYPIE1Ipsz',
        'a10a9282f926d4294aca9e6677ff22087ca7e0ab8d49cd439f8881d92754d209',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_set_availability', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickChangeStockAvailabilityProperties {
  view: ViewValueType;
  selectedItems: string[];
  markedOutOfStock: boolean;
  markedInStock: boolean;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_change_stock_availability: Determines when the user changes items' availability using the bulk at the top of the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when "Mark out of stock" or "Mark in stock" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/AkRqptQ7AB/trigger/cDEvJLIFD
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.markedOutOfStock: Determines if the user marked items out of stock
 * @param properties.markedInStock: Determines if the user marked items in stock
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/AkRqptQ7AB}
 */
export function interactionClickChangeStockAvailability(properties: InteractionClickChangeStockAvailabilityProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: 'dPO_jkGYF', name: 'marked_out_of_stock', value: properties.markedOutOfStock });
  eventPropertiesArray.push({ id: 'Z1-Oi5mEM', name: 'marked_in_stock', value: properties.markedInStock });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'change_stock_availability' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'AkRqptQ7AB',
        '2cd4e6cbbeb736e81913de77359c63440f037f91856c3a1eec1ee34cd78b2cda',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_change_stock_availability', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'AkRqptQ7AB',
        'interaction_click_change_stock_availability',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_change_stock_availability',
        eventProperties,
        'AkRqptQ7AB',
        '2cd4e6cbbeb736e81913de77359c63440f037f91856c3a1eec1ee34cd78b2cda',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_change_stock_availability', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickChangePriceProperties {
  view: ViewValueType;
  selectedItems: string[];
  priceChangingType: string;
  priceChangingAmount: string;
  priceChangingDirection: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_change_price: Determines when the user changed item prices using the bulk at the top of the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when "Save" was clicked (after "Change price" was clicked)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ZqPbqx1n2S/trigger/tb9lD5Ru-
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.priceChangingType: 'Single price for all items', 'Change price by amount', or 'Change price by %'
 * @param properties.priceChangingAmount: The amount entered by the user
 * @param properties.priceChangingDirection: Addition or deduction
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ZqPbqx1n2S}
 */
export function interactionClickChangePrice(properties: InteractionClickChangePriceProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: 'NjIPVhNow', name: 'price_changing_type', value: properties.priceChangingType });
  eventPropertiesArray.push({ id: 'ghV1gFCJs', name: 'price_changing_amount', value: properties.priceChangingAmount });
  eventPropertiesArray.push({
    id: '4h9GkNLsb',
    name: 'price_changing_direction',
    value: properties.priceChangingDirection,
  });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'change_price' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ZqPbqx1n2S',
        'ad234c7abf601c8623c7b9feebd16bd391749d6aeaa6b0d6bf26352f68e531fd',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_change_price', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ZqPbqx1n2S',
        'interaction_click_change_price',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_change_price',
        eventProperties,
        'ZqPbqx1n2S',
        'ad234c7abf601c8623c7b9feebd16bd391749d6aeaa6b0d6bf26352f68e531fd',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_change_price', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickSetCourierRestrictionsProperties {
  view: ViewValueType;
  selectedItems: string[];
  restrictionSelected: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_set_courier_restrictions: Determines when the user changed courier restrictions
 *
 * When to trigger this event:
 * 1. Trigger when "Save" was clicked and bike delivery was disabled using the bulk at the top of the menu editor
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Xl_LFV9-iD/trigger/C2FAvb-X8
 * 2. Trigger when "Save" was clicked and car delivery was disabled using the bulk at the top of the menu editor
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Xl_LFV9-iD/trigger/WZUAPX6f1
 * 3. Trigger when "Save" was clicked and motorcycle delivery was disabled using the bulk at the top of the menu editor
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Xl_LFV9-iD/trigger/E_zaosipm
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.restrictionSelected: Describes the courier restriction selected by user: 'Disable bike delivery', 'Disable car delivery', or 'Disable motorcycle delivery'
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Xl_LFV9-iD}
 */
export function interactionClickSetCourierRestrictions(properties: InteractionClickSetCourierRestrictionsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: '88kDAsJbC', name: 'restriction_selected', value: properties.restrictionSelected });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'set_courier_restrictions' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Xl_LFV9-iD',
        '91fd3162296150d8ca386d39fa985baebbe74a730e00ab9e9d04a2bbbb090195',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_set_courier_restrictions', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Xl_LFV9-iD',
        'interaction_click_set_courier_restrictions',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_set_courier_restrictions',
        eventProperties,
        'Xl_LFV9-iD',
        '91fd3162296150d8ca386d39fa985baebbe74a730e00ab9e9d04a2bbbb090195',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_set_courier_restrictions', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickAddOptionsProperties {
  view: ViewValueType;
  selectedItems: string[];
  optionsSelected: string[];
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_add_options: Determines when the user added option to the item using the bulk at the top of the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when "Done" was clicked (after clicking the "Add options" at the top of the menu editor)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ODzOTM1MmZ/trigger/KKs7SQ7mZ
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.optionsSelected: Selected option ids
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ODzOTM1MmZ}
 */
export function interactionClickAddOptions(properties: InteractionClickAddOptionsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: 'QQFbfDkAJ', name: 'options_selected', value: properties.optionsSelected });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'add_options' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ODzOTM1MmZ',
        '7656e14026fb36e261ceb1bf3bb2f44b2d0f8aec96a4cea7f7f2760cefa4c1a9',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_add_options', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ODzOTM1MmZ',
        'interaction_click_add_options',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_add_options',
        eventProperties,
        'ODzOTM1MmZ',
        '7656e14026fb36e261ceb1bf3bb2f44b2d0f8aec96a4cea7f7f2760cefa4c1a9',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_add_options', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickChangeCategoryProperties {
  view: ViewValueType;
  selectedItems: string[];
  categoryId: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_change_category: Determine when the user changed items category using the bulk at the top of the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when "Save" was clicked (after clicking "Change category" at the top of the menu editor)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/2eB4d4MrGM/trigger/zmWKTQhaV
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/2eB4d4MrGM}
 */
export function interactionClickChangeCategory(properties: InteractionClickChangeCategoryProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'change_category' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '2eB4d4MrGM',
        'be0b189b3cf4cd9d17dbeaec4efdb730087825d20ed293924bbab45ce0786f92',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_change_category', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '2eB4d4MrGM',
        'interaction_click_change_category',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_change_category',
        eventProperties,
        '2eB4d4MrGM',
        'be0b189b3cf4cd9d17dbeaec4efdb730087825d20ed293924bbab45ce0786f92',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_change_category', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickChangeCommissionsProperties {
  view: ViewValueType;
  selectedItems: string[];
  woltDeliveryCommission: string;
  takeawayComission: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_change_commissions: Determines when the user changes item commissions using the bulk at the top of the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when "Save" was clicked (after clicking "Change commissions" at the top of the menu editor)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/gx_E7_QOJm/trigger/bquXuEAjD
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.woltDeliveryCommission: None or wolt delivery commission that user set
 * @param properties.takeawayComission: None or takeaway commission that user set
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/gx_E7_QOJm}
 */
export function interactionClickChangeCommissions(properties: InteractionClickChangeCommissionsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({
    id: 'ljqAFwtEE',
    name: 'wolt_delivery_commission',
    value: properties.woltDeliveryCommission,
  });
  eventPropertiesArray.push({ id: 'HhGp1w4UD', name: 'takeaway_comission', value: properties.takeawayComission });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'change_commissions' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'gx_E7_QOJm',
        'a12fb2f5229c28bcad9e1d1387a36c606e1abda1e88d74757e3ad46708b8b5eb',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_change_commissions', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'gx_E7_QOJm',
        'interaction_click_change_commissions',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_change_commissions',
        eventProperties,
        'gx_E7_QOJm',
        'a12fb2f5229c28bcad9e1d1387a36c606e1abda1e88d74757e3ad46708b8b5eb',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_change_commissions', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickChangeVatProperties {
  view: ViewValueType;
  selectedItems: string[];
  vatAmountEntered: number;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_change_vat: Determines when the user changed vat using the bulk at the top of the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when "Save" was clicked (after clicking the "Change VAT")
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/oTrhd_3qn-/trigger/cMmPNINfb
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.vatAmountEntered: VAT entered by user
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/oTrhd_3qn-}
 */
export function interactionClickChangeVat(properties: InteractionClickChangeVatProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({ id: '6fAOvtgNM', name: 'vat_amount_entered', value: properties.vatAmountEntered });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'change_vat' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'oTrhd_3qn-',
        '762e50877fb8d77c9553efe245f68556a6fe16386a42eea8a165beb24fb19748',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_change_vat', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'oTrhd_3qn-',
        'interaction_click_change_vat',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_change_vat',
        eventProperties,
        'oTrhd_3qn-',
        '762e50877fb8d77c9553efe245f68556a6fe16386a42eea8a165beb24fb19748',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_change_vat', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickCreateWoltSpecialsProperties {
  view: ViewValueType;
  selectedItems: string[];
  woltSpecialSettings: WoltSpecialSettings;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_create_wolt_specials: Determines when the user created wolt specials using the bulk at the top of the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when "Save" was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/uFCsXWeHVp/trigger/hXLZBZGAd
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.woltSpecialSettings: Describes the setting user set while creating wolt special items
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/uFCsXWeHVp}
 */
export function interactionClickCreateWoltSpecials(properties: InteractionClickCreateWoltSpecialsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({
    id: 'oY3fg8owt',
    name: 'wolt_special_settings',
    value: {
      discount_amount: properties.woltSpecialSettings.discountAmount,
      start_date_selected: properties.woltSpecialSettings.startDateSelected,
      end_date_selected: properties.woltSpecialSettings.endDateSelected,
      first_time_customers: properties.woltSpecialSettings.firstTimeCustomers,
    },
  });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'create_wolt_specials' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertWoltSpecialSettings(properties.woltSpecialSettings));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'uFCsXWeHVp',
        '499da577cf75c4c8f7b430d075fa44a3bdfae031be338c89a4f1742c6fe66204',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_create_wolt_specials', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'uFCsXWeHVp',
        'interaction_click_create_wolt_specials',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'interaction_click_create_wolt_specials': " + messages[0]!.message);
      }
    } else {
      messages.forEach(function (m) {
        console[__REPORT_FAILURE_AS__ || 'error']('[avo] ' + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_create_wolt_specials',
        eventProperties,
        'uFCsXWeHVp',
        '499da577cf75c4c8f7b430d075fa44a3bdfae031be338c89a4f1742c6fe66204',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_create_wolt_specials', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickDeleteItemsProperties {
  view: ViewValueType;
  selectedItems: string[];
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_delete_items: Determines when the user deleted items using the bulk at the top of the menu editor
 *
 * When to trigger this event:
 * 1. Trigger when "Delete items" was clicked (after clicking the "Delete items" at the top of the menu editor)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/sZagQ7RuVa/trigger/oUeUc3Olb
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.selectedItems: Items selected
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/sZagQ7RuVa}
 */
export function interactionClickDeleteItems(properties: InteractionClickDeleteItemsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '1eGpeDbea', name: 'selected_items', value: properties.selectedItems });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'delete_items' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'sZagQ7RuVa',
        'd8c5cf84e314b2c840de90ba96fd468d32fce113eda39e933a42211cc46eff2c',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_delete_items', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'sZagQ7RuVa',
        'interaction_click_delete_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_delete_items',
        eventProperties,
        'sZagQ7RuVa',
        'd8c5cf84e314b2c840de90ba96fd468d32fce113eda39e933a42211cc46eff2c',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_delete_items', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickCreateSelectFileProperties {
  importStatus: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_create_select_file: Determines when the user selected a CSV file to upload items
 *
 * When to trigger this event:
 * 1. Trigger when "Select a CSV file or drop if here" was clicked AND file was selected (or dropped)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/sy-R2XLvTu/trigger/j_-UOpvbf
 *
 * @param properties the properties associatied with this event
 * @param properties.importStatus: Determines if the import was successful. If not, provides the error message
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/sy-R2XLvTu}
 */
export function allItemsInteractionClickCreateSelectFile(
  properties: AllItemsInteractionClickCreateSelectFileProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Kh0saahc4', name: 'import_status', value: properties.importStatus });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'create_select_file' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'sy-R2XLvTu',
        '579ea780e0e248301c972ea6ddf1878eb91b186a0548e404d7f09cd4e312828b',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_create_select_file', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'sy-R2XLvTu',
        'all_items_interaction_click_create_select_file',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_create_select_file',
        eventProperties,
        'sy-R2XLvTu',
        '579ea780e0e248301c972ea6ddf1878eb91b186a0548e404d7f09cd4e312828b',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'all_items_interaction_click_create_select_file',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickUpdateSelectFileProperties {
  importStatus: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_update_select_file: Determines when the user selected a CSV file to update images
 *
 * When to trigger this event:
 * 1. Trigger when "Select a CSV file or drop it here" was clicked AND the file was selected (or dropped)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/oV5OQiCPQ1/trigger/33AzDl75c
 *
 * @param properties the properties associatied with this event
 * @param properties.importStatus: Determines if the import was successful. If not, provides the error message
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/oV5OQiCPQ1}
 */
export function allItemsInteractionClickUpdateSelectFile(
  properties: AllItemsInteractionClickUpdateSelectFileProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Kh0saahc4', name: 'import_status', value: properties.importStatus });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'update_select_file' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'oV5OQiCPQ1',
        '266a71d73a590946c13628e1d27148df60e6747db71e182a6a5a492b5852b807',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_update_select_file', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'oV5OQiCPQ1',
        'all_items_interaction_click_update_select_file',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_update_select_file',
        eventProperties,
        'oV5OQiCPQ1',
        '266a71d73a590946c13628e1d27148df60e6747db71e182a6a5a492b5852b807',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'all_items_interaction_click_update_select_file',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface InteractionClickAddSubcategoriesProperties {
  view: ViewValueType;
  categoryId: string;
  subcategoriesAdded: string[];
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_add_subcategories: Determines when the user added subcategories
 *
 * When to trigger this event:
 * 1. Trigger when new subcategories were entered and "Save" was clicked (after clicking "Add subcategories" inside the menu editor)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/-HJaHZ0ITm/trigger/klslfpJEW
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 * @param properties.subcategoriesAdded: Describer all the subcategories that were added
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/-HJaHZ0ITm}
 */
export function interactionClickAddSubcategories(properties: InteractionClickAddSubcategoriesProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({ id: '3X-bKw55e', name: 'subcategories_added', value: properties.subcategoriesAdded });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'add_subcategories' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '-HJaHZ0ITm',
        'ce86347bb9548f5b49b2f0c98f271066a992a3c7beac6896b648cda77ae4bb1a',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_add_subcategories', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '-HJaHZ0ITm',
        'interaction_click_add_subcategories',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_add_subcategories',
        eventProperties,
        '-HJaHZ0ITm',
        'ce86347bb9548f5b49b2f0c98f271066a992a3c7beac6896b648cda77ae4bb1a',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_add_subcategories', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickMenuImportSelectFileProperties {
  importStatus: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * all_items_interaction_click_menu_import_select_file: Determines when the user tried to upload a file to import the menu
 *
 * When to trigger this event:
 * 1. Trigger when "Select a JSON file or drop it here" was clicked and the file was uploaded (or dropped)
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/YbpPqyPtxk/trigger/tTNPHK32o
 *
 * @param properties the properties associatied with this event
 * @param properties.importStatus: Determines if the import was successful. If not, provides the error message
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/YbpPqyPtxk}
 */
export function allItemsInteractionClickMenuImportSelectFile(
  properties: AllItemsInteractionClickMenuImportSelectFileProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Kh0saahc4', name: 'import_status', value: properties.importStatus });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'menu_import_select_file' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: false });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'YbpPqyPtxk',
        '553cde4caa3cbe4f0815ce624b9d563212f013213ef5ad9547c91292347af0d8',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'all_items_interaction_click_menu_import_select_file',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'YbpPqyPtxk',
        'all_items_interaction_click_menu_import_select_file',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_menu_import_select_file',
        eventProperties,
        'YbpPqyPtxk',
        '553cde4caa3cbe4f0815ce624b9d563212f013213ef5ad9547c91292347af0d8',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'all_items_interaction_click_menu_import_select_file',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface InteractionClickEditOptionProperties {
  view: ViewValueType;
  changedFields: string[];
  optionId: string;
  triggeredFromSharedMenu: boolean;
}
/**
 * interaction_click_edit_option: Describes if the user edited the option
 *
 * When to trigger this event:
 * 1. Trigger when the option was edited and the "Save" button was clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/j2gVDLvyMZ/trigger/F1CUnwpmS
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.changedFields: Determines what fields were change by user
 * @param properties.optionId: ID of the item options section available in item bottom sheet / card
 * @param properties.triggeredFromSharedMenu: Describes if the event was triggered from the Shared Menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/j2gVDLvyMZ}
 */
export function interactionClickEditOption(properties: InteractionClickEditOptionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'G7EAKyPSs', name: 'changed_fields', value: properties.changedFields });
  eventPropertiesArray.push({ id: 'Gh5yBexKN', name: 'option_id', value: properties.optionId });
  eventPropertiesArray.push({
    id: 'u5JNgZnkg',
    name: 'triggered_from_shared_menu',
    value: properties.triggeredFromSharedMenu,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'edit_option' });
  eventPropertiesArray.push({ id: 'FkzNg3k7k', name: 'is_changing_interaction', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'j2gVDLvyMZ',
        'e13bc72ba9f9e483eb9474081375cecea3bf54ce8fbe506c61db07df975e8704',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_edit_option', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'j2gVDLvyMZ',
        'interaction_click_edit_option',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_edit_option',
        eventProperties,
        'j2gVDLvyMZ',
        'e13bc72ba9f9e483eb9474081375cecea3bf54ce8fbe506c61db07df975e8704',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_edit_option', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickEditSubcategoryProperties {
  view: ViewValueType;
  changedFields: string[];
  categoryId: string;
}
/**
 * interaction_click_edit_subcategory: Describes if the user changes the subcategory
 *
 * When to trigger this event:
 * 1. Trigger when "edit was clicked", and changes were saved then
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/zCgPCaQurf/trigger/XFpbSgk-k
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.changedFields: Determines what fields were change by user
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/zCgPCaQurf}
 */
export function interactionClickEditSubcategory(properties: InteractionClickEditSubcategoryProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'G7EAKyPSs', name: 'changed_fields', value: properties.changedFields });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'edit_subcategory' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'zCgPCaQurf',
        '17ce3fe2542139e567237e14dadc7a068f08882a5a972de0da5061ee60e55a32',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_edit_subcategory', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'zCgPCaQurf',
        'interaction_click_edit_subcategory',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_edit_subcategory',
        eventProperties,
        'zCgPCaQurf',
        '17ce3fe2542139e567237e14dadc7a068f08882a5a972de0da5061ee60e55a32',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_edit_subcategory', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickDeleteSubcategoryProperties {
  view: ViewValueType;
  categoryId: string;
}
/**
 * interaction_click_delete_subcategory: Describes if the user deleted the subcategory
 *
 * When to trigger this event:
 * 1. Trigger when the subcategory was deleted
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/9RoIJimH_d/trigger/BQ14d_nuO
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.categoryId: ID of a parent category (not subcategory in venue category navigation) the item belongs to.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/9RoIJimH_d}
 */
export function interactionClickDeleteSubcategory(properties: InteractionClickDeleteSubcategoryProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'C-Qy95fVhXV', name: 'category_id', value: properties.categoryId });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'delete_subcategory' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '9RoIJimH_d',
        '915b632019d712a843231737795d895f6edc90ca0732d53f893883a18083e13a',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_delete_subcategory', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '9RoIJimH_d',
        'interaction_click_delete_subcategory',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_delete_subcategory',
        eventProperties,
        '9RoIJimH_d',
        '915b632019d712a843231737795d895f6edc90ca0732d53f893883a18083e13a',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_delete_subcategory', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BusinessInsightsInteractionClickChartSourceProperties {
  sourceTitle: SourceTitleValueType;
}
/**
 * business_insights_interaction_click_chart_source: This event tells the clicks to change the chart type in the Merchant Admins Business Insights page. This event tracks the initial click to change the chart and the selection click for the chart type, i.e. what chart the user selected.
 *
 * When to trigger this event:
 * 1. Fired when the user clicks and changes the chart source
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/vBWpRTwa3K/trigger/pvOnOuogy
 *
 * @param properties the properties associatied with this event
 * @param properties.sourceTitle: Tells the source title of the chart, i.e. what chart the user selected
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/vBWpRTwa3K}
 */
export function businessInsightsInteractionClickChartSource(
  properties: BusinessInsightsInteractionClickChartSourceProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'ivvZbkhVL', name: 'source_title', value: properties.sourceTitle });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'chart_source' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'vBWpRTwa3K',
        '36a825184aae4b2c8b4d07c684b7b37eb1532c06710c910d327d4787357fe7e3',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('business_insights_interaction_click_chart_source', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'vBWpRTwa3K',
        'business_insights_interaction_click_chart_source',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_interaction_click_chart_source',
        eventProperties,
        'vBWpRTwa3K',
        '36a825184aae4b2c8b4d07c684b7b37eb1532c06710c910d327d4787357fe7e3',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'business_insights_interaction_click_chart_source',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface BusinessInsightsInteractionClickDatePickerProperties {
  targetContentDatePicker: TargetContentDatePickerValueType | null | undefined;
}
/**
 * business_insights_interaction_click_date_picker: This event fires when the user clicks the date picker selection in the Business Insights view.
 *
 * When to trigger this event:
 * 1. The event is fired when the user clicks the date picker pointed by the arrow
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/3l6DAGBXeW/trigger/vKoROwTri
 *
 * @param properties the properties associatied with this event
 * @param properties.targetContentDatePicker: This event property is a follow-up event for a click on the date picker in the Merchant Admin Business Insights page. It's fired when a user selects another timeline for the visualisation
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/3l6DAGBXeW}
 */
export function businessInsightsInteractionClickDatePicker(
  properties: BusinessInsightsInteractionClickDatePickerProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.targetContentDatePicker !== undefined && properties.targetContentDatePicker !== null
    ? eventPropertiesArray.push({
        id: '0asQdPAvF',
        name: 'target_content_date_picker',
        value: properties.targetContentDatePicker,
      })
    : eventPropertiesArray.push({ id: '0asQdPAvF', name: 'target_content_date_picker', value: null });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'date_picker' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '3l6DAGBXeW',
        '6ba0a9615e57c063fde260f3855b2999ef954a83b25cb842205733e740a18e31',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('business_insights_interaction_click_date_picker', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '3l6DAGBXeW',
        'business_insights_interaction_click_date_picker',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_interaction_click_date_picker',
        eventProperties,
        '3l6DAGBXeW',
        '6ba0a9615e57c063fde260f3855b2999ef954a83b25cb842205733e740a18e31',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'business_insights_interaction_click_date_picker',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface CampaignsViewProperties {
  durationMs: number;
}
/**
 * campaigns_view: This event tells us when a user lands in the campaigns page in Merchant Admin
 *
 * When to trigger this event:
 * 1. This event fires when the user lands on the Campaigns-view in the Merchant Admin
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/SlOTlZ6RQI/trigger/qv58Hp8y_
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/SlOTlZ6RQI}
 */
export function campaignsView(properties: CampaignsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'campaigns' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'SlOTlZ6RQI',
        '94be35f9eae89daeb2dcd23f2847ab66c4f9a0bfa8cf04680a88bd2daaf54196',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('campaigns_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('SlOTlZ6RQI', 'campaigns_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'campaigns_view',
        eventProperties,
        'SlOTlZ6RQI',
        '94be35f9eae89daeb2dcd23f2847ab66c4f9a0bfa8cf04680a88bd2daaf54196',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('campaigns_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CampaignsInteractionClickCampaignTableProperties {
  targetContentCampaignsTable: TargetContentCampaignsTableValueType;
}
/**
 * campaigns_interaction_click_campaign_table: This event tracks all the clicks on the campaign table (not new_campaign-button)

 *
 * When to trigger this event:
 * 1. This event tracks all the clicks (marked in purple) in the main campaign table (not new_campaign) nor filter
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/LhlHt29pZ5/trigger/mpmMoVIRG
 *
 * @param properties the properties associatied with this event
 * @param properties.targetContentCampaignsTable: This is a follow-up click on the campaign table in the campaign-page
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/LhlHt29pZ5}
 */
export function campaignsInteractionClickCampaignTable(properties: CampaignsInteractionClickCampaignTableProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: '41IGf6_Cx',
    name: 'target_content_campaigns_table',
    value: properties.targetContentCampaignsTable,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'campaign_table' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'campaigns' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'LhlHt29pZ5',
        '8bac99b40cc2333dbf4ca6682d1f469ae4dd757b9de96626225bcf8eaca26d64',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('campaigns_interaction_click_campaign_table', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'LhlHt29pZ5',
        'campaigns_interaction_click_campaign_table',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'campaigns_interaction_click_campaign_table',
        eventProperties,
        'LhlHt29pZ5',
        '8bac99b40cc2333dbf4ca6682d1f469ae4dd757b9de96626225bcf8eaca26d64',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('campaigns_interaction_click_campaign_table', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * campaigns_interaction_click_new_campaign: This event triggers when the user clicks the new_campaign
 *
 * When to trigger this event:
 * 1. This event triggers when the user clicks the new_campaign
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/x-g4UBxMmp/trigger/rqhNgPu_x
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/x-g4UBxMmp}
 */
export function campaignsInteractionClickNewCampaign() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'new_campaign' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'campaigns' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'x-g4UBxMmp',
        '10b9baaa3cefa3da83b9d2f60e9da8200576a57b22c79481d62cdf962f71dbd8',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('campaigns_interaction_click_new_campaign', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'x-g4UBxMmp',
        'campaigns_interaction_click_new_campaign',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'campaigns_interaction_click_new_campaign',
        eventProperties,
        'x-g4UBxMmp',
        '10b9baaa3cefa3da83b9d2f60e9da8200576a57b22c79481d62cdf962f71dbd8',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('campaigns_interaction_click_new_campaign', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChooseCampaignInteractionClickCampaignSelectionProperties {
  optionSelected: OptionSelectedValueType;
}
/**
 * choose_campaign_interaction_click_campaign_selection: This event triggers when the user selects a new campaign in the "choose campaign"-page
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ZMVm-_bbAn/trigger/b2Jiu4YbF
 *
 * @param properties the properties associatied with this event
 * @param properties.optionSelected: Related to 'choose campaign'-page in Merchant Admin
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ZMVm-_bbAn}
 */
export function chooseCampaignInteractionClickCampaignSelection(
  properties: ChooseCampaignInteractionClickCampaignSelectionProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '2WYY10_y3', name: 'option_selected', value: properties.optionSelected });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'choose_campaign' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'campaign_selection' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ZMVm-_bbAn',
        'e1747d117970f8116bc73e94f9c273ad0ddfb79e77a989e8410e98807f7f0cfb',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'choose_campaign_interaction_click_campaign_selection',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ZMVm-_bbAn',
        'choose_campaign_interaction_click_campaign_selection',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'choose_campaign_interaction_click_campaign_selection',
        eventProperties,
        'ZMVm-_bbAn',
        'e1747d117970f8116bc73e94f9c273ad0ddfb79e77a989e8410e98807f7f0cfb',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'choose_campaign_interaction_click_campaign_selection',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface NewCampaignInteractionClickCampaignRulesProperties {
  targetContentNewCampaigns: TargetContentNewCampaignsValueType;
  campaignType: CampaignTypeValueType;
}
/**
 * new_campaign_interaction_click_campaign_rules: This event triggers when the user clicks any button on the campaign creation-tool.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/lSsTEb_zbb/trigger/PvG2ecLWi
 *
 * @param properties the properties associatied with this event
 * @param properties.targetContentNewCampaigns: Every button in new_campaigns-page is defined here
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/lSsTEb_zbb}
 */
export function newCampaignInteractionClickCampaignRules(
  properties: NewCampaignInteractionClickCampaignRulesProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'HeaE4wLxn',
    name: 'target_content_new_campaigns',
    value: properties.targetContentNewCampaigns,
  });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'campaign_rules' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'new_campaign' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'lSsTEb_zbb',
        'f34241c0c850eed5e2f07b33d988384f4394cfe4e5797f4ca3d869e43f25fec9',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('new_campaign_interaction_click_campaign_rules', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'lSsTEb_zbb',
        'new_campaign_interaction_click_campaign_rules',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'new_campaign_interaction_click_campaign_rules',
        eventProperties,
        'lSsTEb_zbb',
        'f34241c0c850eed5e2f07b33d988384f4394cfe4e5797f4ca3d869e43f25fec9',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'new_campaign_interaction_click_campaign_rules',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface UpdateCampaignDataEndCampaignProperties {
  campaignType: CampaignTypeValueType;
}
/**
 * update_campaign_data_end_campaign: This event trickers when the user clicks a end campaign and the data is sent to the backend
 *
 * When to trigger this event:
 * 1. Triggers when the end campaign-button is clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/983aZeIEn8/trigger/isIy_EIbm
 *
 * @param properties the properties associatied with this event
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/983aZeIEn8}
 */
export function updateCampaignDataEndCampaign(properties: UpdateCampaignDataEndCampaignProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'update_campaign' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'end_campaign' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '983aZeIEn8',
        '356522e121f8e7fa45ff22be7995813e902f9e5b3c6c9dddf1650579d6b8eba2',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('update_campaign_data_end_campaign', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '983aZeIEn8',
        'update_campaign_data_end_campaign',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'update_campaign_data_end_campaign',
        eventProperties,
        '983aZeIEn8',
        '356522e121f8e7fa45ff22be7995813e902f9e5b3c6c9dddf1650579d6b8eba2',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('update_campaign_data_end_campaign', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NewCampaignRulesViewProperties {
  durationMs: number;
  campaignType: CampaignTypeValueType;
}
/**
 * new_campaign_rules_view: This event triggers when the user lands to the new campaign rules page
 *
 * When to trigger this event:
 * 1. Triggered when the User lands to this page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/uJx4morIU3/trigger/xlKOlJpfA
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/uJx4morIU3}
 */
export function newCampaignRulesView(properties: NewCampaignRulesViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'new_campaign_rules' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'uJx4morIU3',
        '6775aa28da9d3f5d2284534d9db4b90c603278d0a57fde4af41245cf254c69b9',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('new_campaign_rules_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'uJx4morIU3',
        'new_campaign_rules_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'new_campaign_rules_view',
        eventProperties,
        'uJx4morIU3',
        '6775aa28da9d3f5d2284534d9db4b90c603278d0a57fde4af41245cf254c69b9',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('new_campaign_rules_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NewCampaignInteractionClickCampaignRulesBasketProperties {
  campaignRulesBasketContent: string;
  campaignType: CampaignTypeValueType;
}
/**
 * new_campaign_interaction_click_campaign_rules_basket: This event triggers when the user clicks basket rules on the campaign rules page
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/7_5pkj8Zo/trigger/xBtigLpZKV
 *
 * @param properties the properties associatied with this event
 * @param properties.campaignRulesBasketContent: Tells the content of the click for basket rules

 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/7_5pkj8Zo}
 */
export function newCampaignInteractionClickCampaignRulesBasket(
  properties: NewCampaignInteractionClickCampaignRulesBasketProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'memIunW40',
    name: 'campaign_rules_basket_content',
    value: properties.campaignRulesBasketContent,
  });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'new_campaign' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'campaign_rules_basket' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '7_5pkj8Zo',
        '777f585a460a2765fb5b23b94b230d58e8450c99942582c1fff059a3d7dfba21',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'new_campaign_interaction_click_campaign_rules_basket',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '7_5pkj8Zo',
        'new_campaign_interaction_click_campaign_rules_basket',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'new_campaign_interaction_click_campaign_rules_basket',
        eventProperties,
        '7_5pkj8Zo',
        '777f585a460a2765fb5b23b94b230d58e8450c99942582c1fff059a3d7dfba21',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'new_campaign_interaction_click_campaign_rules_basket',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface NewCampaignRulesInteractionClickUserRulesProperties {
  userRulesContent: string;
  campaignType: CampaignTypeValueType;
}
/**
 * new_campaign_rules_interaction_click_user_rules: This event triggers when the user clicks user rules on the campaign rules page
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/drZiUWlKg/trigger/rWmbx8jCt-
 *
 * @param properties the properties associatied with this event
 * @param properties.userRulesContent: Tells the content for the user rules
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/drZiUWlKg}
 */
export function newCampaignRulesInteractionClickUserRules(
  properties: NewCampaignRulesInteractionClickUserRulesProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'ZK42nKEPR', name: 'user_rules_content', value: properties.userRulesContent });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'new_campaign_rules' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'user_rules' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'drZiUWlKg',
        '14ea0a1f4faf3dcab922a8f5fa20ac36b759ae686c634b6d317e8a5113307b19',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('new_campaign_rules_interaction_click_user_rules', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'drZiUWlKg',
        'new_campaign_rules_interaction_click_user_rules',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'new_campaign_rules_interaction_click_user_rules',
        eventProperties,
        'drZiUWlKg',
        '14ea0a1f4faf3dcab922a8f5fa20ac36b759ae686c634b6d317e8a5113307b19',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'new_campaign_rules_interaction_click_user_rules',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface UpdateCampaignDataUpdateCampaignProperties {
  campaignType: CampaignTypeValueType;
}
/**
 * update_campaign_data_update_campaign: This event trickers when the user clicks the update campaign and the data is sent to the backend
 *
 * When to trigger this event:
 * 1. Triggers when the update campaign-button is clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/scMWgfy9y/trigger/SdpjNsnWp8
 *
 * @param properties the properties associatied with this event
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/scMWgfy9y}
 */
export function updateCampaignDataUpdateCampaign(properties: UpdateCampaignDataUpdateCampaignProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'update_campaign' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'update_campaign' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'scMWgfy9y',
        '579c46ea4238bd77706baaa8cef414e922264f4367e6627644ad3a9b96cb57ed',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('update_campaign_data_update_campaign', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'scMWgfy9y',
        'update_campaign_data_update_campaign',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'update_campaign_data_update_campaign',
        eventProperties,
        'scMWgfy9y',
        '579c46ea4238bd77706baaa8cef414e922264f4367e6627644ad3a9b96cb57ed',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('update_campaign_data_update_campaign', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NewCampaignDataCreateCampaignProperties {
  campaignType: CampaignTypeValueType;
  campaignDuration: number;
}
/**
 * new_campaign_data_create_campaign: This event trickers when the user clicks the create campaign and the data is sent to the backend
 *
 * When to trigger this event:
 * 1. Triggers when the create campaign-button is clicked
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/X5aAJkDsH/trigger/CX1KSliptH
 *
 * @param properties the properties associatied with this event
 * @param properties.campaignType: Tells the type of the campaign
 * @param properties.campaignDuration: The duration of the campaign in days
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/X5aAJkDsH}
 */
export function newCampaignDataCreateCampaign(properties: NewCampaignDataCreateCampaignProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'mM30KYXlX', name: 'campaign_duration', value: properties.campaignDuration });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'new_campaign' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'new_campaign_created' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'X5aAJkDsH',
        'a604825e433958ee33c69ab02ba8f071f3c3923db671046f1b94c879253a3b09',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('new_campaign_data_create_campaign', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'X5aAJkDsH',
        'new_campaign_data_create_campaign',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'new_campaign_data_create_campaign',
        eventProperties,
        'X5aAJkDsH',
        'a604825e433958ee33c69ab02ba8f071f3c3923db671046f1b94c879253a3b09',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('new_campaign_data_create_campaign', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UpdateCampaignInteractionClickCampaignUpdateProperties {
  targetContentCampaignEdit: TargetContentCampaignEditValueType;
  campaignType: CampaignTypeValueType;
}
/**
 * update_campaign_interaction_click_campaign_update: This is triggered when the user clicks anything in the "update campaign"-page
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/pfHsXAT4xi/trigger/u-0RSKvYI
 *
 * @param properties the properties associatied with this event
 * @param properties.targetContentCampaignEdit: Tells the clicked button in the campaign edit page
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/pfHsXAT4xi}
 */
export function updateCampaignInteractionClickCampaignUpdate(
  properties: UpdateCampaignInteractionClickCampaignUpdateProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'YisyO4W35',
    name: 'target_content_campaign_edit',
    value: properties.targetContentCampaignEdit,
  });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'update_campaign' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'campaign_update' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'pfHsXAT4xi',
        '57e87ee99bc732ede56309ab62591fba324d7334aec7bf954f96afc5a3705b9d',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'update_campaign_interaction_click_campaign_update',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'pfHsXAT4xi',
        'update_campaign_interaction_click_campaign_update',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'update_campaign_interaction_click_campaign_update',
        eventProperties,
        'pfHsXAT4xi',
        '57e87ee99bc732ede56309ab62591fba324d7334aec7bf954f96afc5a3705b9d',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'update_campaign_interaction_click_campaign_update',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface BusinessInsightsV2ViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * business_insights_v2_view: When user logs in to merchant admin and lands on business insights v2 page after selecting a merchant/venue. v1 still available with the switch button on the bottom
 *
 * When to trigger this event:
 * 1. Trigger when user lands on this page after selecting the venue. This is the v2 of the isights page, v1 is still available through the switch button on the bottom
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/gqbUb1Zop/trigger/xCRr8xSNMb
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/gqbUb1Zop}
 */
export function businessInsightsV2View(properties: BusinessInsightsV2ViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'business_insights_v2_view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'gqbUb1Zop',
        'f98241bd37a143839b9113c8f19eeb6d212415414a96214839ea3f5a545d85e5',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('business_insights_v2_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'gqbUb1Zop',
        'business_insights_v2_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_view',
        eventProperties,
        'gqbUb1Zop',
        'f98241bd37a143839b9113c8f19eeb6d212415414a96214839ea3f5a545d85e5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('business_insights_v2_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BusinessInsightsV2InteractionClickSwitchToOldInsightsProperties {
  viewType: string;
}
/**
 * business_insights_v2_interaction_click_switch_to_old_insights: Click on the "go to old insights page"-button
 *
 * When to trigger this event:
 * 1. Click on the switch to old insights-button on the bottom
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/n6mE3tUyI/trigger/7my8zSDj2y
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/n6mE3tUyI}
 */
export function businessInsightsV2InteractionClickSwitchToOldInsights(
  properties: BusinessInsightsV2InteractionClickSwitchToOldInsightsProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'switch_to_old_insights' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'n6mE3tUyI',
        '3202f17f7e3c6ed1ecb5ca2c67f48ce35322c74c86304b4828e00bf76d94c621',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'business_insights_v2_interaction_click_switch_to_old_insights',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'n6mE3tUyI',
        'business_insights_v2_interaction_click_switch_to_old_insights',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_interaction_click_switch_to_old_insights',
        eventProperties,
        'n6mE3tUyI',
        '3202f17f7e3c6ed1ecb5ca2c67f48ce35322c74c86304b4828e00bf76d94c621',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'business_insights_v2_interaction_click_switch_to_old_insights',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * enterprise_brand_user_management_interaction_click_send_invitation: This interaction is triggered when user clicks "Send invitation" button.
 *
 * When to trigger this event:
 * 1. This interaction is triggered when user clicks "Send invitation" button from brand's access management page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/y0Wzt1fWXr/trigger/xkv6qO1NJ
 * 2. This interaction is triggered when user clicks "Send invitation" button from enterprise's access management page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/y0Wzt1fWXr/trigger/BW9IqkNoX
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/y0Wzt1fWXr}
 */
export function enterpriseBrandUserManagementInteractionClickSendInvitation() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'enterprise_user_management' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'send_invitation' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'y0Wzt1fWXr',
        'c1a125185c1bdfa01c5fdb4e374448147a1f27721263d6a7e6b047be61c4b5a0',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'enterprise_brand_user_management_interaction_click_send_invitation',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'y0Wzt1fWXr',
        'enterprise_brand_user_management_interaction_click_send_invitation',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'enterprise_brand_user_management_interaction_click_send_invitation',
        eventProperties,
        'y0Wzt1fWXr',
        'c1a125185c1bdfa01c5fdb4e374448147a1f27721263d6a7e6b047be61c4b5a0',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'enterprise_brand_user_management_interaction_click_send_invitation',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface InteractionClickCreateSharedMenuProperties {
  view: ViewValueType;
  sharedMenuId: string;
  fromMenuLanguage: string;
}
/**
 * interaction_click_create_shared_menu: Describes when the user created a new shared menu
 *
 * When to trigger this event:
 * 1. Trigger when user clicks "Create shared menu", and then clicks "Create"
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/vaFkc6tIwb/trigger/Vy4JpsF50
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.sharedMenuId: Describes the unique identifier of the shared menu
 * @param properties.fromMenuLanguage: The language which menu was translated from.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/vaFkc6tIwb}
 */
export function interactionClickCreateSharedMenu(properties: InteractionClickCreateSharedMenuProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'uK7RgUVXeo', name: 'shared_menu_id', value: properties.sharedMenuId });
  eventPropertiesArray.push({ id: 'EavON6gkSs2S', name: 'from_menu_language', value: properties.fromMenuLanguage });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'create_shared_menu' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'vaFkc6tIwb',
        'ca4919388a1796c6534dc8d343cf203b0d0c7c743a3e727553942876abca0550',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_create_shared_menu', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'vaFkc6tIwb',
        'interaction_click_create_shared_menu',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_create_shared_menu',
        eventProperties,
        'vaFkc6tIwb',
        'ca4919388a1796c6534dc8d343cf203b0d0c7c743a3e727553942876abca0550',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_create_shared_menu', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickShareMenuWithVenuesProperties {
  view: ViewValueType;
  userSearchQuery: string;
  selectAllSelected: boolean;
  venueIdSelected: string[];
  sharedMenuId: string;
}
/**
 * interaction_click_share_menu_with_venues: Describes if the user shares the menu with venues
 *
 * When to trigger this event:
 * 1. Trigger when user clicks "Share menu" on the main view, then clicks "Share menu" after selecting the venues, and then confirms sharing
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/UL6Av8Md4A/trigger/xf4yZX_CE
 * 2. Trigger when user clicks "Share menu with venues", and then clicks "Share menu", so the menu is finally shared
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/UL6Av8Md4A/trigger/OPBs66K55
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.userSearchQuery: Describes if the user used search to find the selected venues. If yes, provides with the search query, if not -- NULL
 * @param properties.selectAllSelected: Determines if 'Select all' was used
 * @param properties.venueIdSelected: Ids of selected venues
 * @param properties.sharedMenuId: Describes the unique identifier of the shared menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/UL6Av8Md4A}
 */
export function interactionClickShareMenuWithVenues(properties: InteractionClickShareMenuWithVenuesProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '3fBH3G0eW', name: 'user_search_query', value: properties.userSearchQuery });
  eventPropertiesArray.push({ id: 'nph2B0tBC', name: 'select_all_selected', value: properties.selectAllSelected });
  eventPropertiesArray.push({ id: 'J7VBNFsIz', name: 'venue_id_selected', value: properties.venueIdSelected });
  eventPropertiesArray.push({ id: 'uK7RgUVXeo', name: 'shared_menu_id', value: properties.sharedMenuId });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'share_menu_with_venues' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'UL6Av8Md4A',
        '502daf9dc732399e185ad82c4e5baccc82c657ebbee84a9ed17e44f73efdc14b',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_share_menu_with_venues', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'UL6Av8Md4A',
        'interaction_click_share_menu_with_venues',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_share_menu_with_venues',
        eventProperties,
        'UL6Av8Md4A',
        '502daf9dc732399e185ad82c4e5baccc82c657ebbee84a9ed17e44f73efdc14b',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_share_menu_with_venues', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickStopSharingMenuProperties {
  view: ViewValueType;
  userSearchQuery: string;
  selectAllSelected: boolean;
  venueIdSelected: string[];
  sharedMenuId: string;
}
/**
 * interaction_click_stop_sharing_menu: Describes when the user stops sharing the menu with venue(s)
 *
 * When to trigger this event:
 * 1. Trigger when user clicks "Stop sharing", and then confirms it by clicking "Stop sharing"
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/wZvmaCQpVi/trigger/bQ_oYR7YR
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.userSearchQuery: Describes if the user used search to find the selected venues. If yes, provides with the search query, if not -- NULL
 * @param properties.selectAllSelected: Determines if 'Select all' was used
 * @param properties.venueIdSelected: Ids of selected venues
 * @param properties.sharedMenuId: Describes the unique identifier of the shared menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/wZvmaCQpVi}
 */
export function interactionClickStopSharingMenu(properties: InteractionClickStopSharingMenuProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: '3fBH3G0eW', name: 'user_search_query', value: properties.userSearchQuery });
  eventPropertiesArray.push({ id: 'nph2B0tBC', name: 'select_all_selected', value: properties.selectAllSelected });
  eventPropertiesArray.push({ id: 'J7VBNFsIz', name: 'venue_id_selected', value: properties.venueIdSelected });
  eventPropertiesArray.push({ id: 'uK7RgUVXeo', name: 'shared_menu_id', value: properties.sharedMenuId });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'stop_sharing_menu' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'wZvmaCQpVi',
        'cdd5579a2ef41b34416738e86ad798509e0322576aa3d9dfb5a26a6bb9ab3970',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_stop_sharing_menu', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'wZvmaCQpVi',
        'interaction_click_stop_sharing_menu',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_stop_sharing_menu',
        eventProperties,
        'wZvmaCQpVi',
        'cdd5579a2ef41b34416738e86ad798509e0322576aa3d9dfb5a26a6bb9ab3970',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_stop_sharing_menu', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickEditSharedMenuProperties {
  view: ViewValueType;
  sharedMenuId: string;
}
/**
 * interaction_click_edit_shared_menu: Describes when the user starts editing a shared menu
 *
 * When to trigger this event:
 * 1. Trigger when the user clicks "Edit menu"
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/DZHvngoS0r/trigger/n725tglQG
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.sharedMenuId: Describes the unique identifier of the shared menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/DZHvngoS0r}
 */
export function interactionClickEditSharedMenu(properties: InteractionClickEditSharedMenuProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'uK7RgUVXeo', name: 'shared_menu_id', value: properties.sharedMenuId });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'edit_shared_menu' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'DZHvngoS0r',
        '3dbdfbcc0f5b9aa04e9136cf9b2b779cda9f73935754fb1a6d4fbf9c48883802',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_edit_shared_menu', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'DZHvngoS0r',
        'interaction_click_edit_shared_menu',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_edit_shared_menu',
        eventProperties,
        'DZHvngoS0r',
        '3dbdfbcc0f5b9aa04e9136cf9b2b779cda9f73935754fb1a6d4fbf9c48883802',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_edit_shared_menu', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickSchedulePublishingProperties {
  view: ViewValueType;
  sharedMenuId: string;
  dateSelected: number;
}
/**
 * interaction_click_schedule_publishing: Describes when the user schedules the menu publishing after editing the menu
 *
 * When to trigger this event:
 * 1. Trigger when user clicks "Schedule publishing", and then confirms scheduling by clicking "Schedule publishing"
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/bztcq2JAgX/trigger/tIbB62TSu
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.sharedMenuId: Describes the unique identifier of the shared menu
 * @param properties.dateSelected: The date selected by user
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/bztcq2JAgX}
 */
export function interactionClickSchedulePublishing(properties: InteractionClickSchedulePublishingProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'uK7RgUVXeo', name: 'shared_menu_id', value: properties.sharedMenuId });
  eventPropertiesArray.push({ id: 'FRE0y-Mg4', name: 'date_selected', value: properties.dateSelected });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'schedule_publishing' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'bztcq2JAgX',
        'd3f041c5e3cacde3e0fd1999a97e0d56dd9f88118f797a5cc3c21ae1e11c1fef',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_schedule_publishing', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'bztcq2JAgX',
        'interaction_click_schedule_publishing',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_schedule_publishing',
        eventProperties,
        'bztcq2JAgX',
        'd3f041c5e3cacde3e0fd1999a97e0d56dd9f88118f797a5cc3c21ae1e11c1fef',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_schedule_publishing', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickPublishNowProperties {
  view: ViewValueType;
  sharedMenuId: string;
}
/**
 * interaction_click_publish_now: Describes when the user published the shared menu
 *
 * When to trigger this event:
 * 1. Trigger when the user clicks "Publish now", and then clicks "Publish now" again to confirm the action
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/jVpe_WiAnK/trigger/22Fzv9MJO
 *
 * @param properties the properties associatied with this event
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.sharedMenuId: Describes the unique identifier of the shared menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/jVpe_WiAnK}
 */
export function interactionClickPublishNow(properties: InteractionClickPublishNowProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'uK7RgUVXeo', name: 'shared_menu_id', value: properties.sharedMenuId });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'publish_now' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'jVpe_WiAnK',
        '4ca4b4a889af0370f9718710b1880f53a2128d11a6f6b33bd1a910ee74647386',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_publish_now', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'jVpe_WiAnK',
        'interaction_click_publish_now',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_publish_now',
        eventProperties,
        'jVpe_WiAnK',
        '4ca4b4a889af0370f9718710b1880f53a2128d11a6f6b33bd1a910ee74647386',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_publish_now', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface InteractionClickInstallMerchantAdminProperties {
  clickTarget: ClickTargetValueType;
}
/**
 * interaction_click_install_merchant_admin: The event for user clicking the install button in Merchant Admin
 *
 * When to trigger this event:
 * 1. Event for clicking the install button in the banner
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MTFd0gJis7/trigger/ZvJwe5CgJ
 *
 * @param properties the properties associatied with this event
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MTFd0gJis7}
 */
export function interactionClickInstallMerchantAdmin(properties: InteractionClickInstallMerchantAdminProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: properties.clickTarget });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'MTFd0gJis7',
        'c39e25232efe99b5393fd0f80e2b81ed00c57b124e076dd1bf19da5fe65c04e1',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('interaction_click_install_merchant_admin', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'MTFd0gJis7',
        'interaction_click_install_merchant_admin',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'interaction_click_install_merchant_admin',
        eventProperties,
        'MTFd0gJis7',
        'c39e25232efe99b5393fd0f80e2b81ed00c57b124e076dd1bf19da5fe65c04e1',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('interaction_click_install_merchant_admin', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * pwa_app_installed: When the PWA app is installed on device
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/HzM-yzh59c}
 */
export function pwaAppInstalled() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'HzM-yzh59c',
        '7320ba4e1dc3c04f035559a479fcf8d8fa69d56afd9571599ea3a17148638e74',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('pwa_app_installed', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('HzM-yzh59c', 'pwa_app_installed', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'pwa_app_installed',
        eventProperties,
        'HzM-yzh59c',
        '7320ba4e1dc3c04f035559a479fcf8d8fa69d56afd9571599ea3a17148638e74',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('pwa_app_installed', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NewCampaignViewProperties {
  durationMs: number;
  campaignType: CampaignTypeValueType;
}
/**
 * new_campaign_view: Event for landing on the campaign creation page
 *
 * When to trigger this event:
 * 1. Event for when the user lands on a campaign creation page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ZB_lgBqHjR/trigger/2Rp3tbp7y
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ZB_lgBqHjR}
 */
export function newCampaignView(properties: NewCampaignViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'new_campaign' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'new_campaign_view' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ZB_lgBqHjR',
        '1ba66ba87a248e8a9af84aef751d7fcd68c01090f73f58ce36a069c3df2ac88b',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('new_campaign_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('ZB_lgBqHjR', 'new_campaign_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'new_campaign_view',
        eventProperties,
        'ZB_lgBqHjR',
        '1ba66ba87a248e8a9af84aef751d7fcd68c01090f73f58ce36a069c3df2ac88b',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('new_campaign_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ChooseCampaignViewProperties {
  durationMs: number;
}
/**
 * choose_campaign_view: Triggers when the user lands to the campaign selection page
 *
 * When to trigger this event:
 * 1. Triggers when the user lands to the campaign selection page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/IhaVuPCMqq/trigger/I5H_i4WSq
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/IhaVuPCMqq}
 */
export function chooseCampaignView(properties: ChooseCampaignViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'choose_campaign' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'choose_campaign_view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'IhaVuPCMqq',
        '314d162d8d9f905e0a24e670b0c42eaaeb87c70ee4d6084a501e7128431b3914',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('choose_campaign_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('IhaVuPCMqq', 'choose_campaign_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'choose_campaign_view',
        eventProperties,
        'IhaVuPCMqq',
        '314d162d8d9f905e0a24e670b0c42eaaeb87c70ee4d6084a501e7128431b3914',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('choose_campaign_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UpdateCampaignViewProperties {
  durationMs: number;
  campaignType: CampaignTypeValueType;
}
/**
 * update_campaign_view: Event for landing on the campaign editing page
 *
 * When to trigger this event:
 * 1. Event for when the user lands on a campaign editing page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/KNutYvXuu/trigger/8e5sINjoJW
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/KNutYvXuu}
 */
export function updateCampaignView(properties: UpdateCampaignViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'update_campaign' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'update_campaign_view' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'KNutYvXuu',
        'bc94765f16774fe3c6c8383763f27b4703dd8aa2d92092b8449ddb5dc2d1a2c3',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('update_campaign_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('KNutYvXuu', 'update_campaign_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'update_campaign_view',
        eventProperties,
        'KNutYvXuu',
        'bc94765f16774fe3c6c8383763f27b4703dd8aa2d92092b8449ddb5dc2d1a2c3',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('update_campaign_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CampaignDetailsViewProperties {
  durationMs: number;
  campaignType: CampaignTypeValueType;
}
/**
 * campaign_details_view: This event is triggered when the user lands on the campaign details page
 *
 * When to trigger this event:
 * 1. This event is triggered when the user lands on the campaign details page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/g3pOhmrDlB/trigger/kNn3ifigw
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/g3pOhmrDlB}
 */
export function campaignDetailsView(properties: CampaignDetailsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'campaign_details' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'campaign_details_view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'g3pOhmrDlB',
        'a52514ae5625d9844b3fbb7239f18240968ca078cf570dff77bbcaca9486182e',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('campaign_details_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log('g3pOhmrDlB', 'campaign_details_view', messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'campaign_details_view',
        eventProperties,
        'g3pOhmrDlB',
        'a52514ae5625d9844b3fbb7239f18240968ca078cf570dff77bbcaca9486182e',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('campaign_details_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UpdateCampaignInteractionClickCampaignRulesBasketProperties {
  campaignRulesBasketContent: string;
  campaignType: CampaignTypeValueType;
}
/**
 * update_campaign_interaction_click_campaign_rules_basket: This event triggers when the user clicks basket rules on the campaign rules page
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/orkifxalK/trigger/Le9Pb13uAX
 *
 * @param properties the properties associatied with this event
 * @param properties.campaignRulesBasketContent: Tells the content of the click for basket rules

 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/orkifxalK}
 */
export function updateCampaignInteractionClickCampaignRulesBasket(
  properties: UpdateCampaignInteractionClickCampaignRulesBasketProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'memIunW40',
    name: 'campaign_rules_basket_content',
    value: properties.campaignRulesBasketContent,
  });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'update_campaign' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'campaign_rules_basket' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'orkifxalK',
        '29899158fc427fa070bb6ae1566a53fa768b42571c6769b51ee2cabf678b682b',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'update_campaign_interaction_click_campaign_rules_basket',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'orkifxalK',
        'update_campaign_interaction_click_campaign_rules_basket',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'update_campaign_interaction_click_campaign_rules_basket',
        eventProperties,
        'orkifxalK',
        '29899158fc427fa070bb6ae1566a53fa768b42571c6769b51ee2cabf678b682b',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'update_campaign_interaction_click_campaign_rules_basket',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface UpdateCampaignRulesInteractionClickUserRulesProperties {
  userRulesContent: string;
  campaignType: CampaignTypeValueType;
}
/**
 * update_campaign_rules_interaction_click_user_rules: This event triggers when the user clicks user rules on the campaign rules page
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ge-81_Euy/trigger/QaPzE1_wd
 *
 * @param properties the properties associatied with this event
 * @param properties.userRulesContent: Tells the content for the user rules
 * @param properties.campaignType: Tells the type of the campaign
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ge-81_Euy}
 */
export function updateCampaignRulesInteractionClickUserRules(
  properties: UpdateCampaignRulesInteractionClickUserRulesProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'ZK42nKEPR', name: 'user_rules_content', value: properties.userRulesContent });
  eventPropertiesArray.push({ id: 'UUEDl_Z3m', name: 'campaign_type', value: properties.campaignType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'update_campaign' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'user_rules' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ge-81_Euy',
        '4e7b302120cf9d80782e99e39ff58bb4cfbd8810bc804a96d0e68e1085d59fdc',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'update_campaign_rules_interaction_click_user_rules',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ge-81_Euy',
        'update_campaign_rules_interaction_click_user_rules',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'update_campaign_rules_interaction_click_user_rules',
        eventProperties,
        'ge-81_Euy',
        '4e7b302120cf9d80782e99e39ff58bb4cfbd8810bc804a96d0e68e1085d59fdc',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'update_campaign_rules_interaction_click_user_rules',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface DeliveryTypeModalViewProperties {
  durationMs: number;
  source: SourceValueType | null | undefined;
}
/**
 * delivery_type_modal_view: This event tell us a user has seen the modal to switch delivery type
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/E7bbxraNT-/trigger/WHJrhugzT
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 * @param properties.source: ⚠️ Will be implemented after new analytics architecture is in place.

Previous page (view name in telemetry) where the current one was opened from if used in multiple places across the App.
OR
Background view for a banner, pop-up or modal.
OR
For in-venue search, identifies location of the interaction that led to in-venue search view.

For error_view: the property shows for which view the error was opened.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/E7bbxraNT-}
 */
export function deliveryTypeModalView(properties: DeliveryTypeModalViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  properties.source !== undefined && properties.source !== null
    ? eventPropertiesArray.push({ id: '_Y01LmRqp', name: 'source', value: properties.source })
    : eventPropertiesArray.push({ id: '_Y01LmRqp', name: 'source', value: null });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'delivery_type_modal' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'E7bbxraNT-',
        '5abb4f50e8e5e39c4a9106cc30f711c5e1d849c7fd6c4896e5affc8fb3d342a5',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('delivery_type_modal_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'E7bbxraNT-',
        'delivery_type_modal_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'delivery_type_modal_view',
        eventProperties,
        'E7bbxraNT-',
        '5abb4f50e8e5e39c4a9106cc30f711c5e1d849c7fd6c4896e5affc8fb3d342a5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('delivery_type_modal_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface DeliveryTypeModalDataConfirmProperties {
  viewType: string;
  deliveryType: DeliveryTypeValueType;
}
/**
 * delivery_type_modal_data_confirm: When the user clicks on the confirm button in the delivery type modal in either live purchases or restaurant details.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/QllHAQ-GXv/trigger/LIWSGlKJ4
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.deliveryType: Describes the delivery type which can be self_delivery or wolt_delivery

 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/QllHAQ-GXv}
 */
export function deliveryTypeModalDataConfirm(properties: DeliveryTypeModalDataConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Z_yEpQ1vm', name: 'delivery_type', value: properties.deliveryType });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'delivery_type_modal' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'QllHAQ-GXv',
        '7681d84bbebfdf6dc3d6b7c153f88c05a6fdd99cdfa82d752b248d764c2f9cc5',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('delivery_type_modal_data_confirm', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'QllHAQ-GXv',
        'delivery_type_modal_data_confirm',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'delivery_type_modal_data_confirm',
        eventProperties,
        'QllHAQ-GXv',
        '7681d84bbebfdf6dc3d6b7c153f88c05a6fdd99cdfa82d752b248d764c2f9cc5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('delivery_type_modal_data_confirm', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RestaurantDetailsViewProperties {
  durationMs: number;
}
/**
 * restaurant_details_view: This event tell us when a user landed on the restaurant details page
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/vB6QyAm2Ob/trigger/RTzSht4l1
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/vB6QyAm2Ob}
 */
export function restaurantDetailsView(properties: RestaurantDetailsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'restaurant_details' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'vB6QyAm2Ob',
        'a3caf2da98127b5d3b6c70118852b9f0514d1bd503d7616bf557ad09dee07418',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('restaurant_details_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'vB6QyAm2Ob',
        'restaurant_details_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'restaurant_details_view',
        eventProperties,
        'vB6QyAm2Ob',
        'a3caf2da98127b5d3b6c70118852b9f0514d1bd503d7616bf557ad09dee07418',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('restaurant_details_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RestaurantDetailsInteractionClickSwitchDeliveryTypeProperties {
  viewType: string;
}
/**
 * restaurant_details_interaction_click_switch_delivery_type: When user clicks on the switch delivery type button on the restaurant details
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JdWhx54Zd/trigger/BygAoWAx-
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JdWhx54Zd}
 */
export function restaurantDetailsInteractionClickSwitchDeliveryType(
  properties: RestaurantDetailsInteractionClickSwitchDeliveryTypeProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'restaurant_details' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'switch_delivery_type' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'JdWhx54Zd',
        '8c7388c0967803ee0c07d2813b17a74d236463fe7b12c66b1fb1e28a55a5f8c7',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'restaurant_details_interaction_click_switch_delivery_type',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'JdWhx54Zd',
        'restaurant_details_interaction_click_switch_delivery_type',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'restaurant_details_interaction_click_switch_delivery_type',
        eventProperties,
        'JdWhx54Zd',
        '8c7388c0967803ee0c07d2813b17a74d236463fe7b12c66b1fb1e28a55a5f8c7',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'restaurant_details_interaction_click_switch_delivery_type',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface VenueAvailabilityViewProperties {
  durationMs: number;
}
/**
 * venue_availability_view: Send the event when the user visit "Venue availability" tab of merchant-admin
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Hs_DVdLzbX/trigger/QFzKQHbPB
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Hs_DVdLzbX}
 */
export function venueAvailabilityView(properties: VenueAvailabilityViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'venue_availability' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Hs_DVdLzbX',
        'e64a7a8e29fffe318b8d7c990b31f0f5bdea6a2714b5c9a82db6973239b66e8e',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('venue_availability_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Hs_DVdLzbX',
        'venue_availability_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'venue_availability_view',
        eventProperties,
        'Hs_DVdLzbX',
        'e64a7a8e29fffe318b8d7c990b31f0f5bdea6a2714b5c9a82db6973239b66e8e',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('venue_availability_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProfileInteractionClickSubscriptionRowProperties {
  clickTarget: ClickTargetValueType;
  eventName: EventNameValueType;
  logType: LogTypeValueType;
  view: ViewValueType;
  subscriptionPlan: any;
}
/**
 * profile_interaction_click_subscription_row: Interaction event that tracks click on the 'Wolt+' button which only appears when user is subscribed and leads to subscription management
 *
 * @param properties the properties associatied with this event
 * @param properties.clickTarget: This field describes the actual target user interacted with in click/swipe interaction event
 * @param properties.eventName: Name of the event according to Wolt internal specifications
 * @param properties.logType: Typology of log according to Wolt internal specifications
 * @param properties.view: Describes the context of which view the event was originated
 * @param properties.subscriptionPlan: Indicates the id of the subscription plan, for example:
{'subscription_plan':'61f0fc8142a6c7d45662397a'}
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/P-e9NPFYa7y}
 */
export function profileInteractionClickSubscriptionRow(properties: ProfileInteractionClickSubscriptionRowProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: properties.clickTarget });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: properties.eventName });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: properties.logType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: properties.view });
  eventPropertiesArray.push({ id: 'c1Sh9WTLiUB', name: 'subscription_plan', value: properties.subscriptionPlan });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'P-e9NPFYa7y',
        'c2e0843fcb1f4bf52e84ea8e8b77a9c59cefc299a648f8cc7cbb25bba07e545d',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('profile_interaction_click_subscription_row', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'P-e9NPFYa7y',
        'profile_interaction_click_subscription_row',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'profile_interaction_click_subscription_row',
        eventProperties,
        'P-e9NPFYa7y',
        'c2e0843fcb1f4bf52e84ea8e8b77a9c59cefc299a648f8cc7cbb25bba07e545d',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('profile_interaction_click_subscription_row', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AllItemsInteractionClickAddItemsToCatalogProperties {
  country: string;
  numberOfItems: number;
}
/**
 * all_items_interaction_click_add_items_to_catalog: The event describes when the user clicks "Add" for saving Menu Editor items into catalog
 *
 * When to trigger this event:
 * 1. Triggers when clicking the "Add" button
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/KqInZji7rs/trigger/LqqZ4nkn2
 *
 * @param properties the properties associatied with this event
 * @param properties.country: Most actual country (detected automatically or selected by user)
 * @param properties.numberOfItems: Number of items related to the event
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/KqInZji7rs}
 */
export function allItemsInteractionClickAddItemsToCatalog(
  properties: AllItemsInteractionClickAddItemsToCatalogProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: '8mUBOQ5_QW', name: 'country', value: properties.country });
  eventPropertiesArray.push({ id: 'FPwMnYqMp', name: 'number_of_items', value: properties.numberOfItems });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'all_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'add_items_to_catalog' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'KqInZji7rs',
        'a3ddf805af2c6ec8739fb48950df5df756a4750ef7afc050b6b750807b29b37a',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('all_items_interaction_click_add_items_to_catalog', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'KqInZji7rs',
        'all_items_interaction_click_add_items_to_catalog',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'all_items_interaction_click_add_items_to_catalog',
        eventProperties,
        'KqInZji7rs',
        'a3ddf805af2c6ec8739fb48950df5df756a4750ef7afc050b6b750807b29b37a',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'all_items_interaction_click_add_items_to_catalog',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface BusinessInsightsV2PerformanceViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * business_insights_v2_performance_view: When user logs in to merchant admin and lands on business insights v2 page after selecting a merchant/venue. v1 still available with the switch button on the bottom
 *
 * When to trigger this event:
 * 1. Trigger when user lands on this page after selecting the venue. This is the v2 of the isights page, v1 is still available through the switch button on the bottom
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JUCWt_9Kw/trigger/mY4ZGI5uTN
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JUCWt_9Kw}
 */
export function businessInsightsV2PerformanceView(properties: BusinessInsightsV2PerformanceViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'business_insights_v2_performance_view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2_performance' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'JUCWt_9Kw',
        '7e9486b9fa7adb43ea84d356a9b2cc71770f0ae43124f291749e511fbb151615',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('business_insights_v2_performance_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'JUCWt_9Kw',
        'business_insights_v2_performance_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_performance_view',
        eventProperties,
        'JUCWt_9Kw',
        '7e9486b9fa7adb43ea84d356a9b2cc71770f0ae43124f291749e511fbb151615',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('business_insights_v2_performance_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BusinessInsightsV2OperationsViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * business_insights_v2_operations_view: When user logs in to merchant admin and lands on business insights v2 page after selecting a merchant/venue. v1 still available with the switch button on the bottom
 *
 * When to trigger this event:
 * 1. Trigger when user lands on this page after selecting the venue. This is the v2 of the isights page, v1 is still available through the switch button on the bottom
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/8X_elwzQx/trigger/-kYzuDD8NK
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/8X_elwzQx}
 */
export function businessInsightsV2OperationsView(properties: BusinessInsightsV2OperationsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'business_insights_v2_operations_view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2_operations' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '8X_elwzQx',
        'ade5826281325a2556e3143f5b6a037c3de27333b278ef7eedbd284828826e8f',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('business_insights_v2_operations_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '8X_elwzQx',
        'business_insights_v2_operations_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_operations_view',
        eventProperties,
        '8X_elwzQx',
        'ade5826281325a2556e3143f5b6a037c3de27333b278ef7eedbd284828826e8f',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('business_insights_v2_operations_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BusinessInsightsV2CustomerBaseViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * business_insights_v2_customer_base_view: When user logs in to merchant admin and lands on business insights v2 page after selecting a merchant/venue. v1 still available with the switch button on the bottom
 *
 * When to trigger this event:
 * 1. Trigger when user lands on this page after selecting the venue. This is the v2 of the isights page, v1 is still available through the switch button on the bottom
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JhRYtJ2o2/trigger/kBClewHN79
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JhRYtJ2o2}
 */
export function businessInsightsV2CustomerBaseView(properties: BusinessInsightsV2CustomerBaseViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'business_insights_v2_customer_base_view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2_customer_base' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'JhRYtJ2o2',
        'b7104b91c826c26c578aafc1c7baa80958195215632b25c7efdd93e2bfd2deb2',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('business_insights_v2_customer_base_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'JhRYtJ2o2',
        'business_insights_v2_customer_base_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_customer_base_view',
        eventProperties,
        'JhRYtJ2o2',
        'b7104b91c826c26c578aafc1c7baa80958195215632b25c7efdd93e2bfd2deb2',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('business_insights_v2_customer_base_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BusinessInsightsV2MenuViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * business_insights_v2_menu_view: When user logs in to merchant admin and lands on business insights v2 page after selecting a merchant/venue. v1 still available with the switch button on the bottom
 *
 * When to trigger this event:
 * 1. Trigger when user lands on this page after selecting the venue. This is the v2 of the isights page, v1 is still available through the switch button on the bottom
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/-W3J0GzF6/trigger/nbqCUFtrzn
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/-W3J0GzF6}
 */
export function businessInsightsV2MenuView(properties: BusinessInsightsV2MenuViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'business_insights_v2_menu_view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2_menu' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '-W3J0GzF6',
        '92a1ef804f97a9156af68fefc2167e74c80442164e3f8ad549cf908a3271081e',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('business_insights_v2_menu_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '-W3J0GzF6',
        'business_insights_v2_menu_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_menu_view',
        eventProperties,
        '-W3J0GzF6',
        '92a1ef804f97a9156af68fefc2167e74c80442164e3f8ad549cf908a3271081e',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('business_insights_v2_menu_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SharedMenuInteractionClickFilterVenuesOptionProperties {
  selectedFilters: string[];
}
/**
 * shared_menu_interaction_click_filter_venues_option: When the user chooses an option of the filter menu of the venues list on the Shared Menu page
 *
 * When to trigger this event:
 * 1. User clicks on any of the filtering options on the venue listing on the Shared Menu page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JPV37D7U_w/trigger/xAM6_AEZw
 *
 * @param properties the properties associatied with this event
 * @param properties.selectedFilters: (Shared Menu scope) Selected filters used to narrow down the lists of venues or offers in the listing views.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/JPV37D7U_w}
 */
export function sharedMenuInteractionClickFilterVenuesOption(
  properties: SharedMenuInteractionClickFilterVenuesOptionProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Pir0mjpMIP', name: 'selected_filters', value: properties.selectedFilters });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'shared_menu' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'filter_venues_option' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'JPV37D7U_w',
        '55ebd2395a720b78ae9351b9c85f37b31b0fa6c6afc48a061c20e5a836ac5c48',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'shared_menu_interaction_click_filter_venues_option',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'JPV37D7U_w',
        'shared_menu_interaction_click_filter_venues_option',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'shared_menu_interaction_click_filter_venues_option',
        eventProperties,
        'JPV37D7U_w',
        '55ebd2395a720b78ae9351b9c85f37b31b0fa6c6afc48a061c20e5a836ac5c48',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'shared_menu_interaction_click_filter_venues_option',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface SharedMenuInteractionClickVenueOrderbyProperties {
  venuesOrderby: string;
}
/**
 * shared_menu_interaction_click_venue_orderby: When the user clicks the column headers to reorder the venues listing on the Shared Menu page
 *
 * When to trigger this event:
 * 1. User clicks on the ordering ASC/DESC icons on the venue listing on the Shared Menu page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Cakdc60Rof/trigger/RuYBBBDHK
 *
 * @param properties the properties associatied with this event
 * @param properties.venuesOrderby: (Shared Menu scope) on the venue listing pages we can click on the table headers and order the listings by venue 'name', 'city', 'address' and 'shared menu name'.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Cakdc60Rof}
 */
export function sharedMenuInteractionClickVenueOrderby(properties: SharedMenuInteractionClickVenueOrderbyProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'rzTC8joeQd', name: 'venues_orderby', value: properties.venuesOrderby });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'shared_menu' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'venue_orderby' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Cakdc60Rof',
        '800a723d0812092765ea289e0e1d837f1bf1ed6c09467ab32d77563dbf6e3bbb',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('shared_menu_interaction_click_venue_orderby', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Cakdc60Rof',
        'shared_menu_interaction_click_venue_orderby',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'shared_menu_interaction_click_venue_orderby',
        eventProperties,
        'Cakdc60Rof',
        '800a723d0812092765ea289e0e1d837f1bf1ed6c09467ab32d77563dbf6e3bbb',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('shared_menu_interaction_click_venue_orderby', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HistoricalAvailabilityDataLoadLookerDashboardProperties {
  durationMs: number;
}
/**
 * historical_availability_data_load_looker_dashboard: When the enterprise/brand owners log in to merchant admin and visit historical availability tab, we'll send this event to measure how long it would take to complete loading the dashboard to learn if the performance of loading dashboards are acceptable.

After all tiles in the dashboard are loaded successfully, the duration between "dashboard start loading" and "dashboard complete loading" will be sent as the payload of the event.
 *
 * When to trigger this event:
 * 1. After all tiles in the dashboard are loaded successfully
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ts1UDlJ8E/trigger/XfBuvvbOPF
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/ts1UDlJ8E}
 */
export function historicalAvailabilityDataLoadLookerDashboard(
  properties: HistoricalAvailabilityDataLoadLookerDashboardProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'historical_availability' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'load_looker_dashboard' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'ts1UDlJ8E',
        'af11409e73dddc87c2cd73fda86fc52f2d5467407a7482567010a79b05553494',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'historical_availability_data_load_looker_dashboard',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'ts1UDlJ8E',
        'historical_availability_data_load_looker_dashboard',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'historical_availability_data_load_looker_dashboard',
        eventProperties,
        'ts1UDlJ8E',
        'af11409e73dddc87c2cd73fda86fc52f2d5467407a7482567010a79b05553494',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'historical_availability_data_load_looker_dashboard',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface HistoricalAvailabilityViewProperties {
  durationMs: number;
}
/**
 * historical_availability_view: Send the event when the user visit "Historical availability" tab of merchant-admin
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/H26o5mu_e/trigger/6ddfmeRKA0
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/H26o5mu_e}
 */
export function historicalAvailabilityView(properties: HistoricalAvailabilityViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'historical_availability' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'H26o5mu_e',
        'bef00a6b13ead0320c1d361df6c1e323ed8e3aedf81cd005eab798da77481860',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('historical_availability_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'H26o5mu_e',
        'historical_availability_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'historical_availability_view',
        eventProperties,
        'H26o5mu_e',
        'bef00a6b13ead0320c1d361df6c1e323ed8e3aedf81cd005eab798da77481860',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('historical_availability_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * historical_availability_data_load_looker_dashboard_error: This event will be sent when there's any error while loading historical availability looker dashboard
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/_C0lCkW78h/trigger/YiMGDJx36
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/_C0lCkW78h}
 */
export function historicalAvailabilityDataLoadLookerDashboardError() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'historical_availability' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'load_looker_dashboard_error' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '_C0lCkW78h',
        'bea85746c5dd28d2f654b6f89a0d29cf36e94c627962047566528180c3a8412e',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'historical_availability_data_load_looker_dashboard_error',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '_C0lCkW78h',
        'historical_availability_data_load_looker_dashboard_error',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'historical_availability_data_load_looker_dashboard_error',
        eventProperties,
        '_C0lCkW78h',
        'bea85746c5dd28d2f654b6f89a0d29cf36e94c627962047566528180c3a8412e',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'historical_availability_data_load_looker_dashboard_error',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface GoogleSheetPageViewProperties {
  durationMs: number;
}
/**
 * google_sheet_page_view: When users land on the import/export with Google Sheets page inside a shared menu
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/7H0Rd4eVxf/trigger/imrEdTysn
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/7H0Rd4eVxf}
 */
export function googleSheetPageView(properties: GoogleSheetPageViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'google_sheet_page' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '7H0Rd4eVxf',
        '23e7fa75cd3b9738c1411eddbca8a8d2906d28580ac609d7ee5e59a83b205cb5',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('google_sheet_page_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '7H0Rd4eVxf',
        'google_sheet_page_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'google_sheet_page_view',
        eventProperties,
        '7H0Rd4eVxf',
        '23e7fa75cd3b9738c1411eddbca8a8d2906d28580ac609d7ee5e59a83b205cb5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('google_sheet_page_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface GoogleSheetPageInteractionClickExportToSheetProperties {
  numberOfOffers: number;
  numberOfOptions: number;
  numberOfCategories: number;
}
/**
 * google_sheet_page_interaction_click_export_to_sheet: When clicking on the "Export to Google Sheet" button to create a Google Sheet based on the current menu items/options/categories
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Q9ppbMiyv/trigger/ng33xuUAO
 *
 * @param properties the properties associatied with this event
 * @param properties.numberOfOffers: Amount of items/offers when using the import/export with Google Sheets page
 * @param properties.numberOfOptions: Amount of options when using the import/export with Google Sheets page
 * @param properties.numberOfCategories: Amount of categories when using the import/export with Google Sheets page
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Q9ppbMiyv}
 */
export function googleSheetPageInteractionClickExportToSheet(
  properties: GoogleSheetPageInteractionClickExportToSheetProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Wao4BXSHr9', name: 'number_of_offers', value: properties.numberOfOffers });
  eventPropertiesArray.push({ id: 'wQ0Bke9ARj', name: 'number_of_options', value: properties.numberOfOptions });
  eventPropertiesArray.push({ id: 'tNWGSWHPN_', name: 'number_of_categories', value: properties.numberOfCategories });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'google_sheet_page' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'export_to_sheet' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Q9ppbMiyv',
        'ce035bef4b3a6f11389afdb3b6e15658080d8d8e84aa0d672009887592063ed9',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'google_sheet_page_interaction_click_export_to_sheet',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Q9ppbMiyv',
        'google_sheet_page_interaction_click_export_to_sheet',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'google_sheet_page_interaction_click_export_to_sheet',
        eventProperties,
        'Q9ppbMiyv',
        'ce035bef4b3a6f11389afdb3b6e15658080d8d8e84aa0d672009887592063ed9',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'google_sheet_page_interaction_click_export_to_sheet',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface GoogleSheetPageInteractionClickSelectSheetProperties {
  numberOfOffers: number;
  numberOfOptions: number;
  numberOfCategories: number;
}
/**
 * google_sheet_page_interaction_click_select_sheet: When clicking on the "Select Google Sheet" button to import a Google Sheet. Tracks the amount of Offers/Options/Categories were imported from the selected spreadsheet
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Cf_Cw-6Xt/trigger/PlUOpo_Wp
 *
 * @param properties the properties associatied with this event
 * @param properties.numberOfOffers: Amount of items/offers when using the import/export with Google Sheets page
 * @param properties.numberOfOptions: Amount of options when using the import/export with Google Sheets page
 * @param properties.numberOfCategories: Amount of categories when using the import/export with Google Sheets page
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Cf_Cw-6Xt}
 */
export function googleSheetPageInteractionClickSelectSheet(
  properties: GoogleSheetPageInteractionClickSelectSheetProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Wao4BXSHr9', name: 'number_of_offers', value: properties.numberOfOffers });
  eventPropertiesArray.push({ id: 'wQ0Bke9ARj', name: 'number_of_options', value: properties.numberOfOptions });
  eventPropertiesArray.push({ id: 'tNWGSWHPN_', name: 'number_of_categories', value: properties.numberOfCategories });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'google_sheet_page' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'select_sheet' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Cf_Cw-6Xt',
        '74bacfc142851d4bf2823b9ffcb27ebaa36770d16a2e76e41b11912e8b20062a',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('google_sheet_page_interaction_click_select_sheet', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Cf_Cw-6Xt',
        'google_sheet_page_interaction_click_select_sheet',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'google_sheet_page_interaction_click_select_sheet',
        eventProperties,
        'Cf_Cw-6Xt',
        '74bacfc142851d4bf2823b9ffcb27ebaa36770d16a2e76e41b11912e8b20062a',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'google_sheet_page_interaction_click_select_sheet',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface GoogleSheetPageInteractionClickUploadSheetDataProperties {
  numberOfOffers: number;
  numberOfOptions: number;
  numberOfCategories: number;
}
/**
 * google_sheet_page_interaction_click_upload_sheet_data: When clicking on the "Upload data" button to update a menu with Google Sheet data
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/FsGOnlqT2/trigger/aruOt_hO4
 *
 * @param properties the properties associatied with this event
 * @param properties.numberOfOffers: Amount of items/offers when using the import/export with Google Sheets page
 * @param properties.numberOfOptions: Amount of options when using the import/export with Google Sheets page
 * @param properties.numberOfCategories: Amount of categories when using the import/export with Google Sheets page
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/FsGOnlqT2}
 */
export function googleSheetPageInteractionClickUploadSheetData(
  properties: GoogleSheetPageInteractionClickUploadSheetDataProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Wao4BXSHr9', name: 'number_of_offers', value: properties.numberOfOffers });
  eventPropertiesArray.push({ id: 'wQ0Bke9ARj', name: 'number_of_options', value: properties.numberOfOptions });
  eventPropertiesArray.push({ id: 'tNWGSWHPN_', name: 'number_of_categories', value: properties.numberOfCategories });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'google_sheet_page' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'upload_sheet_data' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'FsGOnlqT2',
        '8ecbb746103ed81014cef8936bf3f4eab6cb80944d6fede35cd576156035c607',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'google_sheet_page_interaction_click_upload_sheet_data',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'FsGOnlqT2',
        'google_sheet_page_interaction_click_upload_sheet_data',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'google_sheet_page_interaction_click_upload_sheet_data',
        eventProperties,
        'FsGOnlqT2',
        '8ecbb746103ed81014cef8936bf3f4eab6cb80944d6fede35cd576156035c607',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'google_sheet_page_interaction_click_upload_sheet_data',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface GoogleSheetPageInteractionClickCancelSheetImportProperties {
  numberOfOffers: number;
  numberOfOptions: number;
  numberOfCategories: number;
}
/**
 * google_sheet_page_interaction_click_cancel_sheet_import: When clicking on the "Cancel" button to reset the Google Sheet interaction
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/K_4hikQCl/trigger/8j38Vq7th
 *
 * @param properties the properties associatied with this event
 * @param properties.numberOfOffers: Amount of items/offers when using the import/export with Google Sheets page
 * @param properties.numberOfOptions: Amount of options when using the import/export with Google Sheets page
 * @param properties.numberOfCategories: Amount of categories when using the import/export with Google Sheets page
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/K_4hikQCl}
 */
export function googleSheetPageInteractionClickCancelSheetImport(
  properties: GoogleSheetPageInteractionClickCancelSheetImportProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Wao4BXSHr9', name: 'number_of_offers', value: properties.numberOfOffers });
  eventPropertiesArray.push({ id: 'wQ0Bke9ARj', name: 'number_of_options', value: properties.numberOfOptions });
  eventPropertiesArray.push({ id: 'tNWGSWHPN_', name: 'number_of_categories', value: properties.numberOfCategories });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'google_sheet_page' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'cancel_sheet_import' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'K_4hikQCl',
        '7285d350a2ed0a2a01d063ac7f8679e5b3ae2488f58b98aac505d62f2a5f2ffb',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'google_sheet_page_interaction_click_cancel_sheet_import',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'K_4hikQCl',
        'google_sheet_page_interaction_click_cancel_sheet_import',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'google_sheet_page_interaction_click_cancel_sheet_import',
        eventProperties,
        'K_4hikQCl',
        '7285d350a2ed0a2a01d063ac7f8679e5b3ae2488f58b98aac505d62f2a5f2ffb',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'google_sheet_page_interaction_click_cancel_sheet_import',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface BusinessInsightsV2RatingsReviewsViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * business_insights_v2_ratings_reviews_view: When user lands on Ratings and Reviews page view.
 *
 * When to trigger this event:
 * 1. Event triggers when user lands on Ratings and reviews page.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/faTSsXXJj/trigger/M8z5Cm8CV
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/faTSsXXJj}
 */
export function businessInsightsV2RatingsReviewsView(properties: BusinessInsightsV2RatingsReviewsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({
    id: 'r5E-SMeZ21',
    name: 'event_name',
    value: 'business_insights_v2_ratings_reviews_view',
  });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2_ratings_reviews' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'faTSsXXJj',
        '8c4de3a58dd70bcd10600301c30b36283c409367f0ae183fc28895c139095bea',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('business_insights_v2_ratings_reviews_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'faTSsXXJj',
        'business_insights_v2_ratings_reviews_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_ratings_reviews_view',
        eventProperties,
        'faTSsXXJj',
        '8c4de3a58dd70bcd10600301c30b36283c409367f0ae183fc28895c139095bea',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('business_insights_v2_ratings_reviews_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BusinessInsightsV2RatingsReviewsInteractionClickFilterRatingsProperties {
  targetContentFilterRatings: TargetContentFilterRatingsValueType;
}
/**
 * business_insights_v2_ratings_reviews_interaction_click_filter_ratings: This event fires when the user clicks the Filter Ratings button in the Ratings and Reviews view, allowing users to select smileys as checkboxes for filtering reviews.
 *
 * When to trigger this event:
 * 1. Event fires when the user clicks the Filter ratings button
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/fNyQcCx9f/trigger/M-1hG_Bf1
 *
 * @param properties the properties associatied with this event
 * @param properties.targetContentFilterRatings: This event property is a follow-up event for a click on the Filter Ratings in the Merchant Admin V2, Ratings and Reviews page. It's fired when a user selects another filter for the ratings. Ratings are integer values between 1 and 5.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/fNyQcCx9f}
 */
export function businessInsightsV2RatingsReviewsInteractionClickFilterRatings(
  properties: BusinessInsightsV2RatingsReviewsInteractionClickFilterRatingsProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'e4eF8leJi',
    name: 'target_content_filter_ratings',
    value: properties.targetContentFilterRatings,
  });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2_ratings_reviews' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'filter_ratings' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'fNyQcCx9f',
        '7a9634c9986797e73629e2a511b5dc316d565c462830c98a897e1e4453e34ed2',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'business_insights_v2_ratings_reviews_interaction_click_filter_ratings',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'fNyQcCx9f',
        'business_insights_v2_ratings_reviews_interaction_click_filter_ratings',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_ratings_reviews_interaction_click_filter_ratings',
        eventProperties,
        'fNyQcCx9f',
        '7a9634c9986797e73629e2a511b5dc316d565c462830c98a897e1e4453e34ed2',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'business_insights_v2_ratings_reviews_interaction_click_filter_ratings',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface SharedMenuInteractionClickDuplicateMenuProperties {
  sharedMenuIdCloned: string;
}
/**
 * shared_menu_interaction_click_duplicate_menu: When clicking on "Duplicate menu" button, cloning an existing Shared Menu
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/KtPwhjNA8_/trigger/8PRky2Z8k
 *
 * @param properties the properties associatied with this event
 * @param properties.sharedMenuIdCloned: ID of the original Shared Menu that was used to duplicate into another one
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/KtPwhjNA8_}
 */
export function sharedMenuInteractionClickDuplicateMenu(properties: SharedMenuInteractionClickDuplicateMenuProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'pgfEyZeMX1', name: 'shared_menu_id_cloned', value: properties.sharedMenuIdCloned });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'shared_menu' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'duplicate_menu' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'KtPwhjNA8_',
        '5a0ea215aeb454b800210a3165bbeff52a6c9a5a6ebb7615910ec496cbe09056',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('shared_menu_interaction_click_duplicate_menu', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'KtPwhjNA8_',
        'shared_menu_interaction_click_duplicate_menu',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'shared_menu_interaction_click_duplicate_menu',
        eventProperties,
        'KtPwhjNA8_',
        '5a0ea215aeb454b800210a3165bbeff52a6c9a5a6ebb7615910ec496cbe09056',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'shared_menu_interaction_click_duplicate_menu',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * venue_group_interaction_click_create_venue_group_failed: This track is to track if a venue groups is failed to create



 *
 * When to trigger this event:
 * 1. After click button "Save", it calls API to create venue group. This track is to track if a venue groups is failed to create
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/KNfEo8A0NH/trigger/2Wnimo_Sj
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/KNfEo8A0NH}
 */
export function venueGroupInteractionClickCreateVenueGroupFailed() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'venue_group' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'kHNVI8N6K', name: 'interaction_type', value: 'click' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'create_venue_group_failed' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'KNfEo8A0NH',
        '982fbf1b0d2724c6e12366ec19035d0bd68195512667516a25396ba0ba235453',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'venue_group_interaction_click_create_venue_group_failed',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'KNfEo8A0NH',
        'venue_group_interaction_click_create_venue_group_failed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'venue_group_interaction_click_create_venue_group_failed',
        eventProperties,
        'KNfEo8A0NH',
        '982fbf1b0d2724c6e12366ec19035d0bd68195512667516a25396ba0ba235453',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'venue_group_interaction_click_create_venue_group_failed',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface SharedMenuInteractionClickDeleteMenuProperties {
  sharedMenuId: string;
}
/**
 * shared_menu_interaction_click_delete_menu: When clicking on "Delete" button, deleting an existing Shared Menu
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/pNkeBFt_t/trigger/ApKE_GxT3W
 *
 * @param properties the properties associatied with this event
 * @param properties.sharedMenuId: Describes the unique identifier of the shared menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/pNkeBFt_t}
 */
export function sharedMenuInteractionClickDeleteMenu(properties: SharedMenuInteractionClickDeleteMenuProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'uK7RgUVXeo', name: 'shared_menu_id', value: properties.sharedMenuId });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'shared_menu' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'delete_menu' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'pNkeBFt_t',
        'f8ae6c3d64289338bfb764fd2f5c0db7bd4e9b55da812951206754e48ad78ffe',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('shared_menu_interaction_click_delete_menu', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'pNkeBFt_t',
        'shared_menu_interaction_click_delete_menu',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'shared_menu_interaction_click_delete_menu',
        eventProperties,
        'pNkeBFt_t',
        'f8ae6c3d64289338bfb764fd2f5c0db7bd4e9b55da812951206754e48ad78ffe',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('shared_menu_interaction_click_delete_menu', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SharedMenuInteractionClickRenameMenuProperties {
  sharedMenuId: string;
}
/**
 * shared_menu_interaction_click_rename_menu: When clicking on "Rename" button, renaming an existing Shared Menu
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/RZ_SAyHri/trigger/w8iM5iZvYc
 *
 * @param properties the properties associatied with this event
 * @param properties.sharedMenuId: Describes the unique identifier of the shared menu
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/RZ_SAyHri}
 */
export function sharedMenuInteractionClickRenameMenu(properties: SharedMenuInteractionClickRenameMenuProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'uK7RgUVXeo', name: 'shared_menu_id', value: properties.sharedMenuId });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'shared_menu' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'rename_menu' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'RZ_SAyHri',
        '4c4036db67ce564759605d55d6469b2a13130f1b0e8b354ca5b02c2109a60baf',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('shared_menu_interaction_click_rename_menu', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'RZ_SAyHri',
        'shared_menu_interaction_click_rename_menu',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'shared_menu_interaction_click_rename_menu',
        eventProperties,
        'RZ_SAyHri',
        '4c4036db67ce564759605d55d6469b2a13130f1b0e8b354ca5b02c2109a60baf',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('shared_menu_interaction_click_rename_menu', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BusinessInsightsInteractionUpdateSidebarWidthProperties {
  sidebarWidthUpdateType: SidebarWidthUpdateTypeValueType;
}
/**
 * business_insights_interaction_update_sidebar_width: This event fires when the user clicks the button to toggle the sidebar width. When the sidebar is fully visible, pressing the button will cause the sidebar to minimize or become "narrow", reducing its width. When the sidebar is minimized or "narrow", pressing the button again will revert the sidebar back to its original, fully visible state.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/8noHJpmCe/trigger/FlvHC_DGw
 *
 * @param properties the properties associatied with this event
 * @param properties.sidebarWidthUpdateType: Tells whether the click expanded or collapsed the sidebar.
expanded = click expanded the sidebar
collapsed= click collapsed the sidebar
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/8noHJpmCe}
 */
export function businessInsightsInteractionUpdateSidebarWidth(
  properties: BusinessInsightsInteractionUpdateSidebarWidthProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'sYyyFxJDI',
    name: 'sidebar_width_update_type',
    value: properties.sidebarWidthUpdateType,
  });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'update_sidebar_width' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '8noHJpmCe',
        '0278bf533cfeaef4c7cc136bc3bc324669fdc3e08544f77634e69112d9214b58',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'business_insights_interaction_update_sidebar_width',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '8noHJpmCe',
        'business_insights_interaction_update_sidebar_width',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_interaction_update_sidebar_width',
        eventProperties,
        '8noHJpmCe',
        '0278bf533cfeaef4c7cc136bc3bc324669fdc3e08544f77634e69112d9214b58',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'business_insights_interaction_update_sidebar_width',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface MerchantAdminSearchViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * merchant_admin_search_view: When user opens search bar functionality from the side bar. This is a general option for Merchant Admin, not just Insights.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/tUggpayYi/trigger/2XuJ0WF69
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/tUggpayYi}
 */
export function merchantAdminSearchView(properties: MerchantAdminSearchViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_search' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'tUggpayYi',
        'd22c9b27a315994d602e8849b151308db1446dfb164ef111eb1277df87f78d52',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('merchant_admin_search_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'tUggpayYi',
        'merchant_admin_search_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_search_view',
        eventProperties,
        'tUggpayYi',
        'd22c9b27a315994d602e8849b151308db1446dfb164ef111eb1277df87f78d52',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('merchant_admin_search_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MerchantAdminUserSettingsViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * merchant_admin_user_settings_view: When user opens user settings dropdown window from the side bar. This is a general option for Merchant Admin, not just Insights.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/HL77-K8Fk/trigger/OrVFJej4e
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/HL77-K8Fk}
 */
export function merchantAdminUserSettingsView(properties: MerchantAdminUserSettingsViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_user_settings' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'HL77-K8Fk',
        '0440a8a25c6bb58e10582a43a21ad762278da3aa10088110764c7c9e4b40aca1',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('merchant_admin_user_settings_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'HL77-K8Fk',
        'merchant_admin_user_settings_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_user_settings_view',
        eventProperties,
        'HL77-K8Fk',
        '0440a8a25c6bb58e10582a43a21ad762278da3aa10088110764c7c9e4b40aca1',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('merchant_admin_user_settings_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_user_settings_interaction_support: This event fires when the user clicks the Support option from user settings dropdown menu.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/iq6YOFioj/trigger/o6ayKO93k
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/iq6YOFioj}
 */
export function merchantAdminUserSettingsInteractionSupport() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'support' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_user_settings' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'iq6YOFioj',
        '4770c057b8f1f9602db170246c9405a3671943592e53b46bffe1360e127a81b7',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('merchant_admin_user_settings_interaction_support', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'iq6YOFioj',
        'merchant_admin_user_settings_interaction_support',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_user_settings_interaction_support',
        eventProperties,
        'iq6YOFioj',
        '4770c057b8f1f9602db170246c9405a3671943592e53b46bffe1360e127a81b7',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_user_settings_interaction_support',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_user_settings_interaction_language: This event fires when the user clicks the Language option from user settings dropdown menu.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/bup6RtCQc/trigger/vIVOMZnSK
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/bup6RtCQc}
 */
export function merchantAdminUserSettingsInteractionLanguage() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'language' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_user_settings' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'bup6RtCQc',
        '4831182b1561a3e1c00542981f698880aa59221ddf8d3b85f3a507086e678a32',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'merchant_admin_user_settings_interaction_language',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'bup6RtCQc',
        'merchant_admin_user_settings_interaction_language',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_user_settings_interaction_language',
        eventProperties,
        'bup6RtCQc',
        '4831182b1561a3e1c00542981f698880aa59221ddf8d3b85f3a507086e678a32',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_user_settings_interaction_language',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_user_settings_interaction_logout: This event fires when the user clicks the Logout option from user settings dropdown menu.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/LoKbqcfTu/trigger/c1aEQ4S54
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/LoKbqcfTu}
 */
export function merchantAdminUserSettingsInteractionLogout() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'logout' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_user_settings' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'LoKbqcfTu',
        '7d3a7815f3875e1688a4a9a4904066e3977516af87db1dc9d95fe71a1308b57e',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('merchant_admin_user_settings_interaction_logout', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'LoKbqcfTu',
        'merchant_admin_user_settings_interaction_logout',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_user_settings_interaction_logout',
        eventProperties,
        'LoKbqcfTu',
        '7d3a7815f3875e1688a4a9a4904066e3977516af87db1dc9d95fe71a1308b57e',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_user_settings_interaction_logout',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_user_settings_interaction_dark_mode: This event fires when the user clicks the Dark mode option from user settings dropdown menu.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/G_vf6U21_/trigger/HKdqlLmxK
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/G_vf6U21_}
 */
export function merchantAdminUserSettingsInteractionDarkMode() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'dark_mode' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_user_settings' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'G_vf6U21_',
        '47c63e443816294b2ed99d682a3caa773e0f3f0bde36cb6ec97d13e40e5a5bab',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'merchant_admin_user_settings_interaction_dark_mode',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'G_vf6U21_',
        'merchant_admin_user_settings_interaction_dark_mode',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_user_settings_interaction_dark_mode',
        eventProperties,
        'G_vf6U21_',
        '47c63e443816294b2ed99d682a3caa773e0f3f0bde36cb6ec97d13e40e5a5bab',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_user_settings_interaction_dark_mode',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface MerchantAdminSearchDataResultsProperties {
  resultCount: number;
  queryValue: string;
  viewType: string;
}
/**
 * merchant_admin_search_data_results: This background data event is recorded when receiving search results from the backend.

 This event should not be sent if user didn't enter any search query.
 *
 * When to trigger this event:
 * 1. Here we should log:
result_count = 3
query_value = 'grill 51'
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/_IjOVNYvC/trigger/EKn7FgbJg
 *
 * @param properties the properties associatied with this event
 * @param properties.resultCount: ⚠️ Temporarily leave. To be replaced with a pair result_count_venues & result_count_items.
Number of items shown in the search results (for legacy search view without sections and for in-venue search)
 * @param properties.queryValue: Shows the value of the search query in the view
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/_IjOVNYvC}
 */
export function merchantAdminSearchDataResults(properties: MerchantAdminSearchDataResultsProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'sv_SbZFZa1p', name: 'result_count', value: properties.resultCount });
  eventPropertiesArray.push({ id: 'Qt6TIJzG9b8', name: 'query_value', value: properties.queryValue });
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'results' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_search' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '_IjOVNYvC',
        '4652ba612fe7a7e7ef64e07ca0570e5717231d0c40d5a976b7314aff326f08d8',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('merchant_admin_search_data_results', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '_IjOVNYvC',
        'merchant_admin_search_data_results',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_search_data_results',
        eventProperties,
        '_IjOVNYvC',
        '4652ba612fe7a7e7ef64e07ca0570e5717231d0c40d5a976b7314aff326f08d8',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('merchant_admin_search_data_results', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ImportExistingMenuFromVenueDataImportVenueIdProperties {
  venueIdSelected: string[];
}
/**
 * import_existing_menu_from_venue_data_import_venue_id: When the user clicks on "Import" (submit) after opening the importing modal & selecting a venue.
 *
 * When to trigger this event:
 * 1. Triggered when clicking on the "Import" button.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/63eCvprY6p/trigger/J8hf75c4f
 *
 * @param properties the properties associatied with this event
 * @param properties.venueIdSelected: Ids of selected venues
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/63eCvprY6p}
 */
export function importExistingMenuFromVenueDataImportVenueId(
  properties: ImportExistingMenuFromVenueDataImportVenueIdProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'J7VBNFsIz', name: 'venue_id_selected', value: properties.venueIdSelected });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'import_existing_menu_from_venue' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'import_venue_id' });
  eventPropertiesArray.push({ id: 'u5JNgZnkg', name: 'triggered_from_shared_menu', value: true });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '63eCvprY6p',
        '93075683e315794339e1ba1c6a289ecf5bc4b08f8b07114adeecdd94903c786b',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'import_existing_menu_from_venue_data_import_venue_id',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '63eCvprY6p',
        'import_existing_menu_from_venue_data_import_venue_id',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'import_existing_menu_from_venue_data_import_venue_id',
        eventProperties,
        '63eCvprY6p',
        '93075683e315794339e1ba1c6a289ecf5bc4b08f8b07114adeecdd94903c786b',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'import_existing_menu_from_venue_data_import_venue_id',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface MerchantSelfServiceSignUpViewProperties {
  durationMs: number;
}
/**
 * merchant_self_service_sign_up_view: Triggered when user sees the single page merchant self service sign up view.
 *
 * When to trigger this event:
 * 1. Triggered when user views single self service sign up page for merchants.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Ijvf8QCHiI/trigger/geg3ETFdp
 *
 * @param properties the properties associatied with this event
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/Ijvf8QCHiI}
 */
export function merchantSelfServiceSignUpView(properties: MerchantSelfServiceSignUpViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_self_service_sign_up' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'Ijvf8QCHiI',
        'b4dae0cda1f5e11c6cc94eb4bd9c1ff37b30c30991410153c9a92609c8de8420',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('merchant_self_service_sign_up_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'Ijvf8QCHiI',
        'merchant_self_service_sign_up_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_self_service_sign_up_view',
        eventProperties,
        'Ijvf8QCHiI',
        'b4dae0cda1f5e11c6cc94eb4bd9c1ff37b30c30991410153c9a92609c8de8420',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('merchant_self_service_sign_up_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MerchantSelfServiceSignUpDataFormSubmissionStatusProperties {
  formSubmissionStatus: FormSubmissionStatusValueType;
  businessId: string;
}
/**
 * merchant_self_service_sign_up_data_form_submission_status: Data event fired when user submits data in the self service sign up form.
 *
 * When to trigger this event:
 * 1. Trigger when user submits the form.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/254EtO2iFm/trigger/JTVNmAmJE
 *
 * @param properties the properties associatied with this event
 * @param properties.formSubmissionStatus: Form submission status is 'success' if sign up form is submitted successfully, otherwise status is 'error'.
 * @param properties.businessId: Unique business ID entered by user in the merchant sign-up form.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/254EtO2iFm}
 */
export function merchantSelfServiceSignUpDataFormSubmissionStatus(
  properties: MerchantSelfServiceSignUpDataFormSubmissionStatusProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({
    id: 'jDhyeZ5Ve',
    name: 'form_submission_status',
    value: properties.formSubmissionStatus,
  });
  eventPropertiesArray.push({ id: 'JQed8gc5x', name: 'business_id', value: properties.businessId });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'form_submission_status' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_self_service_sign_up' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '254EtO2iFm',
        'b2234b67a07c3328eafdb72c924248d7faa0eba2b055545181abf2ae0b2713f8',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'merchant_self_service_sign_up_data_form_submission_status',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '254EtO2iFm',
        'merchant_self_service_sign_up_data_form_submission_status',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_self_service_sign_up_data_form_submission_status',
        eventProperties,
        '254EtO2iFm',
        'b2234b67a07c3328eafdb72c924248d7faa0eba2b055545181abf2ae0b2713f8',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_self_service_sign_up_data_form_submission_status',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * campaigns_limit_warning_overlay: This banner is shown in Merchant Admin Campaigns when the user has 3 or fewer campaigns left to create from the campaigns limit number.

 *
 * When to trigger this event:
 * 1. Triggered when the user has 3 or fewer campaigns left to create from the campaigns limit number.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/mRJ0L_46k1/trigger/JvsoqwaZr
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/mRJ0L_46k1}
 */
export function campaignsLimitWarningOverlay() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'q2xnZ3Hu8', name: 'overlay', value: 'campaigns_limit_warning' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'overlay' });
  eventPropertiesArray.push({ id: '_5Cuynmzf', name: 'overlay_type', value: 'banner' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'mRJ0L_46k1',
        '7c1062d664e062cbba5d07f475611546c41f9a98772ad72b6eb78d256c28629e',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('campaigns_limit_warning_overlay', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'mRJ0L_46k1',
        'campaigns_limit_warning_overlay',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'campaigns_limit_warning_overlay',
        eventProperties,
        'mRJ0L_46k1',
        '7c1062d664e062cbba5d07f475611546c41f9a98772ad72b6eb78d256c28629e',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('campaigns_limit_warning_overlay', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * campaigns_limit_reached_overlay: This banner is shown in Merchant Admin Campaigns when the user has reached the limit of the numbers of campaigns which can be created.
 *
 * When to trigger this event:
 * 1. Triggered when the user has reached the campaigns limit number.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/XYwW0iUXdt/trigger/lYyxDvIjj
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/XYwW0iUXdt}
 */
export function campaignsLimitReachedOverlay() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'q2xnZ3Hu8', name: 'overlay', value: 'campaigns_limit_reached' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'overlay' });
  eventPropertiesArray.push({ id: '_5Cuynmzf', name: 'overlay_type', value: 'banner' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'XYwW0iUXdt',
        '6e5b9ad8eb71315be5b9a8e20bd3e6d908d075a2d4a7f9e79c6e8cbb3e4922c9',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('campaigns_limit_reached_overlay', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'XYwW0iUXdt',
        'campaigns_limit_reached_overlay',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'campaigns_limit_reached_overlay',
        eventProperties,
        'XYwW0iUXdt',
        '6e5b9ad8eb71315be5b9a8e20bd3e6d908d075a2d4a7f9e79c6e8cbb3e4922c9',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('campaigns_limit_reached_overlay', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RestaurantDetailsInteractionClickToggleDeliveryAreaProperties {
  viewType: string;
}
/**
 * restaurant_details_interaction_click_toggle_delivery_area: This event is triggered when use clicks the delivery area enabled/disabled toggle in restaurant details page. Only applicable for Self Delivery venues.
 *
 * When to trigger this event:
 * 1. This event is triggered when use clicks the delivery area enabled/disabled toggle in restaurant details page
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/6tpdnOV3_z/trigger/iVwpBpV0w
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/6tpdnOV3_z}
 */
export function restaurantDetailsInteractionClickToggleDeliveryArea(
  properties: RestaurantDetailsInteractionClickToggleDeliveryAreaProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'restaurant_details' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'click' });
  eventPropertiesArray.push({ id: 'nvdPVEHyGh', name: 'click_target', value: 'toggle_delivery_area' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '6tpdnOV3_z',
        '81904a3ca263ee149ca0a3b3833705bc8ea2a33ea21d1df401674d7a6cc7d674',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'restaurant_details_interaction_click_toggle_delivery_area',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '6tpdnOV3_z',
        'restaurant_details_interaction_click_toggle_delivery_area',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'restaurant_details_interaction_click_toggle_delivery_area',
        eventProperties,
        '6tpdnOV3_z',
        '81904a3ca263ee149ca0a3b3833705bc8ea2a33ea21d1df401674d7a6cc7d674',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'restaurant_details_interaction_click_toggle_delivery_area',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface RestaurantDetailsDataSaveDeliveryAreasProperties {
  viewType: string;
}
/**
 * restaurant_details_data_save_delivery_areas: This event is triggered when a user saves delivery area modifications. Only applicable for Self Delivery venues
 *
 * When to trigger this event:
 * 1. This event is triggered when a user saves delivery area modifications. Only applicable for Self Delivery venues
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/RvGwvfkDHt/trigger/_E6yAuWyS
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/RvGwvfkDHt}
 */
export function restaurantDetailsDataSaveDeliveryAreas(properties: RestaurantDetailsDataSaveDeliveryAreasProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'restaurant_details' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'data' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'save_delivery_areas' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'RvGwvfkDHt',
        'cd23f2ec6793c46499fdf51c1754dc8576282998bc3b8007a232ff2961eb673b',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('restaurant_details_data_save_delivery_areas', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'RvGwvfkDHt',
        'restaurant_details_data_save_delivery_areas',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'restaurant_details_data_save_delivery_areas',
        eventProperties,
        'RvGwvfkDHt',
        'cd23f2ec6793c46499fdf51c1754dc8576282998bc3b8007a232ff2961eb673b',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('restaurant_details_data_save_delivery_areas', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RestaurantDetailsImpressionDeliveryAreasProperties {
  viewType: string;
}
/**
 * restaurant_details_impression_delivery_areas: This impression event is triggered when the user should see self-serve venue delivery area settings. This is only applicable to venues with Self Delivery enabled.
 *
 * When to trigger this event:
 * 1. This impression event is triggered when the user should see self-serve venue delivery area settings. This is only applicable to venues with Self Delivery enabled.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/SpvR0Q_Bjg/trigger/O2XVtZDVc
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/SpvR0Q_Bjg}
 */
export function restaurantDetailsImpressionDeliveryAreas(
  properties: RestaurantDetailsImpressionDeliveryAreasProperties,
) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'restaurant_details' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'impression' });
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'delivery_areas' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'SpvR0Q_Bjg',
        '65cdb8453011affdd043e9f7dd936f9c085a4657f02c8d0e1c9d3d11acead5a5',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('restaurant_details_impression_delivery_areas', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'SpvR0Q_Bjg',
        'restaurant_details_impression_delivery_areas',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'restaurant_details_impression_delivery_areas',
        eventProperties,
        'SpvR0Q_Bjg',
        '65cdb8453011affdd043e9f7dd936f9c085a4657f02c8d0e1c9d3d11acead5a5',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'restaurant_details_impression_delivery_areas',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * business_insights_v2_ratings_reviews_interaction_send_offer: This event fires when the user clicks the Send button from user Ratings & Reviews list to send a discount offer to consumer after getting bad review.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/jSq4J79SJ0/trigger/RfnHyme-D
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/jSq4J79SJ0}
 */
export function businessInsightsV2RatingsReviewsInteractionSendOffer() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'send_offer' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2_ratings_reviews' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'jSq4J79SJ0',
        '33b7012401d4c6e0c7f562e8ca7c18db3c65343f2be9ecb40e809eacea719e9b',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'business_insights_v2_ratings_reviews_interaction_send_offer',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'jSq4J79SJ0',
        'business_insights_v2_ratings_reviews_interaction_send_offer',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_ratings_reviews_interaction_send_offer',
        eventProperties,
        'jSq4J79SJ0',
        '33b7012401d4c6e0c7f562e8ca7c18db3c65343f2be9ecb40e809eacea719e9b',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'business_insights_v2_ratings_reviews_interaction_send_offer',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * business_insights_v2_ratings_reviews_interaction_hover_offer: This event fires when the user hovers over the "Send offer" message inside Ratings & Reviews list.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/NYSFs8HIKe/trigger/WwRqLyqh5
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/NYSFs8HIKe}
 */
export function businessInsightsV2RatingsReviewsInteractionHoverOffer() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'hover_offer' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'business_insights_v2_ratings_reviews' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'NYSFs8HIKe',
        '9ee299e028c1b973dd670793807ec29bc2ba1d187f101af8fadd3bf16fd43ca2',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'business_insights_v2_ratings_reviews_interaction_hover_offer',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'NYSFs8HIKe',
        'business_insights_v2_ratings_reviews_interaction_hover_offer',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'business_insights_v2_ratings_reviews_interaction_hover_offer',
        eventProperties,
        'NYSFs8HIKe',
        '9ee299e028c1b973dd670793807ec29bc2ba1d187f101af8fadd3bf16fd43ca2',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'business_insights_v2_ratings_reviews_interaction_hover_offer',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export interface MerchantAdminPurchasesViewProperties {
  viewType: string;
  durationMs: number;
}
/**
 * merchant_admin_purchases_view: This event tells us when a user lands in the Purchases page (previously known as Live Purchases) in Merchant Admin.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/dpHcsD8U6/trigger/eN0zDbk50
 *
 * @param properties the properties associatied with this event
 * @param properties.viewType: Defines if page is visited for a venue, merchant or venue group
 * @param properties.durationMs: How long a view or overlay was visible to the user in milliseconds.
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/dpHcsD8U6}
 */
export function merchantAdminPurchasesView(properties: MerchantAdminPurchasesViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'RkxYRVyRub', name: 'view_type', value: properties.viewType });
  eventPropertiesArray.push({ id: 'Nu5Md_3-7D', name: 'duration_ms', value: properties.durationMs });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'view' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_purchases' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'dpHcsD8U6',
        'cfe65f74eb9437882a2d5f1e6a5cd3fce385f30c5d294619311f6af26206578c',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent('merchant_admin_purchases_view', eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'dpHcsD8U6',
        'merchant_admin_purchases_view',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_purchases_view',
        eventProperties,
        'dpHcsD8U6',
        'cfe65f74eb9437882a2d5f1e6a5cd3fce385f30c5d294619311f6af26206578c',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent('merchant_admin_purchases_view', (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_purchases_interaction_download_csv: This event is triggered when the user selects the Download CSV option from the Download dropdown menu on the Purchases page. However, there is still one more step and confirmation needed before starting the download and this we log as a new event.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/hJOUK4zvU/trigger/v6I01spDU
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/hJOUK4zvU}
 */
export function merchantAdminPurchasesInteractionDownloadCsv() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'download_csv' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_purchases' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'hJOUK4zvU',
        '30d9ffd7d6c27b385ec6be750e6d025e612877c48ffb4c353140c8d2a23cea0f',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'merchant_admin_purchases_interaction_download_csv',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'hJOUK4zvU',
        'merchant_admin_purchases_interaction_download_csv',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_purchases_interaction_download_csv',
        eventProperties,
        'hJOUK4zvU',
        '30d9ffd7d6c27b385ec6be750e6d025e612877c48ffb4c353140c8d2a23cea0f',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_purchases_interaction_download_csv',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_purchases_interaction_get_receipts: This event is triggered when the user selects the Get receipts option from the Download dropdown menu on the Purchases page. However, there is still one more step to enter E-Mail and confirmation needed before getting the receipts.

 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/qPIGEwbaD/trigger/bcebaL4DV
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/qPIGEwbaD}
 */
export function merchantAdminPurchasesInteractionGetReceipts() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'get_receipts' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_purchases' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'qPIGEwbaD',
        '7838acc22a2467bcf51cc98ff697257a689b2d53ddb0875aa5dd2263022749d4',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'merchant_admin_purchases_interaction_get_receipts',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'qPIGEwbaD',
        'merchant_admin_purchases_interaction_get_receipts',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_purchases_interaction_get_receipts',
        eventProperties,
        'qPIGEwbaD',
        '7838acc22a2467bcf51cc98ff697257a689b2d53ddb0875aa5dd2263022749d4',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_purchases_interaction_get_receipts',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_purchases_interaction_switch_to_items: This event is triggered when the user switches to the Items view on the Purchases page.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/NHrRSscHs/trigger/KEdvXlev_
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/NHrRSscHs}
 */
export function merchantAdminPurchasesInteractionSwitchToItems() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'switch_to_items' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_purchases' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'NHrRSscHs',
        '4c38957b066114e813acf9050567bc8ed5e535600a4a670834b6a387df466838',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'merchant_admin_purchases_interaction_switch_to_items',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'NHrRSscHs',
        'merchant_admin_purchases_interaction_switch_to_items',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_purchases_interaction_switch_to_items',
        eventProperties,
        'NHrRSscHs',
        '4c38957b066114e813acf9050567bc8ed5e535600a4a670834b6a387df466838',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_purchases_interaction_switch_to_items',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_purchases_interaction_switch_to_orders: This event is triggered when the user switches to the Orders view on the Purchases page. This is the default view when landing on the Purchases page, therefore we only trigger this click interaction event when user was before on Items view and switches back to Orders view.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/EbVTOm9j7/trigger/lEBpmd3eK
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/EbVTOm9j7}
 */
export function merchantAdminPurchasesInteractionSwitchToOrders() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'switch_to_orders' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_purchases' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'EbVTOm9j7',
        'cc5ac036b95936358c4e1ba2e70dffbc579b84ae306683ebd135574c32a3d306',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'merchant_admin_purchases_interaction_switch_to_orders',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'EbVTOm9j7',
        'merchant_admin_purchases_interaction_switch_to_orders',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_purchases_interaction_switch_to_orders',
        eventProperties,
        'EbVTOm9j7',
        'cc5ac036b95936358c4e1ba2e70dffbc579b84ae306683ebd135574c32a3d306',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_purchases_interaction_switch_to_orders',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_purchases_interaction_download_csv_confirmed: This event is triggered when the user clicks the final "Download CSV" button in the small window, confirming the download.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/5vvfro6LC/trigger/DwG_ytWF1
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/5vvfro6LC}
 */
export function merchantAdminPurchasesInteractionDownloadCsvConfirmed() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'download_csv_confirmed' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_purchases' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        '5vvfro6LC',
        'bbf64b970099f65829193195abb767881ccf7d450ec4f8faa24daa16a1c53724',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'merchant_admin_purchases_interaction_download_csv_confirmed',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        '5vvfro6LC',
        'merchant_admin_purchases_interaction_download_csv_confirmed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_purchases_interaction_download_csv_confirmed',
        eventProperties,
        '5vvfro6LC',
        'bbf64b970099f65829193195abb767881ccf7d450ec4f8faa24daa16a1c53724',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_purchases_interaction_download_csv_confirmed',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

/**
 * merchant_admin_purchases_interaction_get_receipts_confirmed: This event is triggered when the user clicks the final "Send" button in the small window, confirming the intent to receive receipts via E-Mail provided here too.
 *
 * When to trigger this event:
 * 1.
 * View in Avo: https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MDMSq6cu0/trigger/6uFUkDArm
 *
 * @see {@link https://www.avo.app/schemas/Qxw4SpNZAmmYOzZQPcag/events/MDMSq6cu0}
 */
export function merchantAdminPurchasesInteractionGetReceiptsConfirmed() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({ id: 'r5E-SMeZ21', name: 'event_name', value: 'get_receipts_confirmed' });
  eventPropertiesArray.push({ id: 'pp5TYQIUMm', name: 'log_type', value: 'interaction' });
  eventPropertiesArray.push({ id: 'dLEBXcR0Ty', name: 'view', value: 'merchant_admin_purchases' });
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(
        __AVO_ENV__,
        'MDMSq6cu0',
        '01d1b24fe4d2c015d7bee449687d315dd5737694e75716e146a62c0d5b864c79',
        messages.map(m =>
          Object.assign(
            {},
            {
              tag: m.tag,
              propertyId: m.propertyId,
              additionalProperties: m.additionalProperties,
              actualType: m.actualType,
            },
          ),
        ),
        'event',
      );
    }
    InternalAvoLogger.logEventSent(
      'merchant_admin_purchases_interaction_get_receipts_confirmed',
      eventProperties,
      userProperties,
    );
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log(
        'MDMSq6cu0',
        'merchant_admin_purchases_interaction_get_receipts_confirmed',
        messages,
        eventPropertiesArray,
        userPropertiesArray,
        [],
      );
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent(
        'merchant_admin_purchases_interaction_get_receipts_confirmed',
        eventProperties,
        'MDMSq6cu0',
        '01d1b24fe4d2c015d7bee449687d315dd5737694e75716e146a62c0d5b864c79',
      );
    }
    // destination WoltGatekeeper
    WoltGatekeeper.logEvent(
      'merchant_admin_purchases_interaction_get_receipts_confirmed',
      (Object as any).assign({}, eventProperties),
    );
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  avoInspectorApiKey,
  TargetContentDatePicker,
  OptionSelected,
  TargetContentCampaignsTable,
  TargetContentNewCampaigns,
  CampaignType,
  TargetContentCampaignEdit,
  DeliveryType,
  OverlayType,
  Source,
  View,
  TargetContentFilterRatings,
  SourceTitle,
  FormSubmissionStatus,
  InteractionType,
  ClickTarget,
  LogType,
  Overlay,
  EventName,
  SidebarWidthUpdateType,
  homepageView,
  businessInsightsView,
  menuEditorView,
  purchasesView,
  contactSupport,
  enterpriseAnalyticsDataLoadLookerDashboard,
  purchasesDataCsvDownload,
  purchasesErrorCsvDownload,
  allItemsInteractionClickExportMenu,
  allItemsInteractionClickStartMenuImport,
  allItemsInteractionClickImportMenu,
  allItemsInteractionClickImportItemImages,
  allItemsInteractionClickSelectImages,
  allItemsInteractionClickStartUploading,
  allItemsInteractionClickCreateItems,
  allItemsInteractionClickSubmitItemsCreation,
  allItemsInteractionClickUpdateItems,
  allItemsInteractionClickSubmitItemUpdating,
  allItemsInteractionClickDownloadItems,
  allItemsInteractionClickExportVersions,
  interactionClickEditCategory,
  interactionClickDeleteCategory,
  interactionClickImportItems,
  interactionClickExportItems,
  interactionClickEnableItems,
  interactionClickDisableItems,
  interactionClickCreateItemCopy,
  interactionClickCreateSpecial,
  interactionClickDisableItem,
  interactionClickEnableItem,
  interactionClickDeleteItem,
  interactionClickRemoveItemFromCategory,
  interactionClickSaveNewOption,
  interactionClickSaveItemChanges,
  interactionClickSaveNewItem,
  interactionClickAddNewCategory,
  interactionClickViewOnWolt,
  allItemsView,
  allOptionsView,
  allDisabledView,
  itemsNoCategoryView,
  categoriesView,
  interactionClickEnableOrDisable,
  interactionClickSetAvailability,
  interactionClickChangeStockAvailability,
  interactionClickChangePrice,
  interactionClickSetCourierRestrictions,
  interactionClickAddOptions,
  interactionClickChangeCategory,
  interactionClickChangeCommissions,
  interactionClickChangeVat,
  interactionClickCreateWoltSpecials,
  interactionClickDeleteItems,
  allItemsInteractionClickCreateSelectFile,
  allItemsInteractionClickUpdateSelectFile,
  interactionClickAddSubcategories,
  allItemsInteractionClickMenuImportSelectFile,
  interactionClickEditOption,
  interactionClickEditSubcategory,
  interactionClickDeleteSubcategory,
  businessInsightsInteractionClickChartSource,
  businessInsightsInteractionClickDatePicker,
  campaignsView,
  campaignsInteractionClickCampaignTable,
  campaignsInteractionClickNewCampaign,
  chooseCampaignInteractionClickCampaignSelection,
  newCampaignInteractionClickCampaignRules,
  updateCampaignDataEndCampaign,
  newCampaignRulesView,
  newCampaignInteractionClickCampaignRulesBasket,
  newCampaignRulesInteractionClickUserRules,
  updateCampaignDataUpdateCampaign,
  newCampaignDataCreateCampaign,
  updateCampaignInteractionClickCampaignUpdate,
  businessInsightsV2View,
  businessInsightsV2InteractionClickSwitchToOldInsights,
  enterpriseBrandUserManagementInteractionClickSendInvitation,
  interactionClickCreateSharedMenu,
  interactionClickShareMenuWithVenues,
  interactionClickStopSharingMenu,
  interactionClickEditSharedMenu,
  interactionClickSchedulePublishing,
  interactionClickPublishNow,
  interactionClickInstallMerchantAdmin,
  pwaAppInstalled,
  newCampaignView,
  chooseCampaignView,
  updateCampaignView,
  campaignDetailsView,
  updateCampaignInteractionClickCampaignRulesBasket,
  updateCampaignRulesInteractionClickUserRules,
  deliveryTypeModalView,
  deliveryTypeModalDataConfirm,
  restaurantDetailsView,
  restaurantDetailsInteractionClickSwitchDeliveryType,
  venueAvailabilityView,
  profileInteractionClickSubscriptionRow,
  allItemsInteractionClickAddItemsToCatalog,
  businessInsightsV2PerformanceView,
  businessInsightsV2OperationsView,
  businessInsightsV2CustomerBaseView,
  businessInsightsV2MenuView,
  sharedMenuInteractionClickFilterVenuesOption,
  sharedMenuInteractionClickVenueOrderby,
  historicalAvailabilityDataLoadLookerDashboard,
  historicalAvailabilityView,
  historicalAvailabilityDataLoadLookerDashboardError,
  googleSheetPageView,
  googleSheetPageInteractionClickExportToSheet,
  googleSheetPageInteractionClickSelectSheet,
  googleSheetPageInteractionClickUploadSheetData,
  googleSheetPageInteractionClickCancelSheetImport,
  businessInsightsV2RatingsReviewsView,
  businessInsightsV2RatingsReviewsInteractionClickFilterRatings,
  sharedMenuInteractionClickDuplicateMenu,
  venueGroupInteractionClickCreateVenueGroupFailed,
  sharedMenuInteractionClickDeleteMenu,
  sharedMenuInteractionClickRenameMenu,
  businessInsightsInteractionUpdateSidebarWidth,
  merchantAdminSearchView,
  merchantAdminUserSettingsView,
  merchantAdminUserSettingsInteractionSupport,
  merchantAdminUserSettingsInteractionLanguage,
  merchantAdminUserSettingsInteractionLogout,
  merchantAdminUserSettingsInteractionDarkMode,
  merchantAdminSearchDataResults,
  importExistingMenuFromVenueDataImportVenueId,
  merchantSelfServiceSignUpView,
  merchantSelfServiceSignUpDataFormSubmissionStatus,
  campaignsLimitWarningOverlay,
  campaignsLimitReachedOverlay,
  restaurantDetailsInteractionClickToggleDeliveryArea,
  restaurantDetailsDataSaveDeliveryAreas,
  restaurantDetailsImpressionDeliveryAreas,
  businessInsightsV2RatingsReviewsInteractionSendOffer,
  businessInsightsV2RatingsReviewsInteractionHoverOffer,
  merchantAdminPurchasesView,
  merchantAdminPurchasesInteractionDownloadCsv,
  merchantAdminPurchasesInteractionGetReceipts,
  merchantAdminPurchasesInteractionSwitchToItems,
  merchantAdminPurchasesInteractionSwitchToOrders,
  merchantAdminPurchasesInteractionDownloadCsvConfirmed,
  merchantAdminPurchasesInteractionGetReceiptsConfirmed,
};

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["homepageView","businessInsightsView","menuEditorView","purchasesView","contactSupport","enterpriseAnalyticsDataLoadLookerDashboard","purchasesDataCsvDownload","purchasesErrorCsvDownload","allItemsInteractionClickExportMenu","allItemsInteractionClickStartMenuImport","allItemsInteractionClickImportMenu","allItemsInteractionClickImportItemImages","allItemsInteractionClickSelectImages","allItemsInteractionClickStartUploading","allItemsInteractionClickCreateItems","allItemsInteractionClickSubmitItemsCreation","allItemsInteractionClickUpdateItems","allItemsInteractionClickSubmitItemUpdating","allItemsInteractionClickDownloadItems","allItemsInteractionClickExportVersions","interactionClickEditCategory","interactionClickDeleteCategory","interactionClickImportItems","interactionClickExportItems","interactionClickEnableItems","interactionClickDisableItems","interactionClickCreateItemCopy","interactionClickCreateSpecial","interactionClickDisableItem","interactionClickEnableItem","interactionClickDeleteItem","interactionClickRemoveItemFromCategory","interactionClickSaveNewOption","interactionClickSaveItemChanges","interactionClickSaveNewItem","interactionClickAddNewCategory","interactionClickViewOnWolt","allItemsView","allOptionsView","allDisabledView","itemsNoCategoryView","categoriesView","interactionClickEnableOrDisable","interactionClickSetAvailability","interactionClickChangeStockAvailability","interactionClickChangePrice","interactionClickSetCourierRestrictions","interactionClickAddOptions","interactionClickChangeCategory","interactionClickChangeCommissions","interactionClickChangeVat","interactionClickCreateWoltSpecials","interactionClickDeleteItems","allItemsInteractionClickCreateSelectFile","allItemsInteractionClickUpdateSelectFile","interactionClickAddSubcategories","allItemsInteractionClickMenuImportSelectFile","interactionClickEditOption","interactionClickEditSubcategory","interactionClickDeleteSubcategory","businessInsightsInteractionClickChartSource","businessInsightsInteractionClickDatePicker","campaignsView","campaignsInteractionClickCampaignTable","campaignsInteractionClickNewCampaign","chooseCampaignInteractionClickCampaignSelection","newCampaignInteractionClickCampaignRules","updateCampaignDataEndCampaign","newCampaignRulesView","newCampaignInteractionClickCampaignRulesBasket","newCampaignRulesInteractionClickUserRules","updateCampaignDataUpdateCampaign","newCampaignDataCreateCampaign","updateCampaignInteractionClickCampaignUpdate","businessInsightsV2View","businessInsightsV2InteractionClickSwitchToOldInsights","enterpriseBrandUserManagementInteractionClickSendInvitation","interactionClickCreateSharedMenu","interactionClickShareMenuWithVenues","interactionClickStopSharingMenu","interactionClickEditSharedMenu","interactionClickSchedulePublishing","interactionClickPublishNow","interactionClickInstallMerchantAdmin","pwaAppInstalled","newCampaignView","chooseCampaignView","updateCampaignView","campaignDetailsView","updateCampaignInteractionClickCampaignRulesBasket","updateCampaignRulesInteractionClickUserRules","deliveryTypeModalView","deliveryTypeModalDataConfirm","restaurantDetailsView","restaurantDetailsInteractionClickSwitchDeliveryType","venueAvailabilityView","profileInteractionClickSubscriptionRow","allItemsInteractionClickAddItemsToCatalog","businessInsightsV2PerformanceView","businessInsightsV2OperationsView","businessInsightsV2CustomerBaseView","businessInsightsV2MenuView","sharedMenuInteractionClickFilterVenuesOption","sharedMenuInteractionClickVenueOrderby","historicalAvailabilityDataLoadLookerDashboard","historicalAvailabilityView","historicalAvailabilityDataLoadLookerDashboardError","googleSheetPageView","googleSheetPageInteractionClickExportToSheet","googleSheetPageInteractionClickSelectSheet","googleSheetPageInteractionClickUploadSheetData","googleSheetPageInteractionClickCancelSheetImport","businessInsightsV2RatingsReviewsView","businessInsightsV2RatingsReviewsInteractionClickFilterRatings","sharedMenuInteractionClickDuplicateMenu","venueGroupInteractionClickCreateVenueGroupFailed","sharedMenuInteractionClickDeleteMenu","sharedMenuInteractionClickRenameMenu","businessInsightsInteractionUpdateSidebarWidth","merchantAdminSearchView","merchantAdminUserSettingsView","merchantAdminUserSettingsInteractionSupport","merchantAdminUserSettingsInteractionLanguage","merchantAdminUserSettingsInteractionLogout","merchantAdminUserSettingsInteractionDarkMode","merchantAdminSearchDataResults","importExistingMenuFromVenueDataImportVenueId","merchantSelfServiceSignUpView","merchantSelfServiceSignUpDataFormSubmissionStatus","campaignsLimitWarningOverlay","campaignsLimitReachedOverlay","restaurantDetailsInteractionClickToggleDeliveryArea","restaurantDetailsDataSaveDeliveryAreas","restaurantDetailsImpressionDeliveryAreas","businessInsightsV2RatingsReviewsInteractionSendOffer","businessInsightsV2RatingsReviewsInteractionHoverOffer","merchantAdminPurchasesView","merchantAdminPurchasesInteractionDownloadCsv","merchantAdminPurchasesInteractionGetReceipts","merchantAdminPurchasesInteractionSwitchToItems","merchantAdminPurchasesInteractionSwitchToOrders","merchantAdminPurchasesInteractionDownloadCsvConfirmed","merchantAdminPurchasesInteractionGetReceiptsConfirmed"]
